"use strict";
export const PaymentOptionsMock = (mock) => {
  mock.onGet("/api/v7/payment/virtualdesktop/options/create_ip_region").reply((config) => {
    let response = {
      "timezones": [
        {
          "name": "Pacific/Guadalcanal",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_009c1ddd2b484e7ebae281acdf2144a0"
        },
        {
          "name": "Asia/Thimphu",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_0113c7e8599347aeb9b2d69652523efe"
        },
        {
          "name": "Asia/Aqtau",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_014bbc2ebec44373af0581837ed6dd40"
        },
        {
          "name": "America/Tijuana",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_02a970af32114da7b9acac7c02712a7f"
        },
        {
          "name": "Asia/Seoul",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_02c865e45e3f4760be918bdb2b757669"
        },
        {
          "name": "Atlantic/Azores",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_0458cd80a5334f60a96f62a5248d3b25"
        },
        {
          "name": "Asia/Beirut",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_0592b5f25eab4850b9209511f8ad66df"
        },
        {
          "name": "Antarctica/Vostok",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_05accd8833da43258894f0aee393eefd"
        },
        {
          "name": "America/Dawson_Creek",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_07f846031a7047f8a7e2962096691b01"
        },
        {
          "name": "Europe/Luxembourg",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_08542f1c2d394f4197001cb4582ed7ce"
        },
        {
          "name": "Asia/Tehran",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_087b8040c9634f51a097f9ca4fe302fb"
        },
        {
          "name": "Europe/Stockholm",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_08a79ae713144d1cbe0b7c482d9b147b"
        },
        {
          "name": "Asia/Jerusalem",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_09110a67e2754b78877475f77c7a3b28"
        },
        {
          "name": "Europe/Gibraltar",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_092c386aea354302a2ce99993abaaf33"
        },
        {
          "name": "Europe/Kaliningrad",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_0ad725a6e14c4e9faa2ce99b5f8e5822"
        },
        {
          "name": "Asia/Dushanbe",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_0af0c2c8542341dfb5ee1b7f49013436"
        },
        {
          "name": "America/Boa_Vista",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_0b26dbb3cc664405b8c79b64b6dfcebe"
        },
        {
          "name": "Asia/Bahrain",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_0c5ee26acc9e4935b02eec74616a1e7e"
        },
        {
          "name": "America/Godthab",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_0dc36e63d6ea478fbcf6e3c4995e5a61"
        },
        {
          "name": "America/Cayenne",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_0dfa18608e74423e889960699c4c3521"
        },
        {
          "name": "Asia/Colombo",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_0e3df9f06e384dbdb388f1d22602583b"
        },
        {
          "name": "Indian/Maldives",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_0e5609b26cb04d9baa757cc98d73f141"
        },
        {
          "name": "Asia/Bangkok",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_0f3421fb2ccd4b4c8e000b2efc8061e5"
        },
        {
          "name": "Atlantic/Faroe",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_0f9bec8498354be4ab4ab4c4dff4b0a3"
        },
        {
          "name": "Asia/Makassar",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_105da1409c594c25922028f073ba89db"
        },
        {
          "name": "Europe/Madrid",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_11fd6ce44fc74516910a1254d9d78963"
        },
        {
          "name": "Australia/Brisbane",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_1232eeb91adb464189c41ae939caba71"
        },
        {
          "name": "Europe/Brussels",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_12d6b077545543bf9b42182fd9481d39"
        },
        {
          "name": "America/Recife",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_13cd3024fe5a407d9d11080339ae2991"
        },
        {
          "name": "Asia/Brunei",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_1430b0d9e48c46ecb9199a5d4db284e9"
        },
        {
          "name": "Pacific/Fakaofo",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_16ba625e5e7d4585b3266d92582fd114"
        },
        {
          "name": "Asia/Almaty",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_173e8d87d64e4235a8c1969ed7d8c26f"
        },
        {
          "name": "Pacific/Easter",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_17ac44026c8d494a9cdd5fde86cc5911"
        },
        {
          "name": "America/Scoresbysund",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_1e9e0be839304860accccebc5d57224e"
        },
        {
          "name": "Etc/Greenwich",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_20bb790af38749cdafdf3aca2ba86597"
        },
        {
          "name": "Asia/Nicosia",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_20c3cb17d33940bca3392af837cd3406"
        },
        {
          "name": "Europe/Chisinau",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_21422a9348014d79a8f5eb592934cb1b"
        },
        {
          "name": "America/Bahia",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_231af76fd48d4517ba38b2c6ee301a81"
        },
        {
          "name": "America/Lima",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_236bc933b71349c88fd9a128fb81dd14"
        },
        {
          "name": "Asia/Baku",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_248929d3f6d047208077ef25088dbe1a"
        },
        {
          "name": "Asia/Ashgabat",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_2601d1db8024437fa77c804a2689b91e"
        },
        {
          "name": "Europe/Amsterdam",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_2688b867b93044449d8768748d3ebf6b"
        },
        {
          "name": "Indian/Reunion",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_279b5766de9a41f8bfa2f23cb5271c16"
        },
        {
          "name": "Europe/Tirane",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_281de30ba6144101b542cc52c51ec980"
        },
        {
          "name": "Africa/Accra",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_2997defc7d93400092b3a8a9b0c48276"
        },
        {
          "name": "Asia/Rangoon",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_2bff79c3164c4c6880eaf452f7d99175"
        },
        {
          "name": "America/Cuiaba",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_2d951bb9325d40608283340c91e95f4a"
        },
        {
          "name": "America/Puerto_Rico",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_2f4f412a01314b19a10d9d659ce53a63"
        },
        {
          "name": "Asia/Tbilisi",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_2ff3d679e4484980b124e461574ed0b3"
        },
        {
          "name": "Antarctica/Mawson",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_3038e04ab0584c68a43817ed516f8c1e"
        },
        {
          "name": "Europe/Minsk",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_332642bfa66e40e98d4da99a01b5e774"
        },
        {
          "name": "America/Martinique",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_39f4826f5d6741e796ccfebcf40454b2"
        },
        {
          "name": "America/Iqaluit",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_3c0af5b7f80f4cdd8a0a38f6ca4ce1f1"
        },
        {
          "name": "Africa/El_Aaiun",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_3c22b29ac6ea44cb99a2e462324970fb"
        },
        {
          "name": "America/Miquelon",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_3e58f34e8b794a4bb17108bc99b420a7"
        },
        {
          "name": "America/Belize",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_3ece9f24eead4fe0945fc43d7db03b92"
        },
        {
          "name": "Asia/Omsk",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_406bf4d767cb4153af5d578ad3ebedb5"
        },
        {
          "name": "Europe/Helsinki",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_40a9c9528ba340148c700570c4de1570"
        },
        {
          "name": "Africa/Tripoli",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_40fb7da2d90a48f086bffbbcd0cac2d0"
        },
        {
          "name": "Asia/Pyongyang",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_41151187e1724b50937e8eac3f5495ed"
        },
        {
          "name": "Pacific/Auckland",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_42077787f5a140fbae08114b039898b8"
        },
        {
          "name": "America/Nassau",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_42af038edb204e2db9d017a751958658"
        },
        {
          "name": "Pacific/Tongatapu",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_46bc9d1f02d14d768f4fe3e311888f38"
        },
        {
          "name": "America/Curacao",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_46d32e3fc03b4c03beadf6dbae728c8e"
        },
        {
          "name": "Asia/Ulaanbaatar",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_477287b9288b4561b5dc8cf9f617cfc5"
        },
        {
          "name": "America/Toronto",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_47b8bba76ecf48bcb0e12ae773078a1d"
        },
        {
          "name": "America/Port_of_Spain",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_48be827e141a4b7e814ae93a8d1ebb6e"
        },
        {
          "name": "Europe/Dublin",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_49a0d6d6b4b74365a21efed45e3a5b99"
        },
        {
          "name": "Antarctica/Casey",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_4a158734f72c4e4c8700817a641f60d1"
        },
        {
          "name": "America/Regina",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_4b22dacd53c34012af1d62f65d1a3268"
        },
        {
          "name": "America/Cayman",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_4b4268c5070845e3b4df0f3e5b6712eb"
        },
        {
          "name": "Europe/Andorra",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_4b4b18888cb34b78a889250da0de9b37"
        },
        {
          "name": "America/Campo_Grande",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_4b94e9178dd744699208f4d2546b21a3"
        },
        {
          "name": "Australia/Perth",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_4ce47ac9a0c94045ac0b36cf862c370e"
        },
        {
          "name": "America/Santiago",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_4d7ad3f040a942b89d78df604c24a055"
        },
        {
          "name": "Antarctica/Palmer",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_52373ae817c34c45aece093449ab8cfe"
        },
        {
          "name": "Europe/Bucharest",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_52cc1c04731a4d1d9b8477e161e5e6d7"
        },
        {
          "name": "Asia/Saigon",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_540b9be08a6f43b38e47c4c0b86680e0"
        },
        {
          "name": "America/Jamaica",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_54e51044ace64175a7d0f3ffde762ac8"
        },
        {
          "name": "America/Phoenix",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_55204bd21af44695baa79bac527e881f"
        },
        {
          "name": "Indian/Kerguelen",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_555a4acd5aa64c3b8b9e7ac6d8369a17"
        },
        {
          "name": "Pacific/Galapagos",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_55ea2f932fbf4be2bfc999c5563e6773"
        },
        {
          "name": "Europe/Samara",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_58445c7eac17466283994d66b0458141"
        },
        {
          "name": "Australia/Sydney",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_59127c59ef5c429cb8e9823b0d86c816"
        },
        {
          "name": "Asia/Damascus",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_59736a62ac4443b09aa097a0af43a8db"
        },
        {
          "name": "Asia/Qatar",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_59a049c932c3401d81c0cc04205a6b77"
        },
        {
          "name": "Africa/Maputo",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_5ba71a3918304c7aa6d8f5e9d6d4dd51"
        },
        {
          "name": "Atlantic/South_Georgia",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_5ba9f0c6b2e64c4893fa37ca4477b7fb"
        },
        {
          "name": "Europe/Athens",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_5c256b752b5b4d32b1cd89bda6bf14fe"
        },
        {
          "name": "Pacific/Apia",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_5c9a7ccc72d74a9c9d1b2deb0ef934d7"
        },
        {
          "name": "Pacific/Kwajalein",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_5d1f8e61f2c447c3a5be417ce310179a"
        },
        {
          "name": "Atlantic/Stanley",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_5d520d40a7f54a519516328d47cc2a70"
        },
        {
          "name": "Europe/Kiev",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_5e2a701ce0ce46458edfd3f6366c5ca0"
        },
        {
          "name": "Europe/Zurich",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_5e62ec18a2504606b8c2faf2e88e422a"
        },
        {
          "name": "Pacific/Tahiti",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_5f976447899644c9adccdffac6d661fe"
        },
        {
          "name": "Africa/Ceuta",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_60ae23a242ad4d9e9680efcf000cdf74"
        },
        {
          "name": "America/Los_Angeles",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5"
        },
        {
          "name": "Europe/Riga",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_6233761ff1594bdcbce4824b9f8e7ee0"
        },
        {
          "name": "Africa/Abidjan",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_626ae254b44f467397b897d3e15a0cf8"
        },
        {
          "name": "Pacific/Rarotonga",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_65d3fd248d654731a22d2520264a1c77"
        },
        {
          "name": "America/Anchorage",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_672e4cfed2dd4c01bafd5cc3c30d7676"
        },
        {
          "name": "America/Vancouver",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_67cf0b2690414ea680d0f425f6132dc0"
        },
        {
          "name": "Pacific/Kiritimati",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_67eba5e66eaa42089f7b6640df4a6500"
        },
        {
          "name": "Pacific/Noumea",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_683b7b321c4242058069a7dfc5da990c"
        },
        {
          "name": "America/Grand_Turk",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_6968138f4c5946bb8144763dacab1dd6"
        },
        {
          "name": "Australia/Hobart",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_6cf5dbc484574403bade3591e4ef6d7e"
        },
        {
          "name": "Africa/Monrovia",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_6d7eface72b5467bb0a1b27f0314db35"
        },
        {
          "name": "Indian/Christmas",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_6dc695f568a0417190b31fc48cee7297"
        },
        {
          "name": "America/Cancun",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_6f213ad00b5c4a66a22d062ed535c17c"
        },
        {
          "name": "Asia/Jayapura",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_6fdc8c2bc44a489ea934ea60035ba1e9"
        },
        {
          "name": "Antarctica/Syowa",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_7030697099244a32a8b57df8fb0e452c"
        },
        {
          "name": "Europe/Oslo",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_70b2d2d77e9e4968b56ff576c64a4f32"
        },
        {
          "name": "Europe/Vilnius",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_7176377a43ac4e4f849404b574bdbcb8"
        },
        {
          "name": "America/Araguaina",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_72a10cb18ec44bf89faa1ee8490271cb"
        },
        {
          "name": "America/Costa_Rica",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_74187aa2e7764f0787726d9d2dbae4be"
        },
        {
          "name": "Asia/Aqtobe",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_76b9afee60c84ac18cb389de3d151c35"
        },
        {
          "name": "America/Panama",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_77d6a65389da46dbac2eb5b79c620654"
        },
        {
          "name": "Africa/Algiers",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_78dcec2cffee46cebc26db114b78c4bb"
        },
        {
          "name": "Asia/Tashkent",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_78e2556e1b1a4fa0b413e394c145a76f"
        },
        {
          "name": "Pacific/Funafuti",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_7983eafdcec04ec49459088c5e11eb77"
        },
        {
          "name": "America/Guayaquil",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_79d1d39fc1814c939807c7ac65db09b4"
        },
        {
          "name": "Asia/Kuala_Lumpur",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_7a473af2a04f499da8edf0cb73412c2f"
        },
        {
          "name": "Asia/Dhaka",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_7c4e799696db475e9709fc9e90ff51e8"
        },
        {
          "name": "Africa/Nairobi",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_7d26a5de39474838b3225c2000fec41f"
        },
        {
          "name": "Pacific/Chuuk",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_7ef227dd9fca4a21b08fa0433934cded"
        },
        {
          "name": "Pacific/Pago_Pago",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_7f4a6c8ef00541858b62a95694e162c7"
        },
        {
          "name": "Asia/Taipei",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_7ff89815cce74fa4aacc7948f8f50c78"
        },
        {
          "name": "America/St_Johns",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_804727aeee10496694fef3f074daaf2c"
        },
        {
          "name": "Asia/Choibalsan",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_83171f0291094c608a3b13e6fea7adae"
        },
        {
          "name": "Africa/Casablanca",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_831d05d0db7e401bb5703e97ab88afc1"
        },
        {
          "name": "Africa/Khartoum",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_8355a88312c041439385c3b215f7ff31"
        },
        {
          "name": "Asia/Bishkek",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_864b36b28340472ba84edb08852b8810"
        },
        {
          "name": "Asia/Yekaterinburg",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_875b2ddc9b0d4dbeb0acbef3767ce4c4"
        },
        {
          "name": "Atlantic/Canary",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_893d0c7326d74f6893e81b895f08e38e"
        },
        {
          "name": "Pacific/Nauru",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_8950bf4754214d21bea4ba5a2815bb9b"
        },
        {
          "name": "Antarctica/Davis",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_8958064d6c59401b821e87b0fd1b4a19"
        },
        {
          "name": "Atlantic/Reykjavik",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_89859718ae3e480398ce0316abf94a69"
        },
        {
          "name": "America/Managua",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_8a018196b87a43e2a9dd56784de34221"
        },
        {
          "name": "America/Montevideo",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_8aa2cd6254c44dba86dbe332eeaa9d33"
        },
        {
          "name": "Europe/Malta",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_8ed3a4480dc44a51ba22a4958b02c129"
        },
        {
          "name": "America/Noronha",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_9013e288162c498c8f28830860fb237c"
        },
        {
          "name": "Asia/Kolkata",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_90ceb47c16b142f6b5651ac495e483c8"
        },
        {
          "name": "Africa/Bissau",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_9188655132ee49148ac00252f8d0f27b"
        },
        {
          "name": "America/Winnipeg",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_9383c55bd07a45d39abbd1f0e9466211"
        },
        {
          "name": "Atlantic/Bermuda",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_957e5a1f651b456cb2c2673aec237a46"
        },
        {
          "name": "America/Maceio",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_9628fc8476354652b8884d96ef037750"
        },
        {
          "name": "Asia/Gaza",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_962d1dcf59224a0bb2247d3acbb41a49"
        },
        {
          "name": "Pacific/Niue",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_969685518f5847fa846d3827ff401712"
        },
        {
          "name": "America/Mazatlan",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_97095b4d18bb4a88a92162cf07b7db78"
        },
        {
          "name": "Australia/Adelaide",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_9767399361ad40fbaef8a925eb0b2262"
        },
        {
          "name": "Pacific/Wake",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_9798b4ed8bdb4889865f61b94f0d271c"
        },
        {
          "name": "Pacific/Majuro",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_98302ce22acc49ea83a73707d5c2c415"
        },
        {
          "name": "Pacific/Fiji",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_993b5153d50448f9bafcb0606335caf5"
        },
        {
          "name": "Europe/Prague",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_99badaa5ab4c4e41b34e809600b632d9"
        },
        {
          "name": "America/La_Paz",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_9ac0b60f41aa4c53ba8fe026be6de3e8"
        },
        {
          "name": "Asia/Amman",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_9c79fed742fe4061a6bbc5f818196d26"
        },
        {
          "name": "America/Guatemala",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_9eca2236953342b7a9e8c81c7f36a66c"
        },
        {
          "name": "America/El_Salvador",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_a0a31e078a60418c9ab4052959965976"
        },
        {
          "name": "America/Rio_Branco",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_a4b65fe898c54fe783ffd80408510283"
        },
        {
          "name": "Africa/Lagos",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_a5984eef1a3d4f049b582966c3decc90"
        },
        {
          "name": "Asia/Yakutsk",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_a760411f06624d808f92af051007769b"
        },
        {
          "name": "Asia/Dubai",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_a7ac8957b9a84e77a12bd29143749601"
        },
        {
          "name": "Asia/Krasnoyarsk",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_a7e78a2f7d94413191147a73d5aac743"
        },
        {
          "name": "Pacific/Gambier",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_a905ae37628946be835214f43aee1d55"
        },
        {
          "name": "Asia/Yerevan",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_a98acdfdc8064253ac0b0bcd16531e7b"
        },
        {
          "name": "Pacific/Wallis",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_aaa6c01c22b04e2d94c9d5464a86a33c"
        },
        {
          "name": "America/Tegucigalpa",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_aac56917651c4679b2a12cdc2261af63"
        },
        {
          "name": "Indian/Mahe",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_ab6d7975353942c19a95b55b30bed387"
        },
        {
          "name": "Africa/Ndjamena",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_abab80f43ca1421f90d645646d803c72"
        },
        {
          "name": "Africa/Windhoek",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_ad0ee1ffe19e4062a821c37584b46dd0"
        },
        {
          "name": "Europe/Warsaw",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_ae7a33ab1517499089938533ef57cfbc"
        },
        {
          "name": "Asia/Shanghai",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23"
        },
        {
          "name": "Asia/Karachi",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_b1d2d09a47c44e74b3348244bc0afa78"
        },
        {
          "name": "America/Whitehorse",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_b2c194cbfbff45ec9aa418e41d94d6b6"
        },
        {
          "name": "America/Hermosillo",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_b32f4d8ac7004265a49048c61986da99"
        },
        {
          "name": "Antarctica/DumontDUrville",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_b335424a122940aa8d4ee72e604828b4"
        },
        {
          "name": "Europe/Sofia",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_b4a65849d87d442fa25e64224fcaf14b"
        },
        {
          "name": "America/Fortaleza",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_b509268e21564f0ab2cabcdc36719753"
        },
        {
          "name": "America/Paramaribo",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_b553abd98ad54a8c945018ef4a6afadc"
        },
        {
          "name": "America/Mexico_City",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_b5b46f98b0464135b4787eb90362d0be"
        },
        {
          "name": "Pacific/Norfolk",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_b5e4d19a38a84b05a03a0fdb2ef81405"
        },
        {
          "name": "Pacific/Marquesas",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_b88edb98048e4da191ecb4a408ddf853"
        },
        {
          "name": "Pacific/Pohnpei",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_ba2750aebe424d3c9801f52601390913"
        },
        {
          "name": "America/Halifax",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_bbbbf3e215ce4585980255111222602c"
        },
        {
          "name": "Asia/Hong_Kong",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_bcbbac304d9f4336bb56b3a6e030b3f2"
        },
        {
          "name": "Pacific/Pitcairn",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_bf1a96708b3d4bcdbfa6f15e796773ed"
        },
        {
          "name": "Europe/Paris",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_c083f23050f744f1a98bbc68f9817674"
        },
        {
          "name": "America/Asuncion",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_c25a1b2a30784b32a42d1d3090b041fe"
        },
        {
          "name": "Asia/Ho_Chi_Minh",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_c2e0233c241a477bb2d50e1add0e204e"
        },
        {
          "name": "Asia/Riyadh",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_c6cd0b733108459a85c27db7c96ebc6f"
        },
        {
          "name": "Asia/Magadan",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_c7cbb2c7cdcf43a08e4e0fcfdb0ee72d"
        },
        {
          "name": "Pacific/Palau",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_c7d09bd2960c462eb92d1a44a39be470"
        },
        {
          "name": "America/Chicago",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_c7f027f86ddf48099ebbaf7a1c767af6"
        },
        {
          "name": "Asia/Jakarta",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_c7f631ac50c547d18aa94318270cd029"
        },
        {
          "name": "America/Havana",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_c87a5779b3ca40c5bd5559e66318d35e"
        },
        {
          "name": "Pacific/Kosrae",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_c926d3b98be34ade8ca945061c29c864"
        },
        {
          "name": "Europe/Budapest",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_c96e9a735cd84632b643843bd560b567"
        },
        {
          "name": "Africa/Johannesburg",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_c9ed944b513044b9b37568cbcae47b27"
        },
        {
          "name": "Asia/Kamchatka",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_ca24f24b90a14bd89df9ca30f870145a"
        },
        {
          "name": "Europe/Rome",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_cc0a386307f04adaa6151ced926504c5"
        },
        {
          "name": "Asia/Kabul",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_cc5e496101614559a790c6dfcd0692d5"
        },
        {
          "name": "America/Barbados",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_cc858634a73b44acba7846930328d681"
        },
        {
          "name": "Indian/Cocos",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_cd7820a758ae44079c5a65948f167e53"
        },
        {
          "name": "America/Edmonton",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_ce1fceb7090c4b9ca2877c9cef2a2bca"
        },
        {
          "name": "Europe/Moscow",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_d136a079d03543069b8e64f8d32d5606"
        },
        {
          "name": "Indian/Chagos",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_d533a1ffdae54c83a321013406dda9d7"
        },
        {
          "name": "Europe/Berlin",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_d83bd507733a4ae88b7a2d51f7032e74"
        },
        {
          "name": "Asia/Manila",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_d8a28f397ea64f7483b52720d54d283a"
        },
        {
          "name": "Asia/Katmandu",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_dca0479d14164ba1a7e95ff1823ee420"
        },
        {
          "name": "America/Danmarkshavn",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_dcbb782bb16342b6a567695055f33356"
        },
        {
          "name": "Atlantic/Cape_Verde",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_dd236b6b52ec41ba8167b2302623f0e2"
        },
        {
          "name": "Europe/Vienna",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_dd5d4f2214b347f3a6b59fc0e7399cb7"
        },
        {
          "name": "Europe/Belgrade",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_df3a25663d5e4c7dabb2e13e9a1bfd8c"
        },
        {
          "name": "Indian/Mauritius",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_e051ec0cccfe42cc929eaf42b4df68a8"
        },
        {
          "name": "Pacific/Efate",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_e15b415a3ba04221b90f0bad5672c4b0"
        },
        {
          "name": "Asia/Hovd",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_e230648590c5490eb01624f21194e128"
        },
        {
          "name": "America/Thule",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_e26cf5782c574defbadb6ff1e22d992c"
        },
        {
          "name": "Asia/Vladivostok",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_e29ef3b74ba149a4aac5eaf38dbd4f4a"
        },
        {
          "name": "Pacific/Tarawa",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_e2ebfab370b64421ba3fd139ce74dedc"
        },
        {
          "name": "America/Porto_Velho",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_e57d23d7b90f412e83833dd115401b0b"
        },
        {
          "name": "Europe/London",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_e5e654f51e14404e8e4e7862c9c3516e"
        },
        {
          "name": "Asia/Irkutsk",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_e61098e2683448eca50980ec1feee220"
        },
        {
          "name": "Pacific/Guam",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_e6adc241a10a4c8797e9da2622941260"
        },
        {
          "name": "Asia/Singapore",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_e703e6c1137f460cac012d870d657203"
        },
        {
          "name": "Asia/Dili",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_e710c5e6023c49848fecf6a1cc3e663f"
        },
        {
          "name": "America/Yellowknife",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_e76682ac08a44ceeb8a218b6b46a98df"
        },
        {
          "name": "America/Caracas",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_e786e927d7c84ba1b99486f632052b6f"
        },
        {
          "name": "America/Manaus",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_e7999cdafb6c46b5882a7f5979582a8d"
        },
        {
          "name": "Africa/Tunis",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_e7edb0d2ed08412090d8cfcaedaf13d9"
        },
        {
          "name": "America/Sao_Paulo",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_e912e52e79224f55aac6a1e7bca25c8a"
        },
        {
          "name": "Asia/Macau",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_ea45e975a8804bdb889bca3a9c779a9a"
        },
        {
          "name": "Europe/Istanbul",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_eb7930b6628f45938b12cfa82d0d758f"
        },
        {
          "name": "Asia/Tokyo",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_ee7cb2c5d2b046d6a6fd5a46db682e16"
        },
        {
          "name": "America/Belem",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_eed663dccc414b34be20b748ef1929aa"
        },
        {
          "name": "Europe/Copenhagen",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_efe6db9285134400b8c0543c77a08388"
        },
        {
          "name": "Europe/Monaco",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_f0492a0114a0426d9f75a15508201cd9"
        },
        {
          "name": "Europe/Tallinn",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_f10a316c719842caa0443de257e51832"
        },
        {
          "name": "Africa/Cairo",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_f13840b8b0a241a696605f1ca25c60b6"
        },
        {
          "name": "Pacific/Enderbury",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_f2719c71fb1645a09e9e1539794b3afe"
        },
        {
          "name": "Europe/Lisbon",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_f28ef0f338464fe99a292274da71a937"
        },
        {
          "name": "America/New_York",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_f4272cafe1d6451ea560458c9f11b640"
        },
        {
          "name": "America/Argentina/Buenos_Aires",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_f4792c73483d40adb03aca9567da31be"
        },
        {
          "name": "Pacific/Port_Moresby",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_f51bd138530c4f27ac28199ac9c347f1"
        },
        {
          "name": "America/Guyana",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_f77f750f3096414fbf7618b15c97569a"
        },
        {
          "name": "Australia/Darwin",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_f82fdfcc535f4bd5bb4b524bac7de1ad"
        },
        {
          "name": "Asia/Baghdad",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_f89654150331459fa501c18789cc4656"
        },
        {
          "name": "Antarctica/Rothera",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_f8b18add49414b0db2eefc1b40bb3d39"
        },
        {
          "name": "America/Port-au-Prince",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_f8efe0023f8c42409a32d5e387f5460e"
        },
        {
          "name": "Pacific/Honolulu",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_fa0eaa98db224ebcb0a56a6e2b947ea3"
        },
        {
          "name": "America/Bogota",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_faf55c945b2f4c0e97aa13d9408e72c3"
        },
        {
          "name": "America/Santo_Domingo",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_fe0e1e62347d4b6e95dc39d801b6bbcd"
        },
        {
          "name": "America/Denver",
          "model": "payment.virtualdesktop.options.create.timezone",
          "id": "region_timezone_ffdb1d6d629a497fa3097351917d8e62"
        }
      ],
      "regions": [
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "RECOMMEND",
              "DEFAULT_SELECTED"
            ]
          },
          "risk_level": 2,
          "sortValue": -100,
          "name": "\u963F\u91CC",
          "parent_category": {
            "name": "\u63A8\u8350",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_cb072c45712b4947b2d4a20212c62e51_recommend",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u63A8\u8350",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cb072c45712b4947b2d4a20212c62e51_recommand",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u7EBF\u8DEF\u7ECF\u4F18\u5316\uFF0C\u63A8\u8350\u4F7F\u7528\uFF1B\u8FD1\u671F\u4E9A\u9A6C\u900A\u3001eBay\u6CE8\u518C\u653F\u7B56\u6536\u7D27\uFF0C\u5EFA\u8BAE\u4F7F\u7528\u4F4F\u5B85IP\u8FDB\u884C\u6CE8\u518C\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9",
          "id": "region_8f5fcd998b874d47b790dc2d9f39d3b1",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA669\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA669\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA665\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA662\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+\u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 20,
          "name": "\u963F\u91CC",
          "parent_category": {
            "name": "\u4E0A\u6D77",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_59df69c3538c421b9224abc4e200a712",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u63A8\u8350",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cb072c45712b4947b2d4a20212c62e51_recommand",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u7EBF\u8DEF\u7ECF\u4F18\u5316\uFF0C\u63A8\u8350\u4F7F\u7528\uFF1B\u8FD1\u671F\u4E9A\u9A6C\u900A\u3001eBay\u6CE8\u518C\u653F\u7B56\u6536\u7D27\uFF0C\u5EFA\u8BAE\u4F7F\u7528\u4F4F\u5B85IP\u8FDB\u884C\u6CE8\u518C\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9",
          "id": "region_6a22b00ddec146c99b410723e4d2e9e8",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA669\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA669\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA665\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA662\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+\u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "RECOMMEND",
              "DEFAULT_SELECTED"
            ]
          },
          "risk_level": 2,
          "sortValue": -100,
          "name": "\u963F\u91CC",
          "parent_category": {
            "name": "\u63A8\u8350",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_cb072c45712b4947b2d4a20212c62e51_recommend",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E2D\u56FD\u5927\u9646",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cb072c45712b4947b2d4a20212c62e51",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u7EBF\u8DEF\u7ECF\u4F18\u5316\uFF0C\u63A8\u8350\u4F7F\u7528\uFF1B\u8FD1\u671F\u4E9A\u9A6C\u900A\u3001eBay\u6CE8\u518C\u653F\u7B56\u6536\u7D27\uFF0C\u5EFA\u8BAE\u4F7F\u7528\u4F4F\u5B85IP\u8FDB\u884C\u6CE8\u518C\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9",
          "id": "region_8f5fcd998b874d47b790dc2d9f39d3b1",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA669\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA669\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA665\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA662\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+\u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 20,
          "name": "\u963F\u91CC",
          "parent_category": {
            "name": "\u4E0A\u6D77",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_59df69c3538c421b9224abc4e200a712",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E2D\u56FD\u5927\u9646",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cb072c45712b4947b2d4a20212c62e51",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u7EBF\u8DEF\u7ECF\u4F18\u5316\uFF0C\u63A8\u8350\u4F7F\u7528\uFF1B\u8FD1\u671F\u4E9A\u9A6C\u900A\u3001eBay\u6CE8\u518C\u653F\u7B56\u6536\u7D27\uFF0C\u5EFA\u8BAE\u4F7F\u7528\u4F4F\u5B85IP\u8FDB\u884C\u6CE8\u518C\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9",
          "id": "region_6a22b00ddec146c99b410723e4d2e9e8",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA669\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA669\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA665\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA662\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+\u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": []
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 21,
          "name": "\u817E\u8BAF",
          "parent_category": {
            "name": "\u4E0A\u6D77",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_59df69c3538c421b9224abc4e200a712",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E2D\u56FD\u5927\u9646",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cb072c45712b4947b2d4a20212c62e51",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u8FD1\u671F\u4E9A\u9A6C\u900A\u3001eBay\u6CE8\u518C\u653F\u7B56\u6536\u7D27\uFF0C\u5EFA\u8BAE\u4F7F\u7528\u4F4F\u5B85IP\u8FDB\u884C\u6CE8\u518C\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9",
          "id": "region_e6ac6b03a6b64af196474f44b0b487fa",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA687\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA685\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 30,
          "name": "\u963F\u91CC",
          "parent_category": {
            "name": "\u6DF1\u5733",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_40bd6b114ad84a708d8f1a8e186f5345",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E2D\u56FD\u5927\u9646",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cb072c45712b4947b2d4a20212c62e51",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u7EBF\u8DEF\u7ECF\u4F18\u5316\uFF0C\u63A8\u8350\u4F7F\u7528\uFF1B\u8FD1\u671F\u4E9A\u9A6C\u900A\u3001eBay\u6CE8\u518C\u653F\u7B56\u6536\u7D27\uFF0C\u5EFA\u8BAE\u4F7F\u7528\u4F4F\u5B85IP\u8FDB\u884C\u6CE8\u518C\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9",
          "id": "region_7bbb9313c6f445d5a8ecf18f3c38e9a2",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA669\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA669\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA665\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA662\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+\u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 40,
          "name": "\u963F\u91CC",
          "parent_category": {
            "name": "\u676D\u5DDE",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_1c22a07a52144791bd37efe2417029f3",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E2D\u56FD\u5927\u9646",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cb072c45712b4947b2d4a20212c62e51",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u7EBF\u8DEF\u7ECF\u4F18\u5316\uFF0C\u63A8\u8350\u4F7F\u7528\uFF1B\u8FD1\u671F\u4E9A\u9A6C\u900A\u3001eBay\u6CE8\u518C\u653F\u7B56\u6536\u7D27\uFF0C\u5EFA\u8BAE\u4F7F\u7528\u4F4F\u5B85IP\u8FDB\u884C\u6CE8\u518C\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9",
          "id": "region_2050be94a672443a817f8219f78cadfc",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA669\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA669\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA665\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA662\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+\u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 49,
          "name": "\u963F\u91CC",
          "parent_category": {
            "name": "\u5E7F\u4E1C-\u6CB3\u6E90",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_ec271ab847f2484c8d8e660ff0043d96",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E2D\u56FD\u5927\u9646",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cb072c45712b4947b2d4a20212c62e51",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u7EBF\u8DEF\u7ECF\u4F18\u5316\uFF0C\u63A8\u8350\u4F7F\u7528\uFF1B\u8FD1\u671F\u4E9A\u9A6C\u900A\u3001eBay\u6CE8\u518C\u653F\u7B56\u6536\u7D27\uFF0C\u5EFA\u8BAE\u4F7F\u7528\u4F4F\u5B85IP\u8FDB\u884C\u6CE8\u518C\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9\u3002",
          "id": "region_2b443d35ac074133a25723eb4107b7a4",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA669\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA669\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA665\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA662\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+\u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 60,
          "name": "\u963F\u91CC",
          "parent_category": {
            "name": "\u6210\u90FD",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_6b829e3321a3433a9259dba3afdbe6b6",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E2D\u56FD\u5927\u9646",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cb072c45712b4947b2d4a20212c62e51",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u7EBF\u8DEF\u7ECF\u4F18\u5316\uFF0C\u63A8\u8350\u4F7F\u7528\uFF1B\u8FD1\u671F\u4E9A\u9A6C\u900A\u3001eBay\u6CE8\u518C\u653F\u7B56\u6536\u7D27\uFF0C\u5EFA\u8BAE\u4F7F\u7528\u4F4F\u5B85IP\u8FDB\u884C\u6CE8\u518C\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9",
          "id": "region_c41e0a636c07428086cadf795cb95eb1",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA669\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA669\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA665\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA662\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+\u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 69,
          "name": "\u817E\u8BAF",
          "parent_category": {
            "name": "\u91CD\u5E86",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_ef5f8b3edeca433b89440654cf866c86",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E2D\u56FD\u5927\u9646",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cb072c45712b4947b2d4a20212c62e51",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_92aa5d7cc6314425961add850f7fb65b",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA687\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA684\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "RECOMMEND",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 2,
          "sortValue": 80,
          "name": "\u963F\u91CC",
          "parent_category": {
            "name": "\u5F20\u5BB6\u53E3",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_0afa14d51f754f529c88eb509fded8b5",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E2D\u56FD\u5927\u9646",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cb072c45712b4947b2d4a20212c62e51",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u7EBF\u8DEF\u7ECF\u4F18\u5316\uFF0C\u63A8\u8350\u4F7F\u7528\uFF1B\u8FD1\u671F\u4E9A\u9A6C\u900A\u3001eBay\u6CE8\u518C\u653F\u7B56\u6536\u7D27\uFF0C\u5EFA\u8BAE\u4F7F\u7528\u4F4F\u5B85IP\u8FDB\u884C\u6CE8\u518C\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9",
          "id": "region_8f5fcd998b874d47b790dc2d9f39d3b1",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA669\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA669\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA665\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA662\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+\u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 99,
          "name": "\u963F\u91CC",
          "parent_category": {
            "name": "\u9752\u5C9B",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_bba30a927b694d4c91f85533abbf486e",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E2D\u56FD\u5927\u9646",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cb072c45712b4947b2d4a20212c62e51",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u7EBF\u8DEF\u7ECF\u4F18\u5316\uFF0C\u63A8\u8350\u4F7F\u7528\uFF1B\u8FD1\u671F\u4E9A\u9A6C\u900A\u3001eBay\u6CE8\u518C\u653F\u7B56\u6536\u7D27\uFF0C\u5EFA\u8BAE\u4F7F\u7528\u4F4F\u5B85IP\u8FDB\u884C\u6CE8\u518C\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9\u3002",
          "id": "region_740e822d8fdd48e6bd3241e45d81e102",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA669\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA669\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA665\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA662\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+\u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 119,
          "name": "\u963F\u91CC",
          "parent_category": {
            "name": "\u547C\u548C\u6D69\u7279",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_857eb21d13ac44afa9f2c3914ffca7c8",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E2D\u56FD\u5927\u9646",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cb072c45712b4947b2d4a20212c62e51",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u7EBF\u8DEF\u7ECF\u4F18\u5316\uFF0C\u63A8\u8350\u4F7F\u7528\uFF1B\u8FD1\u671F\u4E9A\u9A6C\u900A\u3001eBay\u6CE8\u518C\u653F\u7B56\u6536\u7D27\uFF0C\u5EFA\u8BAE\u4F7F\u7528\u4F4F\u5B85IP\u8FDB\u884C\u6CE8\u518C\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9\u3002",
          "id": "region_0136c4260e6547829bf9aec5ec1d9fa8",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA669\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA669\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA665\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA662\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+\u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 139,
          "name": "\u817E\u8BAF",
          "parent_category": {
            "name": "\u5357\u4EAC",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_80875d5c23664bddbe4030597a62103c",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E2D\u56FD\u5927\u9646",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cb072c45712b4947b2d4a20212c62e51",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u8FD1\u671F\u4E9A\u9A6C\u900A\u3001eBay\u6CE8\u518C\u653F\u7B56\u6536\u7D27\uFF0C\u5EFA\u8BAE\u4F7F\u7528\u4F4F\u5B85IP\u8FDB\u884C\u6CE8\u518C\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9",
          "id": "region_e11ade51dd2f465b94d9b1a02fb52ce6",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA687\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA685\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 165,
          "name": "\u767E\u5EA6",
          "parent_category": {
            "name": "\u5E7F\u5DDE",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_3b700bbae72b4244a93fb19fd43cb306",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E2D\u56FD\u5927\u9646",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cb072c45712b4947b2d4a20212c62e51",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u8FD1\u671F\u4E9A\u9A6C\u900A\u3001eBay\u6CE8\u518C\u653F\u7B56\u6536\u7D27\uFF0C\u5EFA\u8BAE\u4F7F\u7528\u4F4F\u5B85IP\u8FDB\u884C\u6CE8\u518C\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9",
          "id": "region_41728225acae45a08c03ce8aca0a12d3",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA679\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "7.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA677\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "7.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA675\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "7.1",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA671\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+\u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": []
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 166,
          "name": "\u817E\u8BAF",
          "parent_category": {
            "name": "\u5E7F\u5DDE",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_3b700bbae72b4244a93fb19fd43cb306",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E2D\u56FD\u5927\u9646",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cb072c45712b4947b2d4a20212c62e51",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u8FD1\u671F\u4E9A\u9A6C\u900A\u3001eBay\u6CE8\u518C\u653F\u7B56\u6536\u7D27\uFF0C\u5EFA\u8BAE\u4F7F\u7528\u4F4F\u5B85IP\u8FDB\u884C\u6CE8\u518C\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9",
          "id": "region_d65519035c9d4487b30824261c19a450",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA687\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA685\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 179,
          "name": "\u767E\u5EA6",
          "parent_category": {
            "name": "\u82CF\u5DDE",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_8ffa5d15b7234baa8328311b8ca8b804",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E2D\u56FD\u5927\u9646",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cb072c45712b4947b2d4a20212c62e51",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u8FD1\u671F\u4E9A\u9A6C\u900A\u3001eBay\u6CE8\u518C\u653F\u7B56\u6536\u7D27\uFF0C\u5EFA\u8BAE\u4F7F\u7528\u4F4F\u5B85IP\u8FDB\u884C\u6CE8\u518C\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9",
          "id": "region_e4305ecd4b7d4e4f883d480cea7c572d",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA679\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "7.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA677\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "7.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA675\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "7.1",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA671\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+\u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 180,
          "name": "\u963F\u91CC",
          "parent_category": {
            "name": "\u5317\u4EAC",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_53a7eb3e40f948fab77bfb7294a4e167",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E2D\u56FD\u5927\u9646",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cb072c45712b4947b2d4a20212c62e51",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u7EBF\u8DEF\u7ECF\u4F18\u5316\uFF0C\u63A8\u8350\u4F7F\u7528\uFF1B\u8FD1\u671F\u4E9A\u9A6C\u900A\u3001eBay\u6CE8\u518C\u653F\u7B56\u6536\u7D27\uFF0C\u5EFA\u8BAE\u4F7F\u7528\u4F4F\u5B85IP\u8FDB\u884C\u6CE8\u518C\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9",
          "id": "region_e22ae40be25b41a18c990f41c40ec313",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA669\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA669\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA665\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA662\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+\u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 204,
          "name": "\u767E\u5EA6",
          "parent_category": {
            "name": "\u6B66\u6C49",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_837e4dd01a074c1e8dac724a193e27ed",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E2D\u56FD\u5927\u9646",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cb072c45712b4947b2d4a20212c62e51",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u7EBF\u8DEF\u7ECF\u4F18\u5316\uFF0C\u63A8\u8350\u4F7F\u7528\uFF1B\u8FD1\u671F\u4E9A\u9A6C\u900A\u3001eBay\u6CE8\u518C\u653F\u7B56\u6536\u7D27\uFF0C\u5EFA\u8BAE\u4F7F\u7528\u4F4F\u5B85IP\u8FDB\u884C\u6CE8\u518C\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9",
          "id": "region_4f43ac735f9645cd84c824a28a703205",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "7.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA687\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "7.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA684\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "7.1",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 224,
          "name": "\u767E\u5EA6",
          "parent_category": {
            "name": "\u4FDD\u5B9A",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_008323c25b73406286e4c4f297252cc3",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E2D\u56FD\u5927\u9646",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cb072c45712b4947b2d4a20212c62e51",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u7EBF\u8DEF\u7ECF\u4F18\u5316\uFF0C\u63A8\u8350\u4F7F\u7528\uFF1B\u8FD1\u671F\u4E9A\u9A6C\u900A\u3001eBay\u6CE8\u518C\u653F\u7B56\u6536\u7D27\uFF0C\u5EFA\u8BAE\u4F7F\u7528\u4F4F\u5B85IP\u8FDB\u884C\u6CE8\u518C\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9",
          "id": "region_2dacfdac5abc4d0fbd566d135125d026",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "7.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA687\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "7.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA685\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "7.1",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+\u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 245,
          "name": "BGP",
          "parent_category": {
            "name": "\u6D1B\u9633",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_949dd37a8ed349a7948fb96db9ca7beb",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E2D\u56FD\u5927\u9646",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cb072c45712b4947b2d4a20212c62e51",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u7EBF\u8DEF\u7ECF\u4F18\u5316\uFF0C\u63A8\u8350\u4F7F\u7528\uFF1B\u8FD1\u671F\u4E9A\u9A6C\u900A\u3001eBay\u6CE8\u518C\u653F\u7B56\u6536\u7D27\uFF0C\u5EFA\u8BAE\u4F7F\u7528\u4F4F\u5B85IP\u8FDB\u884C\u6CE8\u518C\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9",
          "id": "region_65497630da4647b89a3be18216009522",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA684\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": false,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": false,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": false,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": false,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": false,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": false,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": false,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": false,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": false,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": false,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_bcbbac304d9f4336bb56b3a6e030b3f2",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_99b359aca2984f0ba8e91824da37daf6",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "RECOMMEND",
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "risk_level": 1,
          "sortValue": 900,
          "name": "\u963F\u91CC",
          "parent_category": {
            "name": "\u63A8\u8350",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_ec0f62c75b8441229fd5b480b4434d8a_recommend",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6E2F\u6FB3\u53F0",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_ec0f62c75b8441229fd5b480b4434d8a",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_673c81cf8e7d49689ba5480b46715502",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA679\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA679\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA675\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA671\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+\u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_bcbbac304d9f4336bb56b3a6e030b3f2",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_99b359aca2984f0ba8e91824da37daf6",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "RECOMMEND",
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 1020,
          "name": "\u963F\u91CC",
          "parent_category": {
            "name": "\u9999\u6E2F",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_d84d43a94a684851a5c8d56a79c18896",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6E2F\u6FB3\u53F0",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_ec0f62c75b8441229fd5b480b4434d8a",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_673c81cf8e7d49689ba5480b46715502",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA679\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA679\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA675\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA671\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+\u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_bcbbac304d9f4336bb56b3a6e030b3f2",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_d05b2f8927f5428fa3caf0686a33b28f",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 1021,
          "name": "\u817E\u8BAF",
          "parent_category": {
            "name": "\u9999\u6E2F",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_d84d43a94a684851a5c8d56a79c18896",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6E2F\u6FB3\u53F0",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_ec0f62c75b8441229fd5b480b4434d8a",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_aac4728ca4f9461f93f1870c7785873a",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA687\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA684\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_bcbbac304d9f4336bb56b3a6e030b3f2",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 1022,
          "name": "\u767E\u5EA6",
          "parent_category": {
            "name": "\u9999\u6E2F",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_d84d43a94a684851a5c8d56a79c18896",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6E2F\u6FB3\u53F0",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_ec0f62c75b8441229fd5b480b4434d8a",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_841c017fdcdd4b82a5939173b20db168",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6129\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6126\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6122\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6116\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_bcbbac304d9f4336bb56b3a6e030b3f2",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_d05b2f8927f5428fa3caf0686a33b28f",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 1023,
          "name": "\u8C37\u6B4C",
          "parent_category": {
            "name": "\u9999\u6E2F",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_d84d43a94a684851a5c8d56a79c18896",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6E2F\u6FB3\u53F0",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_ec0f62c75b8441229fd5b480b4434d8a",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u8D44\u6E90\u7D27\u5F20\uFF0C\u7279\u6B8A\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\uFF0C\u5982\u6709\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u5BA2\u670D",
          "id": "region_2e93c7ec52fe44e4a044b9636aa7f7e6",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA687\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_7ff89815cce74fa4aacc7948f8f50c78",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_d05b2f8927f5428fa3caf0686a33b28f",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 1029,
          "name": "\u8C37\u6B4C",
          "parent_category": {
            "name": "\u53F0\u6E7E",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_e6e185bebce144628d01d5171c905fda",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6E2F\u6FB3\u53F0",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_ec0f62c75b8441229fd5b480b4434d8a",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u8D44\u6E90\u7D27\u5F20\uFF0C\u7279\u6B8A\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\uFF0C\u5982\u6709\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u5BA2\u670D",
          "id": "region_1e6071d2e3264421857f13f0153a1f3a",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA687\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_f4272cafe1d6451ea560458c9f11b640",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cda"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "risk_level": 1,
          "sortValue": 1100,
          "name": "\u963F\u91CC",
          "parent_category": {
            "name": "\u63A8\u8350",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_58d5aeeae05f42da832ba66a351b3d64_recommend",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u7F8E\u56FD",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_58d5aeeae05f42da832ba66a351b3d64",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_3e6eea97e4b74de1825fe004951760f6",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA659\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA657\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA656\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA653\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_f4272cafe1d6451ea560458c9f11b640",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cda"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN"
            ]
          },
          "risk_level": 1,
          "sortValue": 1106,
          "name": "Azure",
          "parent_category": {
            "name": "\u63A8\u8350",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_58d5aeeae05f42da832ba66a351b3d64_recommend",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u7F8E\u56FD",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_58d5aeeae05f42da832ba66a351b3d64",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_44d6627413e7402192f11c5763662edc",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA684\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cda"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 1190,
          "name": "AWS",
          "parent_category": {
            "name": "\u52A0\u5229\u798F\u5C3C\u4E9A",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_278b5c458607498f96450249d735f2ab",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u7F8E\u56FD",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_58d5aeeae05f42da832ba66a351b3d64",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_9cfda642998b429386cf511a71f99ca1",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA659\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA657\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA656\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA653\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cda"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 1195,
          "name": "Azure",
          "parent_category": {
            "name": "\u52A0\u5229\u798F\u5C3C\u4E9A",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_278b5c458607498f96450249d735f2ab",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u7F8E\u56FD",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_58d5aeeae05f42da832ba66a351b3d64",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_1d10199b2ca745f6980a36011fc3c83e",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA684\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_b2c194cbfbff45ec9aa418e41d94d6b6",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cda"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 1229,
          "name": "Azure",
          "parent_category": {
            "name": "\u534E\u76DB\u987F",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_c87c4d4fb6404155936af777dbfc10ec",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u7F8E\u56FD",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_58d5aeeae05f42da832ba66a351b3d64",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_e1ca76006995487a9b8dddf74fa722da",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA684\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cda"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 1239,
          "name": "AWS",
          "parent_category": {
            "name": "\u4FC4\u52D2\u5188",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_7805ed48d3c54ef5917c89b318bc99a8",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u7F8E\u56FD",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_58d5aeeae05f42da832ba66a351b3d64",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_2bb599d8cb344218b3ae350b4e01585b",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA659\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA657\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA656\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA653\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cda"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 1239,
          "name": "\u8C37\u6B4C",
          "parent_category": {
            "name": "\u4FC4\u52D2\u5188",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_7805ed48d3c54ef5917c89b318bc99a8",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u7F8E\u56FD",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_58d5aeeae05f42da832ba66a351b3d64",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u8D44\u6E90\u7D27\u5F20\uFF0C\u7279\u6B8A\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\uFF0C\u5982\u6709\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u5BA2\u670D",
          "id": "region_4a07f8e785b6477e96c3c744244a6f65",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA687\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_c7f027f86ddf48099ebbaf7a1c767af6",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cda"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 1249,
          "name": "Azure",
          "parent_category": {
            "name": "\u5FB7\u514B\u8428\u65AF",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_a95ab4368c2d4fcfaf32adf8cf736640",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u7F8E\u56FD",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_58d5aeeae05f42da832ba66a351b3d64",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_e94115d507924f04b0410efc61e0b8ee",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA684\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_f4272cafe1d6451ea560458c9f11b640",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cda"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 1249,
          "name": "AWS",
          "parent_category": {
            "name": "\u4FC4\u4EA5\u4FC4",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_f89181025fa44cf2b433b408a8d44739",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u7F8E\u56FD",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_58d5aeeae05f42da832ba66a351b3d64",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_dc6abafa370046bea88764022b33f75f",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA659\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA657\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA656\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA653\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_c7f027f86ddf48099ebbaf7a1c767af6",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cda"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 1283,
          "name": "Azure",
          "parent_category": {
            "name": "\u4F0A\u5229\u8BFA\u65AF",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_62dc9198d9ec42ed8fccd546d8b7a3e5",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u7F8E\u56FD",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_58d5aeeae05f42da832ba66a351b3d64",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_5ce1250c8c9843c2b6021dccd6646745",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA684\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_f4272cafe1d6451ea560458c9f11b640",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cda"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 1320,
          "name": "\u963F\u91CC",
          "parent_category": {
            "name": "\u5F17\u5409\u5C3C\u4E9A",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_66a506f3e9e54bf7a080e635c6b3e855",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u7F8E\u56FD",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_58d5aeeae05f42da832ba66a351b3d64",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_3e6eea97e4b74de1825fe004951760f6",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA659\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA657\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA656\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA653\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_f4272cafe1d6451ea560458c9f11b640",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cda"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 1322,
          "name": "AWS",
          "parent_category": {
            "name": "\u5F17\u5409\u5C3C\u4E9A",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_66a506f3e9e54bf7a080e635c6b3e855",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u7F8E\u56FD",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_58d5aeeae05f42da832ba66a351b3d64",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_e7b88a17d1dd4459bff6b05419b28912",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA659\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA657\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA656\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA653/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_f4272cafe1d6451ea560458c9f11b640",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cda"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 1324,
          "name": "\u817E\u8BAF",
          "parent_category": {
            "name": "\u5F17\u5409\u5C3C\u4E9A",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_66a506f3e9e54bf7a080e635c6b3e855",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u7F8E\u56FD",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_58d5aeeae05f42da832ba66a351b3d64",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_35329717c1e34328be5a962ff1747a8e",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6129\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6126\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6122\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6116\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_f4272cafe1d6451ea560458c9f11b640",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cda"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 1325,
          "name": "\u8C37\u6B4C",
          "parent_category": {
            "name": "\u5F17\u5409\u5C3C\u4E9A",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_66a506f3e9e54bf7a080e635c6b3e855",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u7F8E\u56FD",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_58d5aeeae05f42da832ba66a351b3d64",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u8D44\u6E90\u7D27\u5F20\uFF0C\u7279\u6B8A\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\uFF0C\u5982\u6709\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u5BA2\u670D",
          "id": "region_892aa9be63a143e1b8191b791dc1c419",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA687\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_f4272cafe1d6451ea560458c9f11b640",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cda"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 1326,
          "name": "Azure",
          "parent_category": {
            "name": "\u5F17\u5409\u5C3C\u4E9A",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_66a506f3e9e54bf7a080e635c6b3e855",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u7F8E\u56FD",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_58d5aeeae05f42da832ba66a351b3d64",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_44d6627413e7402192f11c5763662edc",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA684\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cda"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 1330,
          "name": "\u963F\u91CC",
          "parent_category": {
            "name": "\u7845\u8C37",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_0fbf2cf35b734c80a821c88af31e9891",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u7F8E\u56FD",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_58d5aeeae05f42da832ba66a351b3d64",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_a128487474a64e05b494dda664d662d1",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA659\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA657\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA656\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA653\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cda"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 1332,
          "name": "\u817E\u8BAF",
          "parent_category": {
            "name": "\u7845\u8C37",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_0fbf2cf35b734c80a821c88af31e9891",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u7F8E\u56FD",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_58d5aeeae05f42da832ba66a351b3d64",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_2a6e7f27c4d24d7fa91d561a5ee8836d",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6129\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6126\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6122\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6116\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_c7f027f86ddf48099ebbaf7a1c767af6",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cda"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 1339,
          "name": "\u8C37\u6B4C",
          "parent_category": {
            "name": "\u827E\u5965\u74E6",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_26124f4daf3c4235b5923e3e208a8db6",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u7F8E\u56FD",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_58d5aeeae05f42da832ba66a351b3d64",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_16b4981e2adc493392d6beb49a4370a0",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA687\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cda"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 1359,
          "name": "\u8C37\u6B4C",
          "parent_category": {
            "name": "\u6D1B\u6749\u77F6",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_2b398bb268f7446084176e1b7efd9c22",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u7F8E\u56FD",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_58d5aeeae05f42da832ba66a351b3d64",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u8D44\u6E90\u7D27\u5F20\uFF0C\u7279\u6B8A\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\uFF0C\u5982\u6709\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u5BA2\u670D",
          "id": "region_74d127db8fae44c1a477279f2bce32cf",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA687\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cda"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 1379,
          "name": "\u8C37\u6B4C",
          "parent_category": {
            "name": "\u62C9\u65AF\u7EF4\u52A0\u65AF",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_c2333f6118924427af51f4f391bfd9cd",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u7F8E\u56FD",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_58d5aeeae05f42da832ba66a351b3d64",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u8D44\u6E90\u7D27\u5F20\uFF0C\u7279\u6B8A\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\uFF0C\u5982\u6709\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u5BA2\u670D",
          "id": "region_90ac74d5c6454baf969b9b883cc423c3",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA687\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_ffdb1d6d629a497fa3097351917d8e62",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cda"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 1399,
          "name": "\u8C37\u6B4C",
          "parent_category": {
            "name": "\u76D0\u6E56\u57CE",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_656b9c61eea8498899a81d97f8caf3aa",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u7F8E\u56FD",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_58d5aeeae05f42da832ba66a351b3d64",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u8D44\u6E90\u7D27\u5F20\uFF0C\u7279\u6B8A\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\uFF0C\u5982\u6709\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u5BA2\u670D",
          "id": "region_064ffde1b500452fa8cecc84bce39de4",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA687\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_f4272cafe1d6451ea560458c9f11b640",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cda"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 1419,
          "name": "\u8C37\u6B4C",
          "parent_category": {
            "name": "\u5357\u5361\u7F57\u6765\u7EB3",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_e72649548f7548ffa858779faf9c94bd",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u7F8E\u56FD",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_58d5aeeae05f42da832ba66a351b3d64",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u8D44\u6E90\u7D27\u5F20\uFF0C\u7279\u6B8A\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\uFF0C\u5982\u6709\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u5BA2\u670D",
          "id": "region_21ec28da03e14004aa8a9478009d747e",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA687\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_e5e654f51e14404e8e4e7862c9c3516e",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_9dfe5d486d8046368588bdfdb3f3d4c2",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cdf"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "RECOMMEND",
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "risk_level": 1,
          "sortValue": 2900,
          "name": "\u963F\u91CC",
          "parent_category": {
            "name": "\u63A8\u8350",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_e6e76e457ef84168b1c35880a99acb7d_recommend",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6B27\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_e6e76e457ef84168b1c35880a99acb7d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_38fd8b37ffea42a490a6b66d9c7fb14c",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA684\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_e5e654f51e14404e8e4e7862c9c3516e",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_9dfe5d486d8046368588bdfdb3f3d4c2",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cdf"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "RECOMMEND",
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 3e3,
          "name": "\u963F\u91CC",
          "parent_category": {
            "name": "\u82F1\u56FD-\u4F26\u6566",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_e8f708af2a674fbe8bac4cd85c98b592",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6B27\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_e6e76e457ef84168b1c35880a99acb7d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_38fd8b37ffea42a490a6b66d9c7fb14c",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA684\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_e5e654f51e14404e8e4e7862c9c3516e",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_9dfe5d486d8046368588bdfdb3f3d4c2",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cdf"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "RECOMMEND",
              "FOREIGN"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 3001,
          "name": "AWS",
          "parent_category": {
            "name": "\u82F1\u56FD-\u4F26\u6566",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_e8f708af2a674fbe8bac4cd85c98b592",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6B27\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_e6e76e457ef84168b1c35880a99acb7d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_e97a9d280d64400baa5d3eed3eb5c8ae",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA684\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_e5e654f51e14404e8e4e7862c9c3516e",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_9dfe5d486d8046368588bdfdb3f3d4c2",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cdf"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 3002,
          "name": "\u8C37\u6B4C",
          "parent_category": {
            "name": "\u82F1\u56FD-\u4F26\u6566",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_e8f708af2a674fbe8bac4cd85c98b592",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6B27\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_e6e76e457ef84168b1c35880a99acb7d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u8D44\u6E90\u7D27\u5F20\uFF0C\u7279\u6B8A\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\uFF0C\u5982\u6709\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u5BA2\u670D",
          "id": "region_318937ab04334ea29ce07473118d4b2e",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA687\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_e5e654f51e14404e8e4e7862c9c3516e",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_ba49909c6e234b9f9759babd39e9738c",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cdf"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 3003,
          "name": "Azure",
          "parent_category": {
            "name": "\u82F1\u56FD-\u4F26\u6566",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_e8f708af2a674fbe8bac4cd85c98b592",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6B27\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_e6e76e457ef84168b1c35880a99acb7d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_12e9b80302924c1c857f47e4b0f75ff1",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA684\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_d83bd507733a4ae88b7a2d51f7032e74",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_4ea8b8cd97e54d4fa0e8b0f01d7ec87c",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cde"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 3009,
          "name": "\u8C37\u6B4C",
          "parent_category": {
            "name": "\u5FB7\u56FD-\u6CD5\u5170\u514B\u798F",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_c00d8ea86a404095848765d7220bc282",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6B27\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_e6e76e457ef84168b1c35880a99acb7d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u8D44\u6E90\u7D27\u5F20\uFF0C\u7279\u6B8A\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\uFF0C\u5982\u6709\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u5BA2\u670D",
          "id": "region_798707d941b74b81a2e63240d0810de6",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA687\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_d83bd507733a4ae88b7a2d51f7032e74",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_4ea8b8cd97e54d4fa0e8b0f01d7ec87c",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cde"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "RECOMMEND",
              "FOREIGN"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 3010,
          "name": "\u963F\u91CC",
          "parent_category": {
            "name": "\u5FB7\u56FD-\u6CD5\u5170\u514B\u798F",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_c00d8ea86a404095848765d7220bc282",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6B27\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_e6e76e457ef84168b1c35880a99acb7d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_3e7d10851a91418ea70fe9be3c52f69c",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA684\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_d83bd507733a4ae88b7a2d51f7032e74",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_4ea8b8cd97e54d4fa0e8b0f01d7ec87c",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cde"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "RECOMMEND",
              "FOREIGN"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 3011,
          "name": "AWS",
          "parent_category": {
            "name": "\u5FB7\u56FD-\u6CD5\u5170\u514B\u798F",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_c00d8ea86a404095848765d7220bc282",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6B27\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_e6e76e457ef84168b1c35880a99acb7d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_ed8b42f2bc084e9498c9731caae826e0",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA684\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_d83bd507733a4ae88b7a2d51f7032e74",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_4ea8b8cd97e54d4fa0e8b0f01d7ec87c",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cde"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 3012,
          "name": "Azure",
          "parent_category": {
            "name": "\u5FB7\u56FD-\u6CD5\u5170\u514B\u798F",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_c00d8ea86a404095848765d7220bc282",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6B27\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_e6e76e457ef84168b1c35880a99acb7d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_22ca133c0f6143f1b90007dbff7f0a7b",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA684\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_c083f23050f744f1a98bbc68f9817674",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_837daeb3ab7d4934990349e57dfd24c8",
            "country_id": "region_country_e1cfb1f82f4d43a0a58492cfc75e2f52_1"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "RECOMMEND",
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 2,
          "sortValue": 3021,
          "name": "AWS",
          "parent_category": {
            "name": "\u6CD5\u56FD-\u5DF4\u9ECE",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_0b784ef22cd84075af4f326063249229",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6B27\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_e6e76e457ef84168b1c35880a99acb7d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_f9d25a54bb094cb18b86881223f8e480",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA684\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_49a0d6d6b4b74365a21efed45e3a5b99",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_ba49909c6e234b9f9759babd39e9738c",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cdf"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 3030,
          "name": "AWS",
          "parent_category": {
            "name": "\u7231\u5C14\u5170",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_312fceb5cd2c4750b3c77cb1e3730c3b",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6B27\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_e6e76e457ef84168b1c35880a99acb7d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_99c021e0dc67445488e64cf860266190",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA684\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_d136a079d03543069b8e64f8d32d5606",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_bfe5ef59a4c64a5a8882fdf016596886",
            "country_id": "region_country_0a4a4432854843a298fedda4e5500116"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 3039,
          "name": "\u817E\u8BAF",
          "parent_category": {
            "name": "\u4FC4\u7F57\u65AF-\u83AB\u65AF\u79D1",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_acfb6076166e493fabd716e2ea3c9f71",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6B27\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_e6e76e457ef84168b1c35880a99acb7d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_19a53ca4742842a1ab573c60b52a64bf",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA687\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA684\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_2688b867b93044449d8768748d3ebf6b",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_624bfb637a04426b8cf6cf394f03090c",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cdb"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 3050,
          "name": "Azure",
          "parent_category": {
            "name": "\u8377\u5170",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_c70e5f00fa104373afedd656add11be3",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6B27\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_e6e76e457ef84168b1c35880a99acb7d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_961fd038962d4c2092641031b5d75d16",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA684\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_2688b867b93044449d8768748d3ebf6b",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_624bfb637a04426b8cf6cf394f03090c",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cdb"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 3051,
          "name": "\u8C37\u6B4C",
          "parent_category": {
            "name": "\u8377\u5170",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_c70e5f00fa104373afedd656add11be3",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6B27\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_e6e76e457ef84168b1c35880a99acb7d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u8D44\u6E90\u7D27\u5F20\uFF0C\u7279\u6B8A\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\uFF0C\u5982\u6709\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u5BA2\u670D",
          "id": "region_0150a39011f04ab2830692849e745fd9",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA687\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_2688b867b93044449d8768748d3ebf6b",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_624bfb637a04426b8cf6cf394f03090c",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cdb"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 3052,
          "name": "VL",
          "parent_category": {
            "name": "\u8377\u5170",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_c70e5f00fa104373afedd656add11be3",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6B27\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_e6e76e457ef84168b1c35880a99acb7d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_abe679028d54434384a4e8d64973ee41",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA699\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA699\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA694\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_08a79ae713144d1cbe0b7c482d9b147b",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_b04cfa8a351a4d0f99c1d79049ec652c",
            "country_id": "region_country_fb87dfe48d6f49f1a30301cace7cd69f"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 3059,
          "name": "AWS",
          "parent_category": {
            "name": "\u745E\u5178",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_46760d1563d145a69af0377efba39110",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6B27\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_e6e76e457ef84168b1c35880a99acb7d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_1fee577062fb48f09a7b9da40e987ee3",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA679\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA677\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA675\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA671\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_12d6b077545543bf9b42182fd9481d39",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_1447d2b0a5f7445b95dfd9ef696198ff",
            "country_id": "region_country_3fe29984c2e449b2b05c9350c3efa8a3"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 3069,
          "name": "\u8C37\u6B4C",
          "parent_category": {
            "name": "\u6BD4\u5229\u65F6",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_08fe1fe7c7e34353bd8e04ea3649614c",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6B27\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_e6e76e457ef84168b1c35880a99acb7d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u8D44\u6E90\u7D27\u5F20\uFF0C\u7279\u6B8A\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\uFF0C\u5982\u6709\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u5BA2\u670D",
          "id": "region_5cc5f2b69c5241cb86a86b85086addd7",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA687\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_40a9c9528ba340148c700570c4de1570",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_2db5c29606724bce9cf4db852f4b298b",
            "country_id": "region_country_d9ebb3edfab9452f817974396160daf2"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 3079,
          "name": "\u8C37\u6B4C",
          "parent_category": {
            "name": "\u82AC\u5170",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_bc275c07b5e54daa9616e90af62ae9bf",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6B27\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_e6e76e457ef84168b1c35880a99acb7d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u8D44\u6E90\u7D27\u5F20\uFF0C\u7279\u6B8A\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\uFF0C\u5982\u6709\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u5BA2\u670D",
          "id": "region_f3d1d71da3cd4853b7c6962c16386a26",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA687\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_ee7cb2c5d2b046d6a6fd5a46db682e16",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_36d08c8af6a647f0a1895f514908008b",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cdc"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "RECOMMEND",
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "risk_level": 1,
          "sortValue": 3900,
          "name": "\u963F\u91CC",
          "parent_category": {
            "name": "\u63A8\u8350",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_2d25c21f478d48ef9ad6f308c417a2cc_recommend",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E9A\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2d25c21f478d48ef9ad6f308c417a2cc",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_3e18e457a2474364850e70c31132ddfa",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA684\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_02c865e45e3f4760be918bdb2b757669",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_bfa74bdf98c34104ba30c9ccf9f8d373",
            "country_id": "region_country_4dfaca65565b48a09d3f3deac5b888ba"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 3989,
          "name": "\u817E\u8BAF",
          "parent_category": {
            "name": "\u9996\u5C14",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_ffd536165bbe4cecae6afd902c7eed2b",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E9A\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2d25c21f478d48ef9ad6f308c417a2cc",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_1e95685da2d04bebbb1fb1855a13d4c3",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA687\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA685\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Amazon",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": false,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "eBay",
              "caption": "eBay",
              "support": false,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PayPal",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Shopee",
              "caption": "Shopee",
              "support": false,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Lazada",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Wish",
              "caption": "Wish",
              "support": false,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDiscount",
              "caption": "CDiscount",
              "support": false,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Joom",
              "caption": "Joom",
              "support": false,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Vova",
              "caption": "Vova",
              "support": false,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Walmart",
              "caption": "\u6C83\u5C14\u739B",
              "support": false,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Rakuten",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Ozon",
              "caption": "Ozon",
              "support": false,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FactoryMarket",
              "caption": "FactoryMarket",
              "support": false,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Alibaba",
              "caption": "Alibaba",
              "support": false,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Etsy",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMaTou",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "The Home Depot",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Target",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WayFair",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OpenSky",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Real",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AmazonVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AmazonAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_e703e6c1137f460cac012d870d657203",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_ba49909c6e234b9f9759babd39e9738c",
            "country_id": "region_country_3d7fe27e0cb3481b9119d46d4e06f453"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 4030,
          "name": "\u963F\u91CC",
          "parent_category": {
            "name": "\u65B0\u52A0\u5761",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_fcdf0c653bc84ca882cb9d977af058f5",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E9A\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2d25c21f478d48ef9ad6f308c417a2cc",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_cf705bf2fc764152a304613227d384ea",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA699\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "8.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA699\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "8.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA694\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "8.1",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_0c5ee26acc9e4935b02eec74616a1e7e",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_39e7914263a84f529540a38fd51a8108",
            "country_id": "region_country_22a5ea67928a4b4ab3481847888bfa85"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 4031,
          "name": "AWS",
          "parent_category": {
            "name": "\u4E2D\u4E1C-\u5DF4\u6797",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_244a761d755c4914970128a52e33ec1d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E9A\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2d25c21f478d48ef9ad6f308c417a2cc",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_e00b75e5b79c4202ac55261eb77b18b7",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6169\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6169\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6160\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6152\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_e703e6c1137f460cac012d870d657203",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_9dfe5d486d8046368588bdfdb3f3d4c2",
            "country_id": "region_country_3d7fe27e0cb3481b9119d46d4e06f453"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 4031,
          "name": "AWS",
          "parent_category": {
            "name": "\u65B0\u52A0\u5761",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_fcdf0c653bc84ca882cb9d977af058f5",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E9A\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2d25c21f478d48ef9ad6f308c417a2cc",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_eb6edfdad4af405f9cc443d64742078f",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA684\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_e703e6c1137f460cac012d870d657203",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_9dfe5d486d8046368588bdfdb3f3d4c2",
            "country_id": "region_country_3d7fe27e0cb3481b9119d46d4e06f453"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 4035,
          "name": "\u767E\u5EA6",
          "parent_category": {
            "name": "\u65B0\u52A0\u5761",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_fcdf0c653bc84ca882cb9d977af058f5",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E9A\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2d25c21f478d48ef9ad6f308c417a2cc",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_2b1be15539c2481face8a22bc63eeb62",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6185\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6180\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6170\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Amazon",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": false,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "eBay",
              "caption": "eBay",
              "support": false,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PayPal",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Shopee",
              "caption": "Shopee",
              "support": false,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Lazada",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Wish",
              "caption": "Wish",
              "support": false,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDiscount",
              "caption": "CDiscount",
              "support": false,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Joom",
              "caption": "Joom",
              "support": false,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Vova",
              "caption": "Vova",
              "support": false,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Walmart",
              "caption": "\u6C83\u5C14\u739B",
              "support": false,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Rakuten",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Ozon",
              "caption": "Ozon",
              "support": false,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FactoryMarket",
              "caption": "FactoryMarket",
              "support": false,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Alibaba",
              "caption": "Alibaba",
              "support": false,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Etsy",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMaTou",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "The Home Depot",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Target",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WayFair",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OpenSky",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Real",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AmazonVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AmazonAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_e703e6c1137f460cac012d870d657203",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_9dfe5d486d8046368588bdfdb3f3d4c2",
            "country_id": "region_country_3d7fe27e0cb3481b9119d46d4e06f453"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 4036,
          "name": "\u8C37\u6B4C",
          "parent_category": {
            "name": "\u65B0\u52A0\u5761",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_fcdf0c653bc84ca882cb9d977af058f5",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E9A\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2d25c21f478d48ef9ad6f308c417a2cc",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u8D44\u6E90\u7D27\u5F20\uFF0C\u7279\u6B8A\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\uFF0C\u5982\u6709\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u5BA2\u670D",
          "id": "region_6980dbad83f44c78aedb0198b459d395",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA687\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_ee7cb2c5d2b046d6a6fd5a46db682e16",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_36d08c8af6a647f0a1895f514908008b",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cdc"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "RECOMMEND",
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 4040,
          "name": "\u963F\u91CC",
          "parent_category": {
            "name": "\u65E5\u672C-\u4E1C\u4EAC",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_b78de56a49c84743a96b46a5207007ee",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E9A\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2d25c21f478d48ef9ad6f308c417a2cc",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_3e18e457a2474364850e70c31132ddfa",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA684\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_ee7cb2c5d2b046d6a6fd5a46db682e16",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_36d08c8af6a647f0a1895f514908008b",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cdc"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "RECOMMEND",
              "FOREIGN"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 4041,
          "name": "AWS",
          "parent_category": {
            "name": "\u65E5\u672C-\u4E1C\u4EAC",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_b78de56a49c84743a96b46a5207007ee",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E9A\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2d25c21f478d48ef9ad6f308c417a2cc",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_1b734f71a32e4d42ac652c7a4dfb1a27",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA684\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": true,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_ee7cb2c5d2b046d6a6fd5a46db682e16",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_36d08c8af6a647f0a1895f514908008b",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cdc"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 4042,
          "name": "Azure",
          "parent_category": {
            "name": "\u65E5\u672C-\u4E1C\u4EAC",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_b78de56a49c84743a96b46a5207007ee",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E9A\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2d25c21f478d48ef9ad6f308c417a2cc",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_7eb4e3c20b1d40c5986724169ba0a063",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA684\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_ee7cb2c5d2b046d6a6fd5a46db682e16",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_36d08c8af6a647f0a1895f514908008b",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cdc"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 4043,
          "name": "\u8C37\u6B4C",
          "parent_category": {
            "name": "\u65E5\u672C-\u4E1C\u4EAC",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_b78de56a49c84743a96b46a5207007ee",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E9A\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2d25c21f478d48ef9ad6f308c417a2cc",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u8D44\u6E90\u7D27\u5F20\uFF0C\u7279\u6B8A\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\uFF0C\u5982\u6709\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u5BA2\u670D",
          "id": "region_62565844b95e4ee2aac333383d05f444",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA687\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_c7f631ac50c547d18aa94318270cd029",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_365c41357e124ead87ae3dbfb90c6a62",
            "country_id": "region_country_e1cfb1f82f4d43a0a58492cfc75e2f52"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 4049,
          "name": "\u963F\u91CC",
          "parent_category": {
            "name": "\u5370\u5C3C-\u96C5\u52A0\u8FBE",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_95a5d8c14d0f43b7b7e1179c213601b0",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E9A\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2d25c21f478d48ef9ad6f308c417a2cc",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_f6feaba4fd3e4e8fbc70daf89465aa2a",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA679\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA677\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA675\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA671\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_c7f631ac50c547d18aa94318270cd029",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_365c41357e124ead87ae3dbfb90c6a62",
            "country_id": "region_country_e1cfb1f82f4d43a0a58492cfc75e2f52"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 4049,
          "name": "\u8C37\u6B4C",
          "parent_category": {
            "name": "\u5370\u5EA6\u5C3C\u897F\u4E9A-\u96C5\u52A0\u8FBE",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_84e74e14a93e425d9ef3aca67b0443c8",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E9A\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2d25c21f478d48ef9ad6f308c417a2cc",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u8D44\u6E90\u7D27\u5F20\uFF0C\u7279\u6B8A\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\uFF0C\u5982\u6709\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u5BA2\u670D",
          "id": "region_28511e4a7d9a4513aed9da3fd6d9c128",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA687\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_7a473af2a04f499da8edf0cb73412c2f",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_895422ac57d645b3b44998b23ad88b63",
            "country_id": "region_country_4a1fc7a1b3e04fd3bf6884289f43805e"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 4059,
          "name": "\u963F\u91CC",
          "parent_category": {
            "name": "\u9A6C\u6765\u897F\u4E9A-\u5409\u9686\u5761",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_697b1e0bd1bf4a3bbfe745639e99c43d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E9A\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2d25c21f478d48ef9ad6f308c417a2cc",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_b24dbe9d742447f7b725c26e8025c9a7",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA679\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA677\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA675\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA671\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_90ceb47c16b142f6b5651ac495e483c8",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_1261f4363c0a4fabb4ca1ce221049962",
            "country_id": "region_country_624d817563df41e6af84abce39f9dcdc"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 4069,
          "name": "\u963F\u91CC",
          "parent_category": {
            "name": "\u5370\u5EA6-\u5B5F\u4E70",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_3ae69774db6d433da0c942505b50cf36",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E9A\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2d25c21f478d48ef9ad6f308c417a2cc",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_8101316dc1fa416189a61265df33dc5f",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA679\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA677\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA675\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA671\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_90ceb47c16b142f6b5651ac495e483c8",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_1261f4363c0a4fabb4ca1ce221049962",
            "country_id": "region_country_624d817563df41e6af84abce39f9dcdc"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 4069,
          "name": "\u8C37\u6B4C",
          "parent_category": {
            "name": "\u5370\u5EA6-\u5B5F\u4E70",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_3ae69774db6d433da0c942505b50cf36",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E9A\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2d25c21f478d48ef9ad6f308c417a2cc",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_64c6b999d8624a109ff044895df9cae5",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA687\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_02c865e45e3f4760be918bdb2b757669",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_bfa74bdf98c34104ba30c9ccf9f8d373",
            "country_id": "region_country_4dfaca65565b48a09d3f3deac5b888ba"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 4090,
          "name": "AWS",
          "parent_category": {
            "name": "\u97E9\u56FD-\u9996\u5C14",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_c4653eb97fb64a76b067f9c45de80eb6",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E9A\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2d25c21f478d48ef9ad6f308c417a2cc",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_930d93c42a404ba19c2fdbf3f74d4913",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA679\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA677\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA675\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA671\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_02c865e45e3f4760be918bdb2b757669",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_bfa74bdf98c34104ba30c9ccf9f8d373",
            "country_id": "region_country_4dfaca65565b48a09d3f3deac5b888ba"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 4092,
          "name": "\u8C37\u6B4C",
          "parent_category": {
            "name": "\u97E9\u56FD-\u9996\u5C14",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_c4653eb97fb64a76b067f9c45de80eb6",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E9A\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2d25c21f478d48ef9ad6f308c417a2cc",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u8D44\u6E90\u7D27\u5F20\uFF0C\u7279\u6B8A\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\uFF0C\u5982\u6709\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u5BA2\u670D",
          "id": "region_a275e918d14f4c39a4333864fa1c517d",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA687\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_ee7cb2c5d2b046d6a6fd5a46db682e16",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_36d08c8af6a647f0a1895f514908008b",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cdc"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 4099,
          "name": "\u8C37\u6B4C",
          "parent_category": {
            "name": "\u65E5\u672C-\u5927\u962A",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_4ac1bac66dc54f0cb91e1e077bfd4ad3",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E9A\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2d25c21f478d48ef9ad6f308c417a2cc",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u8D44\u6E90\u7D27\u5F20\uFF0C\u7279\u6B8A\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\uFF0C\u5982\u6709\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u5BA2\u670D",
          "id": "region_8a64285f18994eaf8679c1a78c4be9c7",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA687\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_47b8bba76ecf48bcb0e12ae773078a1d",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_1261f4363c0a4fabb4ca1ce221049962",
            "country_id": "region_country_624d817563df41e6af84abce39f9dcdc"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 4109,
          "name": "\u817E\u8BAF",
          "parent_category": {
            "name": "\u5B5F\u4E70",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_dd67e4eee82843d896404290c0718acd",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E9A\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2d25c21f478d48ef9ad6f308c417a2cc",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_9c7aab7a2693441c87d77431bdbc4120",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6129\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6126\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6122\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6116\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_0f3421fb2ccd4b4c8e000b2efc8061e5",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_d72752efdfd74bccb701de695f032de7",
            "country_id": "region_country_3bf6d4cc9d814d3e88b7ebe50ade6eb7"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 4109,
          "name": "\u817E\u8BAF",
          "parent_category": {
            "name": "\u6CF0\u56FD-\u66FC\u8C37",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_2f66e9e640ab4b43990b952096f3432c",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E9A\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2d25c21f478d48ef9ad6f308c417a2cc",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_6eec921d70be41d583d46b579fc27997",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6129\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6126\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6122\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6116\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_59127c59ef5c429cb8e9823b0d86c816",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_b1cddf64968947a69619f7c53f9bab81",
            "country_id": "region_country_6c22ff1540e9419f94109e92ba3372c7"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "risk_level": 1,
          "sortValue": 4900,
          "name": "\u963F\u91CC",
          "parent_category": {
            "name": "\u63A8\u8350",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_b60aa48c669e4de0aa34e27c13d33ac1_recommend",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u6D0B\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_b60aa48c669e4de0aa34e27c13d33ac1",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u7EBF\u8DEF\u7ECF\u4F18\u5316\uFF0C\u63A8\u8350\u4F7F\u7528\uFF1B\u8FD1\u671F\u4E9A\u9A6C\u900A\u3001eBay\u6CE8\u518C\u653F\u7B56\u6536\u7D27\uFF0C\u5EFA\u8BAE\u4F7F\u7528\u4F4F\u5B85IP\u8FDB\u884C\u6CE8\u518C\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9",
          "id": "region_98c16c74f7a9412b98b2a3916ec0a6e6",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA684\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_59127c59ef5c429cb8e9823b0d86c816",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_b1cddf64968947a69619f7c53f9bab81",
            "country_id": "region_country_6c22ff1540e9419f94109e92ba3372c7"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 4990,
          "name": "\u963F\u91CC",
          "parent_category": {
            "name": "\u6FB3\u5927\u5229\u4E9A-\u6089\u5C3C",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_2e8f8b34af584f7689c2943785369841",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u6D0B\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_b60aa48c669e4de0aa34e27c13d33ac1",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u7EBF\u8DEF\u7ECF\u4F18\u5316\uFF0C\u63A8\u8350\u4F7F\u7528\uFF1B\u8FD1\u671F\u4E9A\u9A6C\u900A\u3001eBay\u6CE8\u518C\u653F\u7B56\u6536\u7D27\uFF0C\u5EFA\u8BAE\u4F7F\u7528\u4F4F\u5B85IP\u8FDB\u884C\u6CE8\u518C\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9",
          "id": "region_98c16c74f7a9412b98b2a3916ec0a6e6",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA684\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_59127c59ef5c429cb8e9823b0d86c816",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_b1cddf64968947a69619f7c53f9bab81",
            "country_id": "region_country_6c22ff1540e9419f94109e92ba3372c7"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 4991,
          "name": "AWS",
          "parent_category": {
            "name": "\u6FB3\u5927\u5229\u4E9A-\u6089\u5C3C",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_2e8f8b34af584f7689c2943785369841",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u6D0B\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_b60aa48c669e4de0aa34e27c13d33ac1",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_b540ed4a17284b8f9f85077421aac2b1",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": "8.7",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA679\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "8.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA677\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "8.3",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA675\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "7.9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA671\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_59127c59ef5c429cb8e9823b0d86c816",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_b1cddf64968947a69619f7c53f9bab81",
            "country_id": "region_country_6c22ff1540e9419f94109e92ba3372c7"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 4992,
          "name": "\u8C37\u6B4C",
          "parent_category": {
            "name": "\u6FB3\u5927\u5229\u4E9A-\u6089\u5C3C",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_2e8f8b34af584f7689c2943785369841",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u6D0B\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_b60aa48c669e4de0aa34e27c13d33ac1",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u8D44\u6E90\u7D27\u5F20\uFF0C\u7279\u6B8A\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\uFF0C\u5982\u6709\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u5BA2\u670D",
          "id": "region_8c2e2589ebed47a8a0fa25c490f37be3",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA687\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_47b8bba76ecf48bcb0e12ae773078a1d",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_602d7bedd10b416ebef1515d955de14d",
            "country_id": "region_country_d17d5e5f30034b6ab6f918a12e81a989"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 6009,
          "name": "\u817E\u8BAF",
          "parent_category": {
            "name": "\u52A0\u62FF\u5927",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_2b4b30502d7343c4b852555c92d22fde",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u7F8E\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2393947815154c438132418228c6b36d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_6c6184d9a06146258204267ecaa5b693",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6129\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6126\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6122\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6116\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_47b8bba76ecf48bcb0e12ae773078a1d",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_602d7bedd10b416ebef1515d955de14d",
            "country_id": "region_country_d17d5e5f30034b6ab6f918a12e81a989"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 6019,
          "name": "\u8C37\u6B4C",
          "parent_category": {
            "name": "\u52A0\u62FF\u5927-\u8499\u7279\u5229\u5C14",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_6257bd99da414d8f9e28e096d3dd64fd",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u7F8E\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2393947815154c438132418228c6b36d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u8D44\u6E90\u7D27\u5F20\uFF0C\u7279\u6B8A\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\uFF0C\u5982\u6709\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u5BA2\u670D",
          "id": "region_5ac51868a90e4a80b78d12663222bd09",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA687\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_47b8bba76ecf48bcb0e12ae773078a1d",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_602d7bedd10b416ebef1515d955de14d",
            "country_id": "region_country_d17d5e5f30034b6ab6f918a12e81a989"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "RECOMMEND",
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 6041,
          "name": "AWS",
          "parent_category": {
            "name": "\u52A0\u62FF\u5927-\u591A\u4F26\u591A",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_7f1db40f46da4a678ae4246e5d51e8f0",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u7F8E\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2393947815154c438132418228c6b36d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_e403535cceb6468b81ebfff30e20eb40",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA684\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_e912e52e79224f55aac6a1e7bca25c8a",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_cc25f66bca624f6497604194f574e58f",
            "country_id": "region_country_2b856df71f96456389c84a48280b7e54"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 6049,
          "name": "\u8C37\u6B4C",
          "parent_category": {
            "name": "\u5DF4\u897F",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_7a1a545c4c5b45fab5e9a7a4e94ec612",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u7F8E\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2393947815154c438132418228c6b36d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u8D44\u6E90\u7D27\u5F20\uFF0C\u7279\u6B8A\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\uFF0C\u5982\u6709\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u5BA2\u670D",
          "id": "region_bc6fb2d78ec740bbbbed796c2823a90b",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA687\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_e912e52e79224f55aac6a1e7bca25c8a",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_cc25f66bca624f6497604194f574e58f",
            "country_id": "region_country_2b856df71f96456389c84a48280b7e54"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 6061,
          "name": "AWS",
          "parent_category": {
            "name": "\u5DF4\u897F-\u5723\u4FDD\u7F57",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_664568ba1e3e4fa086c2063826707231",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u7F8E\u6D32",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2393947815154c438132418228c6b36d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_03fd38af471747b7be8d3cad7a394fc5",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA689\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA684\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA680\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "TMALL",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 7989,
          "name": "\u7535\u4FE1",
          "parent_category": {
            "name": "\u4E0A\u6D77",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_84e958f1b31743dcb2ab8c09c55ee1de",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u9646\u5176\u4ED6",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_4ea028feb1ec490f8952ecd368450c1d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_e91649ea71b34bd0a09c96b20ed078b4",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "8.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6179\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6170\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": false,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": false,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": false,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": false,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": false,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": false,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": false,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": false,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": false,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": false,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "TMALL",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 7989,
          "name": "\u7535\u4FE1",
          "parent_category": {
            "name": "\u6210\u90FD",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_2eef51ba8fd345a18521f0ab8bf3a9d9",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u9646\u5176\u4ED6",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_4ea028feb1ec490f8952ecd368450c1d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_d0569bd28a904d97a72e53964f53c8ac",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": false,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": false,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": false,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": false,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": false,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": false,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": false,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": false,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": false,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": false,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "TMALL",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 7989,
          "name": "\u7535\u4FE1",
          "parent_category": {
            "name": "\u9752\u5C9B",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_594a9847d9334389babbd2d464792eab",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u9646\u5176\u4ED6",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_4ea028feb1ec490f8952ecd368450c1d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_084887e065f94758857f687040ec20eb",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "8.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6179\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6170\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": false,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": false,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": false,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": false,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": false,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": false,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": false,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": false,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": false,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": false,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "TMALL",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 7989,
          "name": "\u7535\u4FE1",
          "parent_category": {
            "name": "\u4F5B\u5C71",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_7b8debc4c3c64d728035776d464f7a59",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u9646\u5176\u4ED6",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_4ea028feb1ec490f8952ecd368450c1d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u6C11\u7528\u7EA7IP\u6807\u8BC6\uFF0C\u56FD\u5916\u5EF6\u8FDF\u8F83\u9AD8\uFF1B\u8D44\u6E90\u7D27\u5F20\uFF0C\u7F3A\u8D27\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9",
          "id": "region_a4efad4acfe243f6b8b0a282710c7ed9",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "8.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6179\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6170\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": false,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": false,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": false,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": false,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": false,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": false,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": false,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": false,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": false,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": false,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "TMALL",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 7989,
          "name": "\u7535\u4FE1",
          "parent_category": {
            "name": "\u8D35\u5DDE",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_1fbdb4a5772f4fcabfcb4abd14a6768a",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u9646\u5176\u4ED6",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_4ea028feb1ec490f8952ecd368450c1d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_65e170cb542f45779ca8dca4948b8cfc",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "8.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6179\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6170\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": false,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": false,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": false,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": false,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": false,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": false,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": false,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": false,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": false,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": false,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "TMALL",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 7990,
          "name": "\u8054\u901A",
          "parent_category": {
            "name": "\u5929\u6D25",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_490f20bf885b4417ab51096b08ca62ac",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u9646\u5176\u4ED6",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_4ea028feb1ec490f8952ecd368450c1d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_2d3f5508c4be4444b9f178dc03126d73",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": "8.7",
              "price_description": null,
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "8.5",
              "price_description": null,
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "8.3",
              "price_description": null,
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "7.8",
              "price_description": null,
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": false,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": false,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": false,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": false,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": false,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": false,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": false,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": false,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": false,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": false,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "TMALL",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 8006,
          "name": "\u7535\u4FE1",
          "parent_category": {
            "name": "\u9655\u897F",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_297b5debc8294b168a7da88a9fd7e7f3",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u9646\u5176\u4ED6",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_4ea028feb1ec490f8952ecd368450c1d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_4392cb90e7e443c8b9b1bbf2f22f1e8c",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "8.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6179\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6170\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": false,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": false,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": false,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": false,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": false,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": false,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": false,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": false,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": false,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": false,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "TMALL",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 8026,
          "name": "\u7535\u4FE1",
          "parent_category": {
            "name": "\u6DF1\u5733",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_aab0bfea647641ddab1a8edc7ad84c7a",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u9646\u5176\u4ED6",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_4ea028feb1ec490f8952ecd368450c1d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_cd32dd7bcb924ae88205c675517f9a16",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "8.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6179\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6170\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": false,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": false,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": false,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": false,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": false,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": false,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": false,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": false,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": false,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": false,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "TMALL",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 8026,
          "name": "\u7535\u4FE1",
          "parent_category": {
            "name": "\u5E7F\u5DDE",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_af4b89e9aab447c7833280195b9ac1b7",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u9646\u5176\u4ED6",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_4ea028feb1ec490f8952ecd368450c1d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u7279\u6B8A\u5730\u57DF\uFF0C\u53EA\u5728\u4E2D\u56FD\u5927\u9646\u6CD5\u5B9A\u8282\u5047\u65E5\u6B63\u5E38\u5F00\u901A\uFF0C\u5176\u4F59\u5F00\u901A\u65F6\u95F4\u987A\u5EF6\u3002",
          "id": "region_93ce9c96709c43dfbdab308feadcc692",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "8.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6179\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6170\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": false,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": false,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": false,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": false,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": false,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": false,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": false,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": false,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": false,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": false,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "TMALL",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 8036,
          "name": "\u7535\u4FE1",
          "parent_category": {
            "name": "\u798F\u5EFA",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_c3b239b793cf46fa90672b34b4a16090",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u9646\u5176\u4ED6",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_4ea028feb1ec490f8952ecd368450c1d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_bedbad1c7d28436cb390cf6dcb8194b3",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "8.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6179\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6170\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": false,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": false,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": false,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": false,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": false,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": false,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": false,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": false,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": false,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": false,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "TMALL",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 8036,
          "name": "\u7535\u4FE1",
          "parent_category": {
            "name": "\u6D59\u6C5F",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_9ce4bd3eee2246578892370c00df9f91",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u9646\u5176\u4ED6",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_4ea028feb1ec490f8952ecd368450c1d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_bbf89c6a5c08457ea40d9af7f7aa65ed",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "8.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6179\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6170\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": false,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": false,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": false,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": false,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": false,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": false,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": false,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": false,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": false,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": false,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "TMALL",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 8056,
          "name": "\u7535\u4FE1",
          "parent_category": {
            "name": "\u6E56\u5357",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_69659cc1ba2849619f95b373d21570a4",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u9646\u5176\u4ED6",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_4ea028feb1ec490f8952ecd368450c1d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_3f8633f219fd4a608d377b0813b77c39",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6179\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6170\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": false,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": false,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": false,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": false,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": false,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": false,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": false,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": false,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": false,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": false,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "TMALL",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 2,
          "sortValue": 8086,
          "name": "\u7535\u4FE1",
          "parent_category": {
            "name": "\u6C5F\u82CF",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_3b8cc20ade3f428ca90a1e37bdbc5ef1",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u9646\u5176\u4ED6",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_4ea028feb1ec490f8952ecd368450c1d",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_ec1a2aa5096c4b9db51c82b714416ad8",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "8.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6179\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6170\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": false,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": false,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": false,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": false,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": false,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": false,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": false,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": false,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": false,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": false,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": false,
          "marks": {
            "model": "tags",
            "tags": [
              "LOCAL",
              "RECOMMEND",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": true,
          "risk_level": 1,
          "sortValue": 8990,
          "name": "\u672C\u673AIP",
          "parent_category": {
            "name": "\u672C\u5730\u672C\u673A",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_36667508006a41eebcf7cbf5b3a2eed5",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "limit": {
            "min": 1,
            "max": 1e3,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u672C\u673A&\u81EA\u914D",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_9379623172d942c09430fc35d6a468c5",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u53EA\u63D0\u4F9B\u5168\u65B0\u7535\u8111\u73AF\u5883\uFF0C\u4E0D\u542B\u56FA\u5B9AIP\u3002\u914D\u5408\u7528\u6237\u672C\u5730IP\u4F7F\u7528\uFF0C\u53EF\u4EE5\u505A\u8D26\u53F7\u6CE8\u518C",
          "id": "region_02734c770cd345efaa81c94405bad58f",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": "7.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA620\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+10\u4E2A\u5B50\u8D26\u53F7\uFF08PC\u7AEF\u8FD0\u8425\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09+\u5FAE\u4FE1 VIP \u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00d",
              "spec_name": "1\u5929"
            },
            {
              "visible": true,
              "discount_tag": "6.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA620\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+10\u4E2A\u5B50\u8D26\u53F7\uFF08PC\u7AEF\u8FD0\u8425\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09+\u5FAE\u4FE1 VIP \u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00e",
              "spec_name": "5\u5929"
            },
            {
              "visible": true,
              "discount_tag": "4.2",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA620\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+10\u4E2A\u5B50\u8D26\u53F7\uFF08PC\u7AEF\u8FD0\u8425\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09+\u5FAE\u4FE1 VIP \u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "4.2",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA620\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+10\u4E2A\u5B50\u8D26\u53F7\uFF08PC\u7AEF\u8FD0\u8425\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09+\u5FAE\u4FE1 VIP \u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "4.2",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA620\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+10\u4E2A\u5B50\u8D26\u53F7\uFF08PC\u7AEF\u8FD0\u8425\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09+\u5FAE\u4FE1 VIP \u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "4.2",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA620\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+10\u4E2A\u5B50\u8D26\u53F7\uFF08PC\u7AEF\u8FD0\u8425\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09+\u5FAE\u4FE1 VIP \u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": true,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": true,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": true,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": true,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": false,
          "marks": {
            "model": "tags",
            "tags": [
              "RECOMMEND",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": true,
          "risk_level": 1,
          "sortValue": 9020,
          "name": "\u81EA\u5EFA\u4EE3\u7406IP",
          "parent_category": {
            "name": "\u81EA\u914D\u4EE3\u7406",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_0df6bab71f4e49dc99e1dafb308f7ec5",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u672C\u673A&\u81EA\u914D",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_9379623172d942c09430fc35d6a468c5",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u6B64VD\u4E0D\u63D0\u4F9BIP\uFF0C\u7528\u6237\u81EA\u884C\u914D\u7F6E\u4EE3\u7406IP\u3002\u8BF7\u4ED4\u7EC6\u6838\u5BF9\u914D\u7F6E\u7684\u7535\u8111\u73AF\u5883",
          "id": "region_0749f8b0d51a407d98499609c395acd4",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA61.6\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+10\u4E2A\u5B50\u8D26\u53F7\uFF08PC\u7AEF\u8FD0\u8425\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09+\u5FAE\u4FE1 VIP \u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00d",
              "spec_name": "1\u5929"
            },
            {
              "visible": true,
              "discount_tag": "7.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA620\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+10\u4E2A\u5B50\u8D26\u53F7\uFF08PC\u7AEF\u8FD0\u8425\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09+\u5FAE\u4FE1 VIP \u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00e",
              "spec_name": "5\u5929"
            },
            {
              "visible": true,
              "discount_tag": "4.2",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA620\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+10\u4E2A\u5B50\u8D26\u53F7\uFF08PC\u7AEF\u8FD0\u8425\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09+\u5FAE\u4FE1 VIP \u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "4.2",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA620\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+10\u4E2A\u5B50\u8D26\u53F7\uFF08PC\u7AEF\u8FD0\u8425\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09+\u5FAE\u4FE1 VIP \u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "4.2",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA620\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+10\u4E2A\u5B50\u8D26\u53F7\uFF08PC\u7AEF\u8FD0\u8425\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09+\u5FAE\u4FE1 VIP \u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "4.2",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA620\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+10\u4E2A\u5B50\u8D26\u53F7\uFF08PC\u7AEF\u8FD0\u8425\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09+\u5FAE\u4FE1 VIP \u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": true,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": true,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": true,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": true,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 9989,
          "name": "\u4F4F\u5B85",
          "parent_category": {
            "name": "\u5E7F\u897F",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_9814d9dd157842679b922cd15862586b",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u9646\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2e6e6646168743a181ad61a3b52f4c15",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_1cb9c29d085b453dbabb74c7afb8cc4d",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 9989,
          "name": "\u4F4F\u5B85",
          "parent_category": {
            "name": "\u6C5F\u82CF",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_78bac6b9333641b6a28fcd354551d206",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u9646\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2e6e6646168743a181ad61a3b52f4c15",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u6C11\u7528\u7EA7IP\u6807\u8BC6\uFF0C\u56FD\u5916\u5EF6\u8FDF\u8F83\u9AD8\uFF1B\u8D44\u6E90\u7D27\u5F20\uFF0C\u7F3A\u8D27\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9",
          "id": "region_f71351ce51b141cc872e3222619651a9",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "8.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6179\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6170\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 9989,
          "name": "\u4F4F\u5B85",
          "parent_category": {
            "name": "\u91CD\u5E86",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_502a689fd21b4ee996bb853fd0a2426e",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u9646\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2e6e6646168743a181ad61a3b52f4c15",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_9d905e18e7fc4eb1abfe9e0406b3006a",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6179\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6170\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 9989,
          "name": "\u7535\u4FE1",
          "parent_category": {
            "name": "\u6C88\u9633",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_47da8e2aee38477eb6d4c9c5d02f62f4",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u9646\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2e6e6646168743a181ad61a3b52f4c15",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_d90c9233dc3d408f980655c005c6ed59",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 9989,
          "name": "\u4F4F\u5B85",
          "parent_category": {
            "name": "\u6C5F\u897F",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_046ce045873f4ace80de366b2d9550f9",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u9646\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2e6e6646168743a181ad61a3b52f4c15",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u6C11\u7528\u7EA7IP\u6807\u8BC6\uFF0C\u56FD\u5916\u5EF6\u8FDF\u8F83\u9AD8\uFF1B\u8D44\u6E90\u7D27\u5F20\uFF0C\u7F3A\u8D27\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9",
          "id": "region_5a00900b0b73457c827f3c9557847833",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "8.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6179\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6170\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Amazon",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": false,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "eBay",
              "caption": "eBay",
              "support": false,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PayPal",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Shopee",
              "caption": "Shopee",
              "support": false,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Lazada",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Wish",
              "caption": "Wish",
              "support": false,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDiscount",
              "caption": "CDiscount",
              "support": false,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Joom",
              "caption": "Joom",
              "support": false,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Vova",
              "caption": "Vova",
              "support": false,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Walmart",
              "caption": "\u6C83\u5C14\u739B",
              "support": false,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Rakuten",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Ozon",
              "caption": "Ozon",
              "support": false,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FactoryMarket",
              "caption": "FactoryMarket",
              "support": false,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Alibaba",
              "caption": "Alibaba",
              "support": false,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Etsy",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMaTou",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "The Home Depot",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Target",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WayFair",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OpenSky",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Real",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AmazonVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AmazonAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 9989,
          "name": "\u4F4F\u5B85",
          "parent_category": {
            "name": "\u9655\u897F",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_8ef90b15674c4c3591a2decdff44bacb",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u9646\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2e6e6646168743a181ad61a3b52f4c15",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u6C11\u7528\u7EA7IP\u6807\u8BC6\uFF0C\u56FD\u5916\u5EF6\u8FDF\u8F83\u9AD8\uFF1B\u8D44\u6E90\u7D27\u5F20\uFF0C\u7F3A\u8D27\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9",
          "id": "region_e48216f21e574791abd8d26fffcee953",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "8.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6179\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6170\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 9989,
          "name": "\u4F4F\u5B85",
          "parent_category": {
            "name": "\u6DF1\u5733",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_9df46a1f4258414b895dfe986e4dd43b",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u9646\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2e6e6646168743a181ad61a3b52f4c15",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u6C11\u7528\u7EA7IP\u6807\u8BC6\uFF0C\u56FD\u5916\u5EF6\u8FDF\u8F83\u9AD8\uFF1B\u8D44\u6E90\u7D27\u5F20\uFF0C\u7F3A\u8D27\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9",
          "id": "region_81bd6b727dc943358c70034b74bfa5aa",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "8.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6179\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6170\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 10019,
          "name": "\u7535\u4FE1",
          "parent_category": {
            "name": "\u4E0A\u6D77",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_ff60bbe1e16b49acab8b7eb0b9f6886a",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u9646\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2e6e6646168743a181ad61a3b52f4c15",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u6C11\u7528\u7EA7IP\u6807\u8BC6\uFF0C\u56FD\u5916\u5EF6\u8FDF\u8F83\u9AD8\uFF1B\u8D44\u6E90\u7D27\u5F20\uFF0C\u7F3A\u8D27\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9",
          "id": "region_de7c6d916fb847aab158aef02b918a66",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6179\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6170\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 10029,
          "name": "\u7535\u4FE1",
          "parent_category": {
            "name": "\u5E7F\u5DDE",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_37d24e91c59f4b4e9c037000bc2eaac0",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u9646\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2e6e6646168743a181ad61a3b52f4c15",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u7279\u6B8A\u5730\u57DF\uFF0C\u53EA\u5728\u4E2D\u56FD\u5927\u9646\u6CD5\u5B9A\u8282\u5047\u65E5\u6B63\u5E38\u5F00\u901A\uFF0C\u5176\u4F59\u5F00\u901A\u65F6\u95F4\u987A\u5EF6\u3002",
          "id": "region_f03c4bc3fb4f4c50860427db486c8a94",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "8.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6179\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6170\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 10039,
          "name": "\u7535\u4FE1",
          "parent_category": {
            "name": "\u4F5B\u5C71",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_66b0f5cb728f48b4aa2b2ae440452f30",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u9646\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2e6e6646168743a181ad61a3b52f4c15",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u6C11\u7528\u7EA7IP\u6807\u8BC6\uFF0C\u56FD\u5916\u5EF6\u8FDF\u8F83\u9AD8\uFF1B\u8D44\u6E90\u7D27\u5F20\uFF0C\u7F3A\u8D27\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9",
          "id": "region_eaca45f996fc4644bcfe49cf559e7ea2",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "8.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6179\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6170\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 10049,
          "name": "\u7535\u4FE1",
          "parent_category": {
            "name": "\u676D\u5DDE",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_78c47306566a41dbab6af5dce48a96c6",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u9646\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2e6e6646168743a181ad61a3b52f4c15",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u6C11\u7528\u7EA7IP\u6807\u8BC6\uFF0C\u56FD\u5916\u5EF6\u8FDF\u8F83\u9AD8\uFF1B\u8D44\u6E90\u7D27\u5F20\uFF0C\u7F3A\u8D27\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9",
          "id": "region_a4c446da58a543b9b1c4d5bc0e59141c",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "8.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6179\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6170\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 10059,
          "name": "\u8054\u901A",
          "parent_category": {
            "name": "\u5929\u6D25",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_d807ef960f114d84a23ad19b4062a38e",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u9646\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2e6e6646168743a181ad61a3b52f4c15",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_0753d0ff19c045e4a2ffdd83f1577d13",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": "8.7",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6260\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Amazon",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": false,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "eBay",
              "caption": "eBay",
              "support": false,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PayPal",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Shopee",
              "caption": "Shopee",
              "support": false,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Lazada",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Wish",
              "caption": "Wish",
              "support": false,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDiscount",
              "caption": "CDiscount",
              "support": false,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Joom",
              "caption": "Joom",
              "support": false,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Vova",
              "caption": "Vova",
              "support": false,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Walmart",
              "caption": "\u6C83\u5C14\u739B",
              "support": false,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Rakuten",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Ozon",
              "caption": "Ozon",
              "support": false,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FactoryMarket",
              "caption": "FactoryMarket",
              "support": false,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Alibaba",
              "caption": "Alibaba",
              "support": false,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Etsy",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMaTou",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "The Home Depot",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Target",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WayFair",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OpenSky",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Real",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AmazonVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AmazonAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 10069,
          "name": "\u7535\u4FE1",
          "parent_category": {
            "name": "\u9752\u5C9B",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_099197d85bd94083ad599dcbac399791",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u9646\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2e6e6646168743a181ad61a3b52f4c15",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u6C11\u7528\u7EA7IP\u6807\u8BC6\uFF0C\u56FD\u5916\u5EF6\u8FDF\u8F83\u9AD8\uFF1B\u8D44\u6E90\u7D27\u5F20\uFF0C\u7F3A\u8D27\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9",
          "id": "region_804801d132f04defb96248d9615e6cfa",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "8.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6179\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6170\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 10079,
          "name": "\u7535\u4FE1",
          "parent_category": {
            "name": "\u957F\u6C99",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_7f2d357978a4484c8011c796258a89f1",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u9646\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2e6e6646168743a181ad61a3b52f4c15",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u6C11\u7528\u7EA7IP\u6807\u8BC6\uFF0C\u56FD\u5916\u5EF6\u8FDF\u8F83\u9AD8\uFF1B\u8D44\u6E90\u7D27\u5F20\uFF0C\u7F3A\u8D27\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9",
          "id": "region_31390de8074341fc9659a3936841fda3",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "8.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6179\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6170\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 10089,
          "name": "\u7535\u4FE1",
          "parent_category": {
            "name": "\u798F\u5DDE",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_902461f684ab47269955973c182a8795",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u9646\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2e6e6646168743a181ad61a3b52f4c15",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u6C11\u7528\u7EA7IP\u6807\u8BC6\uFF0C\u56FD\u5916\u5EF6\u8FDF\u8F83\u9AD8\uFF1B\u8D44\u6E90\u7D27\u5F20\uFF0C\u7F3A\u8D27\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9",
          "id": "region_079a223f03184aa29e15f8bae9b5493a",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "8.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6179\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6170\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 10149,
          "name": "\u7535\u4FE1",
          "parent_category": {
            "name": "\u592A\u539F",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_fb35260cdeed4e35a792d8f588dcdfed",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u9646\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2e6e6646168743a181ad61a3b52f4c15",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u6C11\u7528\u7EA7IP\u6807\u8BC6\uFF0C\u56FD\u5916\u5EF6\u8FDF\u8F83\u9AD8\uFF1B\u8D44\u6E90\u7D27\u5F20\uFF0C\u7F3A\u8D27\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\u3002\u7981\u6B62\u6CE8\u518C\u56FD\u5185\u7535\u5546\u7F51\u7AD9",
          "id": "region_c57f5fae6e2447e6ba6213a0c7bb56a2",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "8.5",
              "price_description": null,
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": null,
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "8",
              "price_description": null,
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 10259,
          "name": "\u7535\u4FE1",
          "parent_category": {
            "name": "\u829C\u6E56",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_773756e0843242649adffaf780deb0fc",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u5927\u9646\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_2e6e6646168743a181ad61a3b52f4c15",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u6C11\u7528\u7EA7IP\u6807\u8BC6\uFF0C\u56FD\u5916\u5EF6\u8FDF\u8F83\u9AD8\uFF0C\u8D44\u6E90\u7D27\u5F20\uFF0C\u7F3A\u8D27\u60C5\u51B5\u4E0B\u5F00\u901A\u6709\u4E00\u5B9A\u5EF6\u65F6\uFF0C\u5982\u4E0D\u80FD\u7B49\u5F85\uFF0C\u8BF7\u8054\u7CFB\u552E\u524DQQ:498860365\u7533\u8BF7\u9000\u8D27\uFF0C\u7F51\u7EDC\u53D7\u56FD\u5BB6\u76D1\u7BA1\uFF0C\u8BF7\u5408\u6CD5\u5408\u89C4\u4F7F\u7528\u7F51\u7EDC\u3002",
          "id": "region_d2bd39f8b537439cbc846e04fc9c5277",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6189\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "PayPal(\u4E2D\u56FD)",
              "support": true,
              "sort": 9223372036854776e3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_bcbbac304d9f4336bb56b3a6e030b3f2",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_99b359aca2984f0ba8e91824da37daf6",
            "country_id": "region_country_1112067fc1ca46cda4ed23c9058a5109"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 10989,
          "name": "\u4F4F\u5B85",
          "parent_category": {
            "name": "\u9999\u6E2F",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_18e552557e13427c93db7429a48d519c",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E9A\u6D32\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_a91b8025c97b477b8553a8ab4185276b",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u4F4F\u5B85\u3001\u673A\u623F\u5171\u7528\uFF0C24-72\u5C0F\u65F6\u5185\u5F00\u901A\uFF0C\u7531\u4E8EIP\u8D44\u6E90\u7D27\u5F20\uFF0C\u8FC7\u671F\u53EA\u4FDD\u7559\u4E00\u5929\uFF0C\u4E0D\u6392\u9664\u8FDE\u53F7IP\u53EF\u80FD\uFF0C\u4E0D\u4FDD\u8BC1IP\u771F\u4EBA\u7387\uFF0C\u552E\u51FA\u6982\u4E0D\u9000\u6362\uFF0C\u5982\u60A8\u9700\u8981\u4FDD\u8BC1\u4E0D\u8FDE\u53F7\uFF0C\u5219\u5F00\u901A\u5468\u671F\u4F1A\u5EF6\u957F\uFF0C\u8BF7\u60A8\u8054\u7CFB\u552E\u540E\u5BA2\u670D\u786E\u8BA4\u3002",
          "id": "region_179898c5179d494fa54d65cbb195cf80",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6109\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_c2e0233c241a477bb2d50e1add0e204e",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_3604226b397c47a38f0973b7e3bf42d0",
            "country_id": "region_country_80a92523b0f44780832833f3b631e14a"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 10989,
          "name": "\u4F4F\u5B85",
          "parent_category": {
            "name": "\u8D8A\u5357",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_1534d3c5d8094427aca9cacb25a48136",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E9A\u6D32\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_a91b8025c97b477b8553a8ab4185276b",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u4F4F\u5B85\u3001\u673A\u623F\u5171\u7528\uFF0C24-72\u5C0F\u65F6\u5185\u5F00\u901A\uFF0C\u7531\u4E8EIP\u8D44\u6E90\u7D27\u5F20\uFF0C\u8FC7\u671F\u53EA\u4FDD\u7559\u4E00\u5929\uFF0C\u4E0D\u6392\u9664\u8FDE\u53F7IP\u53EF\u80FD\uFF0C\u4E0D\u4FDD\u8BC1IP\u771F\u4EBA\u7387\uFF0C\u552E\u51FA\u6982\u4E0D\u9000\u6362\uFF0C\u5982\u60A8\u9700\u8981\u4FDD\u8BC1\u4E0D\u8FDE\u53F7\uFF0C\u5219\u5F00\u901A\u5468\u671F\u4F1A\u5EF6\u957F\uFF0C\u8BF7\u60A8\u8054\u7CFB\u552E\u540E\u5BA2\u670D\u786E\u8BA4\u3002",
          "id": "region_150fc5ac14514f3580d2518f6fe3fbf3",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6109\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_ee7cb2c5d2b046d6a6fd5a46db682e16",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_36d08c8af6a647f0a1895f514908008b",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cdc"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 10989,
          "name": "\u4F4F\u5B85",
          "parent_category": {
            "name": "\u65E5\u672C",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_6da0f3d1b4e14727863ab68b8dd97e08",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E9A\u6D32\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_a91b8025c97b477b8553a8ab4185276b",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u4F4F\u5B85\u3001\u673A\u623F\u5171\u7528\uFF0C24-72\u5C0F\u65F6\u5185\u5F00\u901A\uFF0C\u7531\u4E8EIP\u8D44\u6E90\u7D27\u5F20\uFF0C\u8FC7\u671F\u53EA\u4FDD\u7559\u4E00\u5929\uFF0C\u4E0D\u6392\u9664\u8FDE\u53F7IP\u53EF\u80FD\uFF0C\u4E0D\u4FDD\u8BC1IP\u771F\u4EBA\u7387\uFF0C\u552E\u51FA\u6982\u4E0D\u9000\u6362\uFF0C\u5982\u60A8\u9700\u8981\u4FDD\u8BC1\u4E0D\u8FDE\u53F7\uFF0C\u5219\u5F00\u901A\u5468\u671F\u4F1A\u5EF6\u957F\uFF0C\u8BF7\u60A8\u8054\u7CFB\u552E\u540E\u5BA2\u670D\u786E\u8BA4\u3002",
          "id": "region_fe5563c532384c9d829ab090b699da19",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6109\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_eb7930b6628f45938b12cfa82d0d758f",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_1a4f2ebe8cb54a48aef9f1cb63d867b1",
            "country_id": "region_country_e4c55796367f4d3ea072e32340ebfb7c"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 11039,
          "name": "\u4F4F\u5B85",
          "parent_category": {
            "name": "\u571F\u8033\u5176",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_e046e60037a84519a3509481ce3b412c",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u4E9A\u6D32\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_a91b8025c97b477b8553a8ab4185276b",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u4F4F\u5B85\u3001\u673A\u623F\u5171\u7528\uFF0C24-72\u5C0F\u65F6\u5185\u5F00\u901A\uFF0C\u7531\u4E8EIP\u8D44\u6E90\u7D27\u5F20\uFF0C\u8FC7\u671F\u53EA\u4FDD\u7559\u4E00\u5929\uFF0C\u4E0D\u6392\u9664\u8FDE\u53F7IP\u53EF\u80FD\uFF0C\u4E0D\u4FDD\u8BC1IP\u771F\u4EBA\u7387\uFF0C\u552E\u51FA\u6982\u4E0D\u9000\u6362\uFF0C\u5982\u60A8\u9700\u8981\u4FDD\u8BC1\u4E0D\u8FDE\u53F7\uFF0C\u5219\u5F00\u901A\u5468\u671F\u4F1A\u5EF6\u957F\uFF0C\u8BF7\u60A8\u8054\u7CFB\u552E\u540E\u5BA2\u670D\u786E\u8BA4\u3002",
          "id": "region_2b6c85523fa44531a7c9e04fb6123183",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6109\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_47b8bba76ecf48bcb0e12ae773078a1d",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_602d7bedd10b416ebef1515d955de14d",
            "country_id": "region_country_d17d5e5f30034b6ab6f918a12e81a989"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 11989,
          "name": "\u4F4F\u5B85",
          "parent_category": {
            "name": "\u52A0\u62FF\u5927",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_17fdf975098c459ab0b9c999f715b199",
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6D77\u5916\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cba036bb5f8a4fc88420cadc17e8db67",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u4F4F\u5B85\u3001\u673A\u623F\u5171\u7528\uFF0C24-72\u5C0F\u65F6\u5185\u5F00\u901A\uFF0C\u7531\u4E8EIP\u8D44\u6E90\u7D27\u5F20\uFF0C\u8FC7\u671F\u53EA\u4FDD\u7559\u4E00\u5929\uFF0C\u4E0D\u6392\u9664\u8FDE\u53F7IP\u53EF\u80FD\uFF0C\u4E0D\u4FDD\u8BC1IP\u771F\u4EBA\u7387\uFF0C\u552E\u51FA\u6982\u4E0D\u9000\u6362\uFF0C\u5982\u60A8\u9700\u8981\u4FDD\u8BC1\u4E0D\u8FDE\u53F7\uFF0C\u5219\u5F00\u901A\u5468\u671F\u4F1A\u5EF6\u957F\uFF0C\u8BF7\u60A8\u8054\u7CFB\u552E\u540E\u5BA2\u670D\u786E\u8BA4\u3002",
          "id": "region_9b6fad9977374bb9a07510209f536f07",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6109\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Amazon",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": false,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "eBay",
              "caption": "eBay",
              "support": false,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PayPal",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Shopee",
              "caption": "Shopee",
              "support": false,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Lazada",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Wish",
              "caption": "Wish",
              "support": false,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDiscount",
              "caption": "CDiscount",
              "support": false,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Joom",
              "caption": "Joom",
              "support": false,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Vova",
              "caption": "Vova",
              "support": false,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Walmart",
              "caption": "\u6C83\u5C14\u739B",
              "support": false,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Rakuten",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Ozon",
              "caption": "Ozon",
              "support": false,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FactoryMarket",
              "caption": "FactoryMarket",
              "support": false,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Alibaba",
              "caption": "Alibaba",
              "support": false,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Etsy",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMaTou",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "The Home Depot",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Target",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WayFair",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OpenSky",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Real",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AmazonVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AmazonAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_c083f23050f744f1a98bbc68f9817674",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_837daeb3ab7d4934990349e57dfd24c8",
            "country_id": "region_country_e1cfb1f82f4d43a0a58492cfc75e2f52_1"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 11989,
          "name": "\u4F4F\u5B85",
          "parent_category": {
            "name": "\u65AF\u7279\u62C9\u65AF\u5821-\u6CD5\u56FD",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_e22ed5620aa84f85a778e5046ec2b187",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 0,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6D77\u5916\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cba036bb5f8a4fc88420cadc17e8db67",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u4F4F\u5B85\u3001\u673A\u623F\u5171\u7528\uFF0C24-72\u5C0F\u65F6\u5185\u5F00\u901A\uFF0C\u7531\u4E8EIP\u8D44\u6E90\u7D27\u5F20\uFF0C\u8FC7\u671F\u53EA\u4FDD\u7559\u4E00\u5929\uFF0C\u4E0D\u6392\u9664\u8FDE\u53F7IP\u53EF\u80FD\uFF0C\u4E0D\u4FDD\u8BC1IP\u771F\u4EBA\u7387\uFF0C\u552E\u51FA\u6982\u4E0D\u9000\u6362\uFF0C\u5982\u60A8\u9700\u8981\u4FDD\u8BC1\u4E0D\u8FDE\u53F7\uFF0C\u5219\u5F00\u901A\u5468\u671F\u4F1A\u5EF6\u957F\uFF0C\u8BF7\u60A8\u8054\u7CFB\u552E\u540E\u5BA2\u670D\u786E\u8BA4\u3002",
          "id": "region_6387aa6a642c4b7e80f10365145eb76a",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6109\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Amazon",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": false,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "eBay",
              "caption": "eBay",
              "support": false,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PayPal",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Shopee",
              "caption": "Shopee",
              "support": false,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Lazada",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Wish",
              "caption": "Wish",
              "support": false,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDiscount",
              "caption": "CDiscount",
              "support": false,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Joom",
              "caption": "Joom",
              "support": false,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Vova",
              "caption": "Vova",
              "support": false,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Walmart",
              "caption": "\u6C83\u5C14\u739B",
              "support": false,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Rakuten",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Ozon",
              "caption": "Ozon",
              "support": false,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FactoryMarket",
              "caption": "FactoryMarket",
              "support": false,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Alibaba",
              "caption": "Alibaba",
              "support": false,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Etsy",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMaTou",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "The Home Depot",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Target",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WayFair",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OpenSky",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Real",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AmazonVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AmazonAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cda"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 11989,
          "name": "\u4F4F\u5B85",
          "parent_category": {
            "name": "\u52A0\u5229\u798F\u5C3C\u4E9A",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_dd362fbef92146ec96ce430b63490818",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 69,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6D77\u5916\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cba036bb5f8a4fc88420cadc17e8db67",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": null,
          "id": "region_318a5a114dda453d810f22b0d0bdbc0c",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6109\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Amazon",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": false,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "eBay",
              "caption": "eBay",
              "support": false,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PayPal",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Shopee",
              "caption": "Shopee",
              "support": false,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Lazada",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Wish",
              "caption": "Wish",
              "support": false,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDiscount",
              "caption": "CDiscount",
              "support": false,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Joom",
              "caption": "Joom",
              "support": false,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Vova",
              "caption": "Vova",
              "support": false,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Walmart",
              "caption": "\u6C83\u5C14\u739B",
              "support": false,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Rakuten",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Ozon",
              "caption": "Ozon",
              "support": false,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FactoryMarket",
              "caption": "FactoryMarket",
              "support": false,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Alibaba",
              "caption": "Alibaba",
              "support": false,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Etsy",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMaTou",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "The Home Depot",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Target",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WayFair",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OpenSky",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Real",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AmazonVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AmazonAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_40a9c9528ba340148c700570c4de1570",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_2db5c29606724bce9cf4db852f4b298b",
            "country_id": "region_country_d9ebb3edfab9452f817974396160daf2"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 11989,
          "name": "\u4F4F\u5B85",
          "parent_category": {
            "name": "\u82AC\u5170",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_bd0a01f79bd249b9b375ea3af5fe1393",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6D77\u5916\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cba036bb5f8a4fc88420cadc17e8db67",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u4F4F\u5B85\u3001\u673A\u623F\u5171\u7528\uFF0C24-72\u5C0F\u65F6\u5185\u5F00\u901A\uFF0C\u7531\u4E8EIP\u8D44\u6E90\u7D27\u5F20\uFF0C\u8FC7\u671F\u53EA\u4FDD\u7559\u4E00\u5929\uFF0C\u4E0D\u6392\u9664\u8FDE\u53F7IP\u53EF\u80FD\uFF0C\u4E0D\u4FDD\u8BC1IP\u771F\u4EBA\u7387\uFF0C\u552E\u51FA\u6982\u4E0D\u9000\u6362\uFF0C\u5982\u60A8\u9700\u8981\u4FDD\u8BC1\u4E0D\u8FDE\u53F7\uFF0C\u5219\u5F00\u901A\u5468\u671F\u4F1A\u5EF6\u957F\uFF0C\u8BF7\u60A8\u8054\u7CFB\u552E\u540E\u5BA2\u670D\u786E\u8BA4\u3002",
          "id": "region_1df5b83dda0546faaebece14add617ba",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6109\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Amazon",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": false,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "eBay",
              "caption": "eBay",
              "support": false,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PayPal",
              "caption": "PayPal",
              "support": false,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Shopee",
              "caption": "Shopee",
              "support": false,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Lazada",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Wish",
              "caption": "Wish",
              "support": false,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDiscount",
              "caption": "CDiscount",
              "support": false,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Joom",
              "caption": "Joom",
              "support": false,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Vova",
              "caption": "Vova",
              "support": false,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Walmart",
              "caption": "\u6C83\u5C14\u739B",
              "support": false,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Rakuten",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Ozon",
              "caption": "Ozon",
              "support": false,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FactoryMarket",
              "caption": "FactoryMarket",
              "support": false,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Alibaba",
              "caption": "Alibaba",
              "support": false,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Etsy",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMaTou",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "The Home Depot",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Target",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WayFair",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OpenSky",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "Real",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AmazonVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AmazonAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_e5e654f51e14404e8e4e7862c9c3516e",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_9dfe5d486d8046368588bdfdb3f3d4c2",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cdf"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 11999,
          "name": "\u4F4F\u5B85",
          "parent_category": {
            "name": "\u82F1\u56FD",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_ca3c8a96fe814f489ee92a4c06e89608",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6D77\u5916\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cba036bb5f8a4fc88420cadc17e8db67",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u4F4F\u5B85\u3001\u673A\u623F\u5171\u7528\uFF0C24-72\u5C0F\u65F6\u5185\u5F00\u901A\uFF0C\u7531\u4E8EIP\u8D44\u6E90\u7D27\u5F20\uFF0C\u8FC7\u671F\u53EA\u4FDD\u7559\u4E00\u5929\uFF0C\u4E0D\u6392\u9664\u8FDE\u53F7IP\u53EF\u80FD\uFF0C\u4E0D\u4FDD\u8BC1IP\u771F\u4EBA\u7387\uFF0C\u552E\u51FA\u6982\u4E0D\u9000\u6362\uFF0C\u5982\u60A8\u9700\u8981\u4FDD\u8BC1\u4E0D\u8FDE\u53F7\uFF0C\u5219\u5F00\u901A\u5468\u671F\u4F1A\u5EF6\u957F\uFF0C\u8BF7\u60A8\u8054\u7CFB\u552E\u540E\u5BA2\u670D\u786E\u8BA4\u3002",
          "id": "region_72def74b480a41e2825c56fd8e409313",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6109\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6109\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6103\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA698\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": false,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_f4272cafe1d6451ea560458c9f11b640",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cda"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 12009,
          "name": " \u4F4F\u5B85",
          "parent_category": {
            "name": "\u7F8E\u56FD-\u7EBD\u7EA6",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_45baac6aa9b54ef7a7a53c1cae6e8eda",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 69,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6D77\u5916\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cba036bb5f8a4fc88420cadc17e8db67",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u4F4F\u5B85\u3001\u673A\u623F\u5171\u7528\uFF0C24-72\u5C0F\u65F6\u5185\u5F00\u901A\uFF0C\u7531\u4E8EIP\u8D44\u6E90\u7D27\u5F20\uFF0C\u8FC7\u671F\u53EA\u4FDD\u7559\u4E00\u5929\uFF0C\u4E0D\u6392\u9664\u8FDE\u53F7IP\u53EF\u80FD\uFF0C\u4E0D\u4FDD\u8BC1IP\u771F\u4EBA\u7387\uFF0C\u552E\u51FA\u6982\u4E0D\u9000\u6362\uFF0C\u5982\u60A8\u9700\u8981\u4FDD\u8BC1\u4E0D\u8FDE\u53F7\uFF0C\u5219\u5F00\u901A\u5468\u671F\u4F1A\u5EF6\u957F\uFF0C\u8BF7\u60A8\u8054\u7CFB\u552E\u540E\u5BA2\u670D\u786E\u8BA4\u3002",
          "id": "region_72ef5758505c4a95b698bac80f703c82",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6109\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cda"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 12019,
          "name": "\u4F4F\u5B85",
          "parent_category": {
            "name": "\u7F8E\u56FD-\u6D1B\u6749\u77F6",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_f4ba5ffa6abf401995b4c70d5263be7f",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6D77\u5916\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cba036bb5f8a4fc88420cadc17e8db67",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u4F4F\u5B85\u3001\u673A\u623F\u5171\u7528\uFF0C24-72\u5C0F\u65F6\u5185\u5F00\u901A\uFF0C\u7531\u4E8EIP\u8D44\u6E90\u7D27\u5F20\uFF0C\u8FC7\u671F\u53EA\u4FDD\u7559\u4E00\u5929\uFF0C\u4E0D\u6392\u9664\u8FDE\u53F7IP\u53EF\u80FD\uFF0C\u4E0D\u4FDD\u8BC1IP\u771F\u4EBA\u7387\uFF0C\u552E\u51FA\u6982\u4E0D\u9000\u6362\uFF0C\u5982\u60A8\u9700\u8981\u4FDD\u8BC1\u4E0D\u8FDE\u53F7\uFF0C\u5219\u5F00\u901A\u5468\u671F\u4F1A\u5EF6\u957F\uFF0C\u8BF7\u60A8\u8054\u7CFB\u552E\u540E\u5BA2\u670D\u786E\u8BA4\u3002",
          "id": "region_f6b1619fd3924e51a54ff1b43bb41b81",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6109\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_2688b867b93044449d8768748d3ebf6b",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_624bfb637a04426b8cf6cf394f03090c",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cdb"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 12029,
          "name": "\u4F4F\u5B85",
          "parent_category": {
            "name": "\u8377\u5170",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_056ada69c7e64efaa9a8f128591d6b94",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6D77\u5916\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cba036bb5f8a4fc88420cadc17e8db67",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u4F4F\u5B85\u3001\u673A\u623F\u5171\u7528\uFF0C24-72\u5C0F\u65F6\u5185\u5F00\u901A\uFF0C\u7531\u4E8EIP\u8D44\u6E90\u7D27\u5F20\uFF0C\u8FC7\u671F\u53EA\u4FDD\u7559\u4E00\u5929\uFF0C\u4E0D\u6392\u9664\u8FDE\u53F7IP\u53EF\u80FD\uFF0C\u4E0D\u4FDD\u8BC1IP\u771F\u4EBA\u7387\uFF0C\u552E\u51FA\u6982\u4E0D\u9000\u6362\uFF0C\u5982\u60A8\u9700\u8981\u4FDD\u8BC1\u4E0D\u8FDE\u53F7\uFF0C\u5219\u5F00\u901A\u5468\u671F\u4F1A\u5EF6\u957F\uFF0C\u8BF7\u60A8\u8054\u7CFB\u552E\u540E\u5BA2\u670D\u786E\u8BA4\u3002",
          "id": "region_2af219ebd3964c3e808089b49f80d020",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6109\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_d83bd507733a4ae88b7a2d51f7032e74",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_4ea8b8cd97e54d4fa0e8b0f01d7ec87c",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cde"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 12039,
          "name": "\u4F4F\u5B85",
          "parent_category": {
            "name": "\u5FB7\u56FD-\u6CD5\u5170\u514B\u798F",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_65a9798d28174f4e84d70e4e2d82b445",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6D77\u5916\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cba036bb5f8a4fc88420cadc17e8db67",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u4F4F\u5B85\u3001\u673A\u623F\u5171\u7528\uFF0C24-72\u5C0F\u65F6\u5185\u5F00\u901A\uFF0C\u7531\u4E8EIP\u8D44\u6E90\u7D27\u5F20\uFF0C\u8FC7\u671F\u53EA\u4FDD\u7559\u4E00\u5929\uFF0C\u4E0D\u6392\u9664\u8FDE\u53F7IP\u53EF\u80FD\uFF0C\u4E0D\u4FDD\u8BC1IP\u771F\u4EBA\u7387\uFF0C\u552E\u51FA\u6982\u4E0D\u9000\u6362\uFF0C\u5982\u60A8\u9700\u8981\u4FDD\u8BC1\u4E0D\u8FDE\u53F7\uFF0C\u5219\u5F00\u901A\u5468\u671F\u4F1A\u5EF6\u957F\uFF0C\u8BF7\u60A8\u8054\u7CFB\u552E\u540E\u5BA2\u670D\u786E\u8BA4\u3002",
          "id": "region_a1dd2c2525f84fb7b7b2e65c29010c35",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6109\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6109\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6103\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA698\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_59127c59ef5c429cb8e9823b0d86c816",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_b1cddf64968947a69619f7c53f9bab81",
            "country_id": "region_country_6c22ff1540e9419f94109e92ba3372c7"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 12049,
          "name": "GCORE",
          "parent_category": {
            "name": "\u6089\u5C3C-\u6FB3\u5927\u5229\u4E9A",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_690c1eae3b6b470aadca3937ea64c274",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6D77\u5916\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cba036bb5f8a4fc88420cadc17e8db67",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u4F4F\u5B85\u3001\u673A\u623F\u5171\u7528\uFF0C24-72\u5C0F\u65F6\u5185\u5F00\u901A\uFF0C\u7531\u4E8EIP\u8D44\u6E90\u7D27\u5F20\uFF0C\u8FC7\u671F\u53EA\u4FDD\u7559\u4E00\u5929\uFF0C\u4E0D\u6392\u9664\u8FDE\u53F7IP\u53EF\u80FD\uFF0C\u4E0D\u4FDD\u8BC1IP\u771F\u4EBA\u7387\uFF0C\u552E\u51FA\u6982\u4E0D\u9000\u6362\uFF0C\u5982\u60A8\u9700\u8981\u4FDD\u8BC1\u4E0D\u8FDE\u53F7\uFF0C\u5219\u5F00\u901A\u5468\u671F\u4F1A\u5EF6\u957F\uFF0C\u8BF7\u60A8\u8054\u7CFB\u552E\u540E\u5BA2\u670D\u786E\u8BA4\u3002",
          "id": "region_7d3864346c5a4b059e0b98a478d74af4",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6129\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_f4272cafe1d6451ea560458c9f11b640",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cda"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 12069,
          "name": "GREEN",
          "parent_category": {
            "name": "\u7F8E\u56FD-\u4F5B\u7F57\u91CC\u8FBE",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_2b196e59f13549d8b06a50646ed0c6ce",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6D77\u5916\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cba036bb5f8a4fc88420cadc17e8db67",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u4F4F\u5B85\u3001\u673A\u623F\u5171\u7528\uFF0C24-72\u5C0F\u65F6\u5185\u5F00\u901A\uFF0C\u7531\u4E8EIP\u8D44\u6E90\u7D27\u5F20\uFF0C\u8FC7\u671F\u53EA\u4FDD\u7559\u4E00\u5929\uFF0C\u4E0D\u6392\u9664\u8FDE\u53F7IP\u53EF\u80FD\uFF0C\u4E0D\u4FDD\u8BC1IP\u771F\u4EBA\u7387\uFF0C\u552E\u51FA\u6982\u4E0D\u9000\u6362\uFF0C\u5982\u60A8\u9700\u8981\u4FDD\u8BC1\u4E0D\u8FDE\u53F7\uFF0C\u5219\u5F00\u901A\u5468\u671F\u4F1A\u5EF6\u957F\uFF0C\u8BF7\u60A8\u8054\u7CFB\u552E\u540E\u5BA2\u670D\u786E\u8BA4\u3002",
          "id": "region_a9446cb72c8c42b889daa646005ed5a5",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6109\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_f4272cafe1d6451ea560458c9f11b640",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
            "country_id": "region_country_7b2ea6852b434e0fa513dff8cbc02cda"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 12079,
          "name": "GCORE",
          "parent_category": {
            "name": "\u7F8E\u56FD-\u8FC8\u963F\u5BC6",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_4b83f61668cd4817b5063b70182f948a",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6D77\u5916\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cba036bb5f8a4fc88420cadc17e8db67",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u4F4F\u5B85\u3001\u673A\u623F\u5171\u7528\uFF0C24-72\u5C0F\u65F6\u5185\u5F00\u901A\uFF0C\u7531\u4E8EIP\u8D44\u6E90\u7D27\u5F20\uFF0C\u8FC7\u671F\u53EA\u4FDD\u7559\u4E00\u5929\uFF0C\u4E0D\u6392\u9664\u8FDE\u53F7IP\u53EF\u80FD\uFF0C\u4E0D\u4FDD\u8BC1IP\u771F\u4EBA\u7387\uFF0C\u552E\u51FA\u6982\u4E0D\u9000\u6362\uFF0C\u5982\u60A8\u9700\u8981\u4FDD\u8BC1\u4E0D\u8FDE\u53F7\uFF0C\u5219\u5F00\u901A\u5468\u671F\u4F1A\u5EF6\u957F\uFF0C\u8BF7\u60A8\u8054\u7CFB\u552E\u540E\u5BA2\u670D\u786E\u8BA4\u3002",
          "id": "region_6daf04b4a0ee4d57bcaadb5da8531109",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6109\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_11fd6ce44fc74516910a1254d9d78963",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_f76c05efe97444f4833ae0d1f2481f45",
            "country_id": "region_country_1693842519a24d709f06754fdb65365c"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 12089,
          "name": "\u4F4F\u5B85",
          "parent_category": {
            "name": "\u897F\u73ED\u7259-\u9A6C\u5FB7\u91CC",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_52a5d9c0189f4584a71df6b2f3beba35",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6D77\u5916\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cba036bb5f8a4fc88420cadc17e8db67",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u4F4F\u5B85\u3001\u673A\u623F\u5171\u7528\uFF0C24-72\u5C0F\u65F6\u5185\u5F00\u901A\uFF0C\u7531\u4E8EIP\u8D44\u6E90\u7D27\u5F20\uFF0C\u8FC7\u671F\u53EA\u4FDD\u7559\u4E00\u5929\uFF0C\u4E0D\u6392\u9664\u8FDE\u53F7IP\u53EF\u80FD\uFF0C\u4E0D\u4FDD\u8BC1IP\u771F\u4EBA\u7387\uFF0C\u552E\u51FA\u6982\u4E0D\u9000\u6362\uFF0C\u5982\u60A8\u9700\u8981\u4FDD\u8BC1\u4E0D\u8FDE\u53F7\uFF0C\u5219\u5F00\u901A\u5468\u671F\u4F1A\u5EF6\u957F\uFF0C\u8BF7\u60A8\u8054\u7CFB\u552E\u540E\u5BA2\u670D\u786E\u8BA4\u3002",
          "id": "region_4784a6f2990d483bb97dfbd0d073a27a",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6109\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6109\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": null,
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": null,
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": false,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_b5b46f98b0464135b4787eb90362d0be",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_2cd49cc5c502412aa0c0721f92a7e9b9",
            "country_id": "region_country_459927a388154ed3966bad3cfd643ede"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 12099,
          "name": "TRX",
          "parent_category": {
            "name": "\u58A8\u897F\u54E5",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_de96145a1b844214a63ec16bf1c26abf",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6D77\u5916\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cba036bb5f8a4fc88420cadc17e8db67",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u4F4F\u5B85\u3001\u673A\u623F\u5171\u7528\uFF0C24-72\u5C0F\u65F6\u5185\u5F00\u901A\uFF0C\u7531\u4E8EIP\u8D44\u6E90\u7D27\u5F20\uFF0C\u8FC7\u671F\u53EA\u4FDD\u7559\u4E00\u5929\uFF0C\u4E0D\u6392\u9664\u8FDE\u53F7IP\u53EF\u80FD\uFF0C\u4E0D\u4FDD\u8BC1IP\u771F\u4EBA\u7387\uFF0C\u552E\u51FA\u6982\u4E0D\u9000\u6362\uFF0C\u5982\u60A8\u9700\u8981\u4FDD\u8BC1\u4E0D\u8FDE\u53F7\uFF0C\u5219\u5F00\u901A\u5468\u671F\u4F1A\u5EF6\u957F\uFF0C\u8BF7\u60A8\u8054\u7CFB\u552E\u540E\u5BA2\u670D\u786E\u8BA4\u3002",
          "id": "region_55cf603fb5334b2482757b45e48e7338",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6159\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_c083f23050f744f1a98bbc68f9817674",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_837daeb3ab7d4934990349e57dfd24c8",
            "country_id": "region_country_e1cfb1f82f4d43a0a58492cfc75e2f52_1"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 12109,
          "name": "\u4F4F\u5B85",
          "parent_category": {
            "name": "\u6CD5\u56FD-\u5DF4\u9ECE",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_232b5ec2fdc6460c9e03db316f3717fd",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6D77\u5916\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cba036bb5f8a4fc88420cadc17e8db67",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u4F4F\u5B85\u3001\u673A\u623F\u5171\u7528\uFF0C24-72\u5C0F\u65F6\u5185\u5F00\u901A\uFF0C\u7531\u4E8EIP\u8D44\u6E90\u7D27\u5F20\uFF0C\u8FC7\u671F\u53EA\u4FDD\u7559\u4E00\u5929\uFF0C\u4E0D\u6392\u9664\u8FDE\u53F7IP\u53EF\u80FD\uFF0C\u4E0D\u4FDD\u8BC1IP\u771F\u4EBA\u7387\uFF0C\u552E\u51FA\u6982\u4E0D\u9000\u6362\uFF0C\u5982\u60A8\u9700\u8981\u4FDD\u8BC1\u4E0D\u8FDE\u53F7\uFF0C\u5219\u5F00\u901A\u5468\u671F\u4F1A\u5EF6\u957F\uFF0C\u8BF7\u60A8\u8054\u7CFB\u552E\u540E\u5BA2\u670D\u786E\u8BA4\u3002",
          "id": "region_4147c4c435e343fda5c684bd1ce4aeca",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6109\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            },
            {
              "visible": true,
              "discount_tag": "9.8",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6109\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_0ba648abede741c4b833eafa1b42b360",
              "spec_name": "1\u4E2A\u5B63\u5EA6"
            },
            {
              "visible": true,
              "discount_tag": "9.5",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6103\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_7c64c2cabbb04b219632a044555898e3",
              "spec_name": "\u534A\u5E74"
            },
            {
              "visible": true,
              "discount_tag": "9",
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA698\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_862369c629734263b23bfd9309b9821e",
              "spec_name": "1\u5E74"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_ae7a33ab1517499089938533ef57cfbc",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_0273490b067845d3a1191432a65ce579",
            "country_id": "region_country_9a5708cb4acb47c8b10b888da58d2274"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 12119,
          "name": "GCORE",
          "parent_category": {
            "name": "\u6CE2\u5170",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_0e223af510be45a890dc91c136a10e83",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6D77\u5916\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cba036bb5f8a4fc88420cadc17e8db67",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u4F4F\u5B85\u3001\u673A\u623F\u5171\u7528\uFF0C24-72\u5C0F\u65F6\u5185\u5F00\u901A\uFF0C\u7531\u4E8EIP\u8D44\u6E90\u7D27\u5F20\uFF0C\u8FC7\u671F\u53EA\u4FDD\u7559\u4E00\u5929\uFF0C\u4E0D\u6392\u9664\u8FDE\u53F7IP\u53EF\u80FD\uFF0C\u4E0D\u4FDD\u8BC1IP\u771F\u4EBA\u7387\uFF0C\u552E\u51FA\u6982\u4E0D\u9000\u6362\uFF0C\u5982\u60A8\u9700\u8981\u4FDD\u8BC1\u4E0D\u8FDE\u53F7\uFF0C\u5219\u5F00\u901A\u5468\u671F\u4F1A\u5EF6\u957F\uFF0C\u8BF7\u60A8\u8054\u7CFB\u552E\u540E\u5BA2\u670D\u786E\u8BA4\u3002",
          "id": "region_6896e3798b29432ea046183ac2d72317",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6109\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        },
        {
          "default_selection": {
            "timezone_id": "region_timezone_cc0a386307f04adaa6151ced926504c5",
            "model": "payment.virtualdesktop.options.create.region_default_selection",
            "language_id": "region_language_4357a256541e43658c9cb73c2c8a98e9",
            "country_id": "region_country_da9dcc373e2f48839f6a81020c908878"
          },
          "show_auto_renew": true,
          "marks": {
            "model": "tags",
            "tags": [
              "FOREIGN",
              "DEFAULT_SELECTED"
            ]
          },
          "show_auto_timezone": false,
          "risk_level": 1,
          "sortValue": 12129,
          "name": "\u4F4F\u5B85",
          "parent_category": {
            "name": "\u610F\u5927\u5229",
            "model": "payment.virtualdesktop.options.create.parent_region",
            "id": "ip_region_66f1816d42ca4748aeaf588f5b98dea6",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "limit": {
            "min": 1,
            "max": 100,
            "model": "payment.virtualdesktop.options.create.buy_limit"
          },
          "top_category": {
            "is_new": false,
            "is_recommend": false,
            "name": "\u6D77\u5916\u4F4F\u5B85",
            "model": "payment.virtualdesktop.options.create.top_region",
            "id": "ip_region_cba036bb5f8a4fc88420cadc17e8db67",
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          "model": "payment.virtualdesktop.options.create.region",
          "comment": "\u4F4F\u5B85\u3001\u673A\u623F\u5171\u7528\uFF0C24-72\u5C0F\u65F6\u5185\u5F00\u901A\uFF0C\u7531\u4E8EIP\u8D44\u6E90\u7D27\u5F20\uFF0C\u8FC7\u671F\u53EA\u4FDD\u7559\u4E00\u5929\uFF0C\u4E0D\u6392\u9664\u8FDE\u53F7IP\u53EF\u80FD\uFF0C\u4E0D\u4FDD\u8BC1IP\u771F\u4EBA\u7387\uFF0C\u552E\u51FA\u6982\u4E0D\u9000\u6362\uFF0C\u5982\u60A8\u9700\u8981\u4FDD\u8BC1\u4E0D\u8FDE\u53F7\uFF0C\u5219\u5F00\u901A\u5468\u671F\u4F1A\u5EF6\u957F\uFF0C\u8BF7\u60A8\u8054\u7CFB\u552E\u540E\u5BA2\u670D\u786E\u8BA4\u3002",
          "id": "region_463b487916b6470f9359777ed026468d",
          "stock": {
            "model": "payment.virtualdesktop.options.create.goods_stock",
            "goods_stock_left": -1
          },
          "goods_spec": [
            {
              "visible": true,
              "discount_tag": null,
              "price_description": "\u5B9A\u4EF7\u5305\u542B\uFF1A\u7EA6109\u5143/\u6708=1\u4E2A\u4E3B\u8D26\u53F7\uFF08WEB\u7AEF\u76D1\u63A7\u7BA1\u7406\uFF09+\u98CE\u63A7\u7CFB\u7EDF+\u65E5\u5FD7\u7CFB\u7EDF+\u6743\u9650\u7CFB\u7EDF+\u9ED1\u767D\u540D\u5355+1\u4E2A\u56FA\u5B9AIP+1\u4E2AVD\u7CFB\u7EDF\uFF08\u53EF\u81EA\u5B9A\u4E49\u64CD\u4F5C\u7CFB\u7EDF\uFF0C\u6D4F\u89C8\u5668\uFF09\n7*12\u5C0F\u65F6\u6280\u672F\u652F\u6301\uFF08\u65E99-\u665A21\u70B9\uFF09+\u540E\u671F\u529F\u80FD\u514D\u8D39\u5347\u7EA7\u7EF4\u62A4+ \u5FAE\u4FE1 VIP\u5BA2\u670D\u3002\u6CE8\u610F\uFF1A\u540C\u4E3B\u8D26\u53F7\u4E0B\u8D2D\u4E70\u591A\u4E2AVD\u4E0D\u63D0\u4F9B\u9664\u4E86VD\u548C\u56FA\u5B9AIP\u4EE5\u5916\u670D\u52A1\u7684\u7D2F\u52A0\u3002",
              "model": "payment.virtualdesktop.goods.Spec",
              "id": "goods_spec_58d69c54afd84f04a407fed8d248d00c",
              "spec_name": "1\u4E2A\u6708"
            }
          ],
          "ebusinesses": [
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZON",
              "caption": "\u4E9A\u9A6C\u900A",
              "support": true,
              "sort": -2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "EBAY",
              "caption": "eBay",
              "support": true,
              "sort": 0
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "PAYPAL",
              "caption": "PayPal",
              "support": true,
              "sort": 2
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "SHOPEE",
              "caption": "Shopee",
              "support": true,
              "sort": 3
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "LAZADA",
              "caption": "Lazada",
              "support": true,
              "sort": 5
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WISH",
              "caption": "Wish",
              "support": true,
              "sort": 6
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "CDISCOUNT",
              "caption": "CDiscount",
              "support": true,
              "sort": 7
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "JOOM",
              "caption": "Joom",
              "support": true,
              "sort": 8
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "VOVA",
              "caption": "Vova",
              "support": true,
              "sort": 9
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WALMART",
              "caption": "\u6C83\u5C14\u739B",
              "support": true,
              "sort": 10
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "RAKUTEN",
              "caption": "\u4E50\u5929",
              "support": false,
              "sort": 11
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OZON",
              "caption": "Ozon",
              "support": true,
              "sort": 12
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "FACTORYMARKET",
              "caption": "FactoryMarket",
              "support": true,
              "sort": 13
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ALIBABA",
              "caption": "Alibaba",
              "support": true,
              "sort": 26
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "ETSY",
              "caption": "Etsy",
              "support": false,
              "sort": 32
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "YMATOU",
              "caption": "\u6D0B\u7801\u5934",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "THE HOME DEPOT",
              "caption": "\u5BB6\u5F97\u5B9D",
              "support": true,
              "sort": 36
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "TARGET",
              "caption": "Target",
              "support": true,
              "sort": 37
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "WAYFAIR",
              "caption": "WayFair",
              "support": true,
              "sort": 38
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "OPENSKY",
              "caption": "OpenSky",
              "support": true,
              "sort": 39
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "REAL",
              "caption": "Real",
              "support": true,
              "sort": 40
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONVC",
              "caption": "\u4E9A\u9A6C\u900AVC",
              "support": false,
              "sort": 108
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "AMAZONAMS",
              "caption": "\u4E9A\u9A6C\u900AAMS",
              "support": false,
              "sort": 109
            },
            {
              "model": "payment.virtualdesktop.options.create.support_ebusiness_platform",
              "code": "",
              "caption": "\u5176\u5B83\u5E73\u53F0",
              "support": true,
              "sort": 9223372036854776e3
            }
          ]
        }
      ],
      "languages": [
        {
          "name": "\u963F\u5C14\u5DF4\u5C3C\u4E9A\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_a213495e6818424a85c81c2677c84e45"
        },
        {
          "name": "\u963F\u62C9\u4F2F\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_39e7914263a84f529540a38fd51a8108"
        },
        {
          "name": "\u963F\u62C9\u8D21\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_87ad75c14b184b6ea73bb7b95af26c66"
        },
        {
          "name": "\u963F\u59C6\u54C8\u62C9\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_4be408fff3324f62a185bc55e0289557"
        },
        {
          "name": "\u963F\u585E\u62DC\u7586\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_b6697707be7a493f97bce313342a59ee"
        },
        {
          "name": "\u963F\u65AF\u56FE\u91CC\u4E9A\u65AF\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_eb604bee3cbe4f959e88e6eaf9cdc3fe"
        },
        {
          "name": "\u7231\u5C14\u5170\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_7e1d803ee8254eb79fd89ad6c51217fb"
        },
        {
          "name": "\u7231\u6C99\u5C3C\u4E9A\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_5b24dc9df70e4eafb92975153de400bb"
        },
        {
          "name": "\u5965\u514B\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_46fe027dfe1a412388867a2c0c36a627"
        },
        {
          "name": "\u5965\u91CC\u4E9A\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_2d8d97c446f44cd4bb7bfb26d9bdf4b6"
        },
        {
          "name": "\u5965\u7F57\u83AB\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_7ef6271e5a1d4811a4a6f2f0c4806f64"
        },
        {
          "name": "\u5DF4\u65AF\u514B\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_9aba6f5ec7cc4bb98d753de814a063d7"
        },
        {
          "name": "\u767D\u4FC4\u7F57\u65AF\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_d25421dd4b774fdb99420ecbc084d193"
        },
        {
          "name": "\u4FDD\u52A0\u5229\u4E9A\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_d341d0f6567a42f0ac2ce068afc334c1"
        },
        {
          "name": "\u51B0\u5C9B\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_b664af93eaf749308abe678e4d51c0a7"
        },
        {
          "name": "\u6CE2\u5170\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_0273490b067845d3a1191432a65ce579"
        },
        {
          "name": "\u6CE2\u65AF\u5C3C\u4E9A\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_dd7a575a2391445d80040d7034d3fd72"
        },
        {
          "name": "\u6CE2\u65AF\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_0bd9ba4a93c449919bb94e7ce07987cb"
        },
        {
          "name": "\u5E03\u5217\u5854\u5C3C\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_857672ca47a14199aa2d0ac61d676ac0"
        },
        {
          "name": "\u9791\u977C\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_608637b8f22a48f6a5b1a7cb62cd8fc4"
        },
        {
          "name": "\u4E39\u9EA6\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_adc07e8a22d940fba8fc891fc837ab4e"
        },
        {
          "name": "\u5FB7\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_1447d2b0a5f7445b95dfd9ef696198ff"
        },
        {
          "name": "\u5FB7\u8BED\uFF08\u5965\u5730\u5229\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_a5c1d7cc7ec9450b87566578b067ef66"
        },
        {
          "name": "\u5FB7\u8BED\uFF08\u5FB7\u56FD\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_4ea8b8cd97e54d4fa0e8b0f01d7ec87c"
        },
        {
          "name": "\u5FB7\u8BED\uFF08\u5217\u652F\u6566\u58EB\u767B\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_23ddfde452174d34add566f2ccfdb8b1"
        },
        {
          "name": "\u5FB7\u8BED\uFF08\u745E\u58EB\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_36b54e83cdde4e36a0d97230f516b92d"
        },
        {
          "name": "\u4FC4\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_bfe5ef59a4c64a5a8882fdf016596886"
        },
        {
          "name": "\u6CD5\u7F57\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_af8d4c305ac145128a54ebab5393f69c"
        },
        {
          "name": "\u6CD5\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_aafddda8458c4bf7a99020514a358fc9"
        },
        {
          "name": "\u6CD5\u8BED\uFF08\u6CD5\u56FD\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_837daeb3ab7d4934990349e57dfd24c8"
        },
        {
          "name": "\u6CD5\u8BED\uFF08\u52A0\u62FF\u5927\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_7912a20c8cb347beb67748d911dd12d6"
        },
        {
          "name": "\u6CD5\u8BED\uFF08\u745E\u58EB\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_161b8110d7b84c40af3000018c88e9a5"
        },
        {
          "name": "\u83F2\u5F8B\u5BBE\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_8734352e961a413088023bee953cd2ce"
        },
        {
          "name": "\u82AC\u5170\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_2db5c29606724bce9cf4db852f4b298b"
        },
        {
          "name": "\u9AD8\u68C9\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_a2662fa1a2ce44c78bd718be493c8d57"
        },
        {
          "name": "\u683C\u9C81\u5409\u4E9A\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_00ec3612cb224ae0a425c4d8a673d37c"
        },
        {
          "name": "\u53E4\u5409\u62C9\u7279\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_cca6e6737be14b7ba3f8322b7e0857c2"
        },
        {
          "name": "\u74DC\u62C9\u5C3C\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_eabf42a051e14273a97f326e28a0a833"
        },
        {
          "name": "\u56FD\u9645\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_2320c93b1e574bfe9ef9a389bc514063"
        },
        {
          "name": "\u54C8\u8428\u514B\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_2491604b51b347c7bc9589a8a38f0bda"
        },
        {
          "name": "\u6D77\u5730\u514B\u91CC\u5965\u5C14\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_c1ffa2678d4d4ae9b6467082bea137a6"
        },
        {
          "name": "\u97E9\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_bfa74bdf98c34104ba30c9ccf9f8d373"
        },
        {
          "name": "\u8C6A\u8428\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_568ceabe94a24208a8efa66331db7023"
        },
        {
          "name": "\u8377\u5170\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_624bfb637a04426b8cf6cf394f03090c"
        },
        {
          "name": "\u52A0\u5229\u897F\u4E9A\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_77e2baa2f7904b058928e199795b0ec6"
        },
        {
          "name": "\u52A0\u6CF0\u7F57\u5C3C\u4E9A\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_fc0aa3b905fe4e1ea6e53d7fc0ed8e74"
        },
        {
          "name": "\u6377\u514B\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_fd7ce1cb351846f9951166640f96ad54"
        },
        {
          "name": "\u5361\u7EB3\u8FBE\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_3bb6d48710f7433e8ced9a96c3b57045"
        },
        {
          "name": "\u67EF\u5C14\u514B\u5B5C\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_a27f115301034a60a7e63f69f14ce079"
        },
        {
          "name": "\u79D1\u8428\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_88fd06ee670c4065b44b508854720386"
        },
        {
          "name": "\u79D1\u897F\u5609\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_db91a19c44b54f81bf40758d85208a2b"
        },
        {
          "name": "\u514B\u7F57\u5730\u4E9A\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_80d9b24f6f6e4b6d9b26e1e60c123797"
        },
        {
          "name": "\u514B\u4E18\u4E9A\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_9e4277685df648b886b977b9e5bd7e09"
        },
        {
          "name": "\u5E93\u5C14\u5FB7\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_7427c515f5804460932753c1b66cc93c"
        },
        {
          "name": "\u62C9\u4E01\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_16aae7609359413c9a3b899b8146fb8a"
        },
        {
          "name": "\u62C9\u8131\u7EF4\u4E9A\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_816f89c3e1da45349316774b07b02c17"
        },
        {
          "name": "\u8001\u631D\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_86ee0898ed3c4ac6ac8826c9aa48892c"
        },
        {
          "name": "\u7ACB\u9676\u5B9B\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_3bf66491962b4a0790df0036e4f5af9c"
        },
        {
          "name": "\u6797\u52A0\u62C9\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_95e802bdf307454793a832de25c623c5"
        },
        {
          "name": "\u5362\u68EE\u5821\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_74d6bd5b01ad4b3eb9ab65cdc4bd57a2"
        },
        {
          "name": "\u7F57\u9A6C\u5C3C\u4E9A\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_8911498b75f84591be6549dfdda88d2a"
        },
        {
          "name": "\u7F57\u9A6C\u5C3C\u4E9A\u8BED\uFF08\u6469\u5C14\u591A\u74E6\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_a350a4284d6b49d2a7ac10839b3fce60"
        },
        {
          "name": "\u7F57\u66FC\u4EC0\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_1974b422c2234f2abeaa1df64e92e556"
        },
        {
          "name": "\u9A6C\u8033\u4ED6\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_27c8b93744bd4581a497820d2b63ab05"
        },
        {
          "name": "\u9A6C\u62C9\u5730\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_403de66fb88e4932b98b69dfd22d6987"
        },
        {
          "name": "\u9A6C\u62C9\u52A0\u65AF\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_dc6208bdb4994fac90888ea24db518f1"
        },
        {
          "name": "\u9A6C\u62C9\u96C5\u62C9\u59C6\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_1064b95cb247432e977fc919458a662b"
        },
        {
          "name": "\u9A6C\u6765\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_895422ac57d645b3b44998b23ad88b63"
        },
        {
          "name": "\u9A6C\u5176\u987F\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_f8d038991a254ed5b285821f276caedb"
        },
        {
          "name": "\u6BDB\u5229\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_2a441752866e4890a2fee588758ab802"
        },
        {
          "name": "\u8499\u53E4\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_32affa2e89a04e96b998b6332a738c0c"
        },
        {
          "name": "\u5B5F\u52A0\u62C9\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_8bbbe08b9a4e40baabb54b326a1584f1"
        },
        {
          "name": "\u7F05\u7538\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_2bd048b1e15946d195e8029c527e9eff"
        },
        {
          "name": "\u82D7\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_eb940d634b9e4ab08c38b677577e20a0"
        },
        {
          "name": "\u5357\u975E\u8377\u5170\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_fa04cdaf98d64a9895cf35fabfbdca7f"
        },
        {
          "name": "\u5357\u7D22\u6258\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_3e25349cece74442aa68448744149414"
        },
        {
          "name": "\u5C3C\u6CCA\u5C14\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_da74ef364c564baca0495cffd2ee402d"
        },
        {
          "name": "\u632A\u5A01\u5C3C\u8BFA\u65AF\u514B\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_8be1771bd7494ca88e31b2b85ea49f70"
        },
        {
          "name": "\u65C1\u906E\u666E\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_8b3e7a7bb4bb4573be25bd84595c017b"
        },
        {
          "name": "\u8461\u8404\u7259\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_085ef17ba98c42eb8b043ddf588878f8"
        },
        {
          "name": "\u8461\u8404\u7259\u8BED\uFF08\u5DF4\u897F\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_cc25f66bca624f6497604194f574e58f"
        },
        {
          "name": "\u8461\u8404\u7259\u8BED\uFF08\u8461\u8404\u7259\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_cf1c9341188f448086c71987a1fb2ece"
        },
        {
          "name": "\u666E\u4EC0\u56FE\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_611957b9d2da44f1833580cb9f52c0ca"
        },
        {
          "name": "\u9F50\u5207\u74E6\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_34bcffe0a9ea4bc59628095622c04951"
        },
        {
          "name": "\u5951\u7EF4\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_206c4774ce2a430ab8219f0fdd34e8b7"
        },
        {
          "name": "\u65E5\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_36d08c8af6a647f0a1895f514908008b"
        },
        {
          "name": "\u745E\u5178\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_b04cfa8a351a4d0f99c1d79049ec652c"
        },
        {
          "name": "\u8428\u6469\u4E9A\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_049a60ac85d2441ea018e4b481c20d5c"
        },
        {
          "name": "\u585E\u5C14\u7EF4\u4E9A-\u514B\u7F57\u5730\u4E9A\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_feebc1d7f5664bfea8a759c7f2750f7f"
        },
        {
          "name": "\u585E\u5C14\u7EF4\u4E9A\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_8fcd1679839f41b480d7cb415225fe82"
        },
        {
          "name": "\u50E7\u4F3D\u7F57\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_54676d794aa643b690bc233c39b87d05"
        },
        {
          "name": "\u7ECD\u7EB3\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_a7dccebca6234fbabc85e45ae084526f"
        },
        {
          "name": "\u4E16\u754C\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_7e47b37732254109839fa1795f7cae48"
        },
        {
          "name": "\u4E66\u9762\u632A\u5A01\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_ae4c8683e2a8476f9b4d95f3f62d613a"
        },
        {
          "name": "\u65AF\u6D1B\u4F10\u514B\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_d7725a0dd4ed4b9bbeb6616426d76844"
        },
        {
          "name": "\u65AF\u6D1B\u6587\u5C3C\u4E9A\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_a5988a4528c04375a90ad3de5d62fcf7"
        },
        {
          "name": "\u65AF\u74E6\u5E0C\u91CC\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_30d220e222744b4fba017ef588e9bfd2"
        },
        {
          "name": "\u82CF\u683C\u5170\u76D6\u5C14\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_7608462b55da4ba096019c2cc84ac181"
        },
        {
          "name": "\u7D22\u9A6C\u91CC\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_a80abdc655d14bb095ecee0d96a78e09"
        },
        {
          "name": "\u5854\u5409\u514B\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_5da0192992f74e8d99889d5137f17929"
        },
        {
          "name": "\u6CF0\u5362\u56FA\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_08429c3277454e078dbf25768a6e6d5e"
        },
        {
          "name": "\u6CF0\u7C73\u5C14\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_5bb970f1e370417081726245780d1cc2"
        },
        {
          "name": "\u6CF0\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_d72752efdfd74bccb701de695f032de7"
        },
        {
          "name": "\u6C64\u52A0\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_588f5e32a28a4a768fbf5d31c109b58b"
        },
        {
          "name": "\u63D0\u683C\u5229\u5C3C\u4E9A\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_809f54858eae438cb679237e24e4473b"
        },
        {
          "name": "\u571F\u8033\u5176\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_1a4f2ebe8cb54a48aef9f1cb63d867b1"
        },
        {
          "name": "\u571F\u5E93\u66FC\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_346dcb84ee644bcf9877a9682cce3284"
        },
        {
          "name": "\u74E6\u9686\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_3dfa80a0673d4263aee2b00e4b2de607"
        },
        {
          "name": "\u5A01\u5C14\u58EB\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_419dc945ec2843b99023872cb2384b3a"
        },
        {
          "name": "\u7EF4\u543E\u5C14\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_03aeddc0727c455fa78c362974e58fd6"
        },
        {
          "name": "\u4E4C\u5C14\u90FD\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_ee5529f21eff4844a0c27fe128454f62"
        },
        {
          "name": "\u4E4C\u514B\u5170\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_580dcf3cd3174337b42ba8e82b8f81f2"
        },
        {
          "name": "\u4E4C\u5179\u522B\u514B\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_e465a38f3a64488ab3ae12acb7e919f1"
        },
        {
          "name": "\u897F\u73ED\u7259\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_7d899bcff2824d86a559626f08c3774e"
        },
        {
          "name": "\u897F\u73ED\u7259\u8BED\uFF08\u963F\u6839\u5EF7\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_76a0a2d2f28645c084bd180061831252"
        },
        {
          "name": "\u897F\u73ED\u7259\u8BED\uFF08\u54E5\u4F26\u6BD4\u4E9A\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_c3bcd968344649ac8dc09a5938f279c5"
        },
        {
          "name": "\u897F\u73ED\u7259\u8BED\uFF08\u54E5\u65AF\u8FBE\u9ECE\u52A0\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_6b135e4c73ab41558e67996a1991d5bd"
        },
        {
          "name": "\u897F\u73ED\u7259\u8BED\uFF08\u6D2A\u90FD\u62C9\u65AF\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_2465b3600cd74527bba2d9de9be654f7"
        },
        {
          "name": "\u897F\u73ED\u7259\u8BED\uFF08\u62C9\u4E01\u7F8E\u6D32\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_a8149d31f4044527b8e6beeb132368b5"
        },
        {
          "name": "\u897F\u73ED\u7259\u8BED\uFF08\u7F8E\u56FD\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_3465c1d225cd47f3a7fe2dffab42f131"
        },
        {
          "name": "\u897F\u73ED\u7259\u8BED\uFF08\u79D8\u9C81\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_c5c36c26fae441239212c760b4fb5fcd"
        },
        {
          "name": "\u897F\u73ED\u7259\u8BED\uFF08\u58A8\u897F\u54E5\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_2cd49cc5c502412aa0c0721f92a7e9b9"
        },
        {
          "name": "\u897F\u73ED\u7259\u8BED\uFF08\u59D4\u5185\u745E\u62C9\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_f7d585aa817b4b2498634d520cae0d53"
        },
        {
          "name": "\u897F\u73ED\u7259\u8BED\uFF08\u4E4C\u62C9\u572D\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_81172d1ac35a43829e16ed7af475054d"
        },
        {
          "name": "\u897F\u73ED\u7259\u8BED\uFF08\u897F\u73ED\u7259\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_f76c05efe97444f4833ae0d1f2481f45"
        },
        {
          "name": "\u897F\u73ED\u7259\u8BED\uFF08\u667A\u5229\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_9cafb958dcad459eaf09221bf863b85c"
        },
        {
          "name": "\u897F\u5F17\u91CC\u897F\u4E9A\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_5d516a27f8814784bf3fbfede23ed8a6"
        },
        {
          "name": "\u5E0C\u4F2F\u6765\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_b449541fac6a4e07af24c596eb83f616"
        },
        {
          "name": "\u5E0C\u814A\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_778a5944babd43949d6a12c97b091397"
        },
        {
          "name": "\u590F\u5A01\u5937\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_fb41b1317d1244cebab92e047e92fa6a"
        },
        {
          "name": "\u4FE1\u5FB7\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_5289b83e588c462a8c06a8d5442c51ff"
        },
        {
          "name": "\u5308\u7259\u5229\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_c57dec7007434fedb81637dd3ab2fab7"
        },
        {
          "name": "\u5BBF\u52A1\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_631ab4acc29a456b8adaaef94cc9b172"
        },
        {
          "name": "\u5DFD\u4ED6\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_cafe8a7709d5483bb7e4218b00e90bd0"
        },
        {
          "name": "\u4E9A\u7F8E\u5C3C\u4E9A\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_ccd90624a4c649e1a591c02769d4daaa"
        },
        {
          "name": "\u4F0A\u535A\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_5dccb81de0aa470bbb7626d29f8844c8"
        },
        {
          "name": "\u610F\u5927\u5229\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_4357a256541e43658c9cb73c2c8a98e9"
        },
        {
          "name": "\u610F\u5927\u5229\u8BED\uFF08\u745E\u58EB\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_cb0beedad99747e599a4b79e91aefbad"
        },
        {
          "name": "\u610F\u5927\u5229\u8BED\uFF08\u610F\u5927\u5229\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_0af3f2c6898c48f7b303b50a73c9a4b9"
        },
        {
          "name": "\u610F\u7B2C\u7EEA\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_5ea790b86bb64f83b2d42981df5da3fb"
        },
        {
          "name": "\u5370\u5730\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_41bc97c6b0b44310be76b47d8d96d86d"
        },
        {
          "name": "\u5370\u5EA6\u5C3C\u897F\u4E9A\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_365c41357e124ead87ae3dbfb90c6a62"
        },
        {
          "name": "\u82F1\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_9dfe5d486d8046368588bdfdb3f3d4c2"
        },
        {
          "name": "\u82F1\u8BED\uFF08\u6FB3\u5927\u5229\u4E9A\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_b1cddf64968947a69619f7c53f9bab81"
        },
        {
          "name": "\u82F1\u8BED\uFF08\u52A0\u62FF\u5927\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_602d7bedd10b416ebef1515d955de14d"
        },
        {
          "name": "\u82F1\u8BED\uFF08\u7F8E\u56FD\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_32176a474bde4f5b8ffc6824e63b4963"
        },
        {
          "name": "\u82F1\u8BED\uFF08\u5357\u975E\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_0a090dfe55a844da9fdb7c0c819ac35e"
        },
        {
          "name": "\u82F1\u8BED\uFF08\u65B0\u897F\u5170\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_5a7c571e99894fb9ac5795fcb44d2ee1"
        },
        {
          "name": "\u82F1\u8BED\uFF08\u5370\u5EA6\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_1261f4363c0a4fabb4ca1ce221049962"
        },
        {
          "name": "\u82F1\u8BED\uFF08\u82F1\u56FD\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_ba49909c6e234b9f9759babd39e9738c"
        },
        {
          "name": "\u7EA6\u9C81\u5DF4\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_39870736d6fe4d07bda1b0c0e247140b"
        },
        {
          "name": "\u8D8A\u5357\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_3604226b397c47a38f0973b7e3bf42d0"
        },
        {
          "name": "\u722A\u54C7\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_054e390b2c5841fbaa57e3bc3bf7cdaa"
        },
        {
          "name": "\u4E2D\u5E93\u5C14\u5FB7\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_aa8693c395c342e49fb7769a5e4b6926"
        },
        {
          "name": "\u4E2D\u6587",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_04b1bbdf7b054cc1a9af4fdde9c8ba68"
        },
        {
          "name": "\u4E2D\u6587\uFF08\u7E41\u4F53\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_d05b2f8927f5428fa3caf0686a33b28f"
        },
        {
          "name": "\u4E2D\u6587\uFF08\u7B80\u4F53\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_586df45a7ca44d8fb810f76a9f6890b0"
        },
        {
          "name": "\u4E2D\u6587\uFF08\u9999\u6E2F\uFF09",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_99b359aca2984f0ba8e91824da37daf6"
        },
        {
          "name": "\u7956\u9C81\u8BED",
          "model": "payment.virtualdesktop.options.create.language",
          "id": "region_language_852ecb3fb2004c3186cf3680c40d68d8"
        }
      ],
      "model": "payment.virtualdesktop.options.create",
      "countries": [
        {
          "operating_systems": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_bcc4e340e9664ce9b16f8b505b00ea03",
              "name": "Win10-64",
              "sort": 1
            },
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_f2fc14414b814f7d8540156927fc6a68",
              "name": "Win7-64",
              "sort": 2
            }
          ],
          "default_selection": {
            "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
            "model": "payment.virtualdesktop.options.create.country_default_selection",
            "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0"
          },
          "name": "\u4E2D\u56FD",
          "model": "payment.virtualdesktop.options.create.country",
          "id": "region_country_1112067fc1ca46cda4ed23c9058a5109",
          "browsers": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_browser",
              "id": "browser_685003f574cf4574a8c3a60ad7eddbb5",
              "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
              "sort": 1
            }
          ],
          "region_default_selection": [
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_2050be94a672443a817f8219f78cadfc"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_079a223f03184aa29e15f8bae9b5493a"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_ed87a35800194c0d8df5035953ea7f37"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_a69991a6a9624c06aa61ed3d931d63fa"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_29d481b84f744905ad6134f76ef22656"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_0dbea98b3d6143dbaa2a9a55db6dbb57"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_0d299003a4544519869ecf180edac3a7"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_81bd6b727dc943358c70034b74bfa5aa"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_9b0416f0e2354e81a8b2734e4c28e1cb"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_08434adb812f4d5e854715fa4b68d5ea"
            },
            {
              "timezone_id": "region_timezone_bcbbac304d9f4336bb56b3a6e030b3f2",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_841c017fdcdd4b82a5939173b20db168"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_7a2d6a566df64218a81e84850225200a"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_d3bc1d3c28b64642a58d2e6afdcf2878"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_82b8222b834a46c9848afae1c6549bcb"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_6d263561174f4cb0b394cee02b2ef75b"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_178e9a2fb09649298cfb57ac70247fe3"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_094bee80dd024a208f1d436c778e4bfa"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_70c5ceb1be9a4c239613d9bd9462f952"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_f5b579661ecb4eab80e87c07ff32ef93"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_bd28be1f04124b72a45c5a22008f2460"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_1cb9c29d085b453dbabb74c7afb8cc4d"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_65497630da4647b89a3be18216009522"
            },
            {
              "timezone_id": "region_timezone_7ff89815cce74fa4aacc7948f8f50c78",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_d05b2f8927f5428fa3caf0686a33b28f",
              "region_guid": "region_1e6071d2e3264421857f13f0153a1f3a"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_e6ac6b03a6b64af196474f44b0b487fa"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_20250548e1564cc281661f5849e2866b"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_c95b0cf8d8a94d73ad837757d1748ddc"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_36a6ffd41e9c486888a532804a93bc7e"
            },
            {
              "timezone_id": "region_timezone_bcbbac304d9f4336bb56b3a6e030b3f2",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_99b359aca2984f0ba8e91824da37daf6",
              "region_guid": "region_68fe96b4b7f94933a1a1cb82fc982b99"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_8f4788a6497f4c269da1a92921b77de1"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_740e822d8fdd48e6bd3241e45d81e102"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_f17d0da5b3074dab99cc2ca55c5aab00"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_d90c9233dc3d408f980655c005c6ed59"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_3213845c60cf42b5be3233e3ed7f3488"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_3f8633f219fd4a608d377b0813b77c39"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_9cd9678f17454ef9880666de1f9d5b48"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_f670c047b26a4d96b527635a2d4bf77b"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_658fca4e592e4f4bb5c7dd7451695a23"
            },
            {
              "timezone_id": "region_timezone_bcbbac304d9f4336bb56b3a6e030b3f2",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_d05b2f8927f5428fa3caf0686a33b28f",
              "region_guid": "region_aac4728ca4f9461f93f1870c7785873a"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_c41e0a636c07428086cadf795cb95eb1"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_43c6da40f4a242bb80db85c96187d4c4"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_55bc2878f83f4421a07b7db9499b36ef"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_a4c446da58a543b9b1c4d5bc0e59141c"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_09e33c19fcb14fd88d2486e3b1fc4503"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_d65519035c9d4487b30824261c19a450"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_31390de8074341fc9659a3936841fda3"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_c2649b143897449aa19cd146a0f656bc"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_23791a316a294df1b2169f53f0e26808"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_f71351ce51b141cc872e3222619651a9"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_e22ae40be25b41a18c990f41c40ec313"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_dc21dd1aecfb4fb5ae290557c7f6640b"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_93ce9c96709c43dfbdab308feadcc692"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_f462984678474bfe8310384e41193228"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_0ffd0500ff42476ba47d711b8b74fc08"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_5a00900b0b73457c827f3c9557847833"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_8996af1c4f5648538a98a8a79a950af6"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_5976278ba07647d1a680339285718666"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_9d905e18e7fc4eb1abfe9e0406b3006a"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_a8bb1ce43f624abda7e8fba93befedbd"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_c346161cfef649729d3d46ee2129f583"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_41728225acae45a08c03ce8aca0a12d3"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_e4305ecd4b7d4e4f883d480cea7c572d"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_e20480fac7894c4eb460db6c8867562e"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_75606c356588440998b3a27a62bfd95e"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_2b443d35ac074133a25723eb4107b7a4"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_7bbb9313c6f445d5a8ecf18f3c38e9a2"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_31f645bec7984057b73a1fa45e4338a4"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_958f7778c7a0483294c77379b051e73a"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_101df81486644c729fc0da8b3ad39bd0"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_be0b373f33b74cbebbc1091f9028bd3d"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_987ae23974e04b6b91a0a788e2e8a31a"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_28785551828e4cb7ae60075107983dff"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_2641ecf46de348c493a5d7435a3f2567"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_e48216f21e574791abd8d26fffcee953"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_54ebc36e384d477c88442fd2ebbdbab8"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_f1ea65311853495ba79f29fdb43bbeaf"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_dc364b3f6e754317b776ce7b8ecaa06e"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_daf93dcb692c496abb30a74929775554"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_084887e065f94758857f687040ec20eb"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_55155fde68ca4d4daa79b35c1a2f1450"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_69b0e9111d204cb884d7551e3a8a7013"
            },
            {
              "timezone_id": "region_timezone_bcbbac304d9f4336bb56b3a6e030b3f2",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_99b359aca2984f0ba8e91824da37daf6",
              "region_guid": "region_179898c5179d494fa54d65cbb195cf80"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_8425fab7b72f4df0b41ece1f90249ae7"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_d2bd39f8b537439cbc846e04fc9c5277"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_1feec40ad07440dea66d8de925e57c27"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_46fda70ca1524dd0b5ad354bfe35ab50"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_ec1a2aa5096c4b9db51c82b714416ad8"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_763104768e0e45b9a9803260ab3b2b41"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_02734c770cd345efaa81c94405bad58f"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_6b07fb155b7f4f0e9d4bf9ae50333a69"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_4392cb90e7e443c8b9b1bbf2f22f1e8c"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_1acfa1b240fc4585914dbb71314e6d9d"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_cc6deb2b55de4bdfb6e598a72c148524"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_5b049a8a43df45498761c8c97a4481ce"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_6140f19f75ba4abaa9ba0a2dca790a81"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_335fa2fef25a4284889e630d618665bc"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_9f88174604cf437498b40d6228b3179c"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_a4efad4acfe243f6b8b0a282710c7ed9"
            },
            {
              "timezone_id": "region_timezone_bcbbac304d9f4336bb56b3a6e030b3f2",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_ac5b41e2996140388e13b653176ba333"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_24d89062230248a59f5278341c98c91a"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_4abcf3671d374572be3bf8c3e2d24ecf"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_91973e5347d9401fa5f6192238db5e57"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_cc71cde1558745afb48d3cb973cdb802"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_c3c7b5f137df44a892a0994c615643c6"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_6023a28559f9424697fcbf9bd08d7e9a"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_0749f8b0d51a407d98499609c395acd4"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_804801d132f04defb96248d9615e6cfa"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_d0fcba751a8e49eea12018f56cfeb5fb"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_cf2e23ac82a84ceb9b2633c2e5be3796"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_0136c4260e6547829bf9aec5ec1d9fa8"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_01df824bef3a47749cdc557d42408160"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_2d3f5508c4be4444b9f178dc03126d73"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_0753d0ff19c045e4a2ffdd83f1577d13"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_d0569bd28a904d97a72e53964f53c8ac"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_92aa5d7cc6314425961add850f7fb65b"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_bbf89c6a5c08457ea40d9af7f7aa65ed"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_cd32dd7bcb924ae88205c675517f9a16"
            },
            {
              "timezone_id": "region_timezone_bcbbac304d9f4336bb56b3a6e030b3f2",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_902fbb1ab8bd4ff3860b92c3e6a20b99"
            },
            {
              "timezone_id": "region_timezone_bcbbac304d9f4336bb56b3a6e030b3f2",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_d05b2f8927f5428fa3caf0686a33b28f",
              "region_guid": "region_2e93c7ec52fe44e4a044b9636aa7f7e6"
            },
            {
              "timezone_id": "region_timezone_bcbbac304d9f4336bb56b3a6e030b3f2",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_99b359aca2984f0ba8e91824da37daf6",
              "region_guid": "region_673c81cf8e7d49689ba5480b46715502"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_bedbad1c7d28436cb390cf6dcb8194b3"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_7a6b8989b2fc4d2d95201acd1b223ab2"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_6fc64fefbf2545eeac2b44586a35978a"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_e6d66560022847ae98b47900f5e72b15"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_532dbcd43269480a97b5ef618e577d58"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_e66f865c4cd54aad920284cbc966d148"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_65e170cb542f45779ca8dca4948b8cfc"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_4562a42d9bf345ce86032c32490cefff"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_8f5fcd998b874d47b790dc2d9f39d3b1"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_2dacfdac5abc4d0fbd566d135125d026"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_de7c6d916fb847aab158aef02b918a66"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_6667e6b1c79d483fb93284a14db9d4d4"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_12eb982922a04417b13eb68cc77e3c01"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_bcb5abcee3ea4758bce1b715774e13e4"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_e11ade51dd2f465b94d9b1a02fb52ce6"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_c10d48cf811b467593761b1d4189ed00"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_6bdcd493de004932afd6a428ac67ed15"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_078823faa643450ba72a9ce84e71c090"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_04b1bbdf7b054cc1a9af4fdde9c8ba68",
              "region_guid": "region_6c726949345c451091c4c656d8333b60"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_284fa3ca775440b281eec34bb9d0c628"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_4f43ac735f9645cd84c824a28a703205"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_eaca45f996fc4644bcfe49cf559e7ea2"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_6b7bdec4ffe143639e573afd439a28f7"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_6d42d402b8cc440089f7bbde2f7cc351"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_e91649ea71b34bd0a09c96b20ed078b4"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_6a22b00ddec146c99b410723e4d2e9e8"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_64322e133b8c4ef89104f3eabc6ec804"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_95fc91c79f6a42b0975fb950d67f16d7"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_ec8961716b5a4c2b8c877d9c8ea2cfe5"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_f03c4bc3fb4f4c50860427db486c8a94"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_c57f5fae6e2447e6ba6213a0c7bb56a2"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_0289c038f2864641aab8323f570ece20"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_7c786903842f487cbc2a0313b23df4eb"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_9f99d43f07834baea4aaf6aa49280a31"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_cecfd9d69d5d4dac90bb8533a2307381"
            },
            {
              "timezone_id": "region_timezone_aee95fe849214aa8b4ef94abb9756b23",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_586df45a7ca44d8fb810f76a9f6890b0",
              "region_guid": "region_aa3841e125d240709e6105f63ebfc9cc"
            }
          ]
        },
        {
          "operating_systems": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_bcc4e340e9664ce9b16f8b505b00ea03",
              "name": "Win10-64",
              "sort": 1
            },
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_f2fc14414b814f7d8540156927fc6a68",
              "name": "Win7-64",
              "sort": 2
            }
          ],
          "default_selection": {
            "timezone_id": "region_timezone_c7f027f86ddf48099ebbaf7a1c767af6",
            "model": "payment.virtualdesktop.options.create.country_default_selection",
            "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963"
          },
          "name": "\u7F8E\u56FD",
          "model": "payment.virtualdesktop.options.create.country",
          "id": "region_country_7b2ea6852b434e0fa513dff8cbc02cda",
          "browsers": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_browser",
              "id": "browser_685003f574cf4574a8c3a60ad7eddbb5",
              "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
              "sort": 1
            }
          ],
          "region_default_selection": [
            {
              "timezone_id": "region_timezone_67cf0b2690414ea680d0f425f6132dc0",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_7cf998bb620e43e7a08bde39060a9f89"
            },
            {
              "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_0012e93edde045fb9c1f6e91917aae31"
            },
            {
              "timezone_id": "region_timezone_f4272cafe1d6451ea560458c9f11b640",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_af019bc3f42340b7a9f8494fef87ecd8"
            },
            {
              "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_74d127db8fae44c1a477279f2bce32cf"
            },
            {
              "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_741a69e9a63c4fd6aa3b636826b76b6a"
            },
            {
              "timezone_id": "region_timezone_c7f027f86ddf48099ebbaf7a1c767af6",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_a04f721efc634c0fbc98e7ea90adf547"
            },
            {
              "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_d9193be6bbf74f2aacf1e88c25dbecd1"
            },
            {
              "timezone_id": "region_timezone_f4272cafe1d6451ea560458c9f11b640",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_d02359b4886445b684a11caafe23ef0d"
            },
            {
              "timezone_id": "region_timezone_c7f027f86ddf48099ebbaf7a1c767af6",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_e9e2a22001c4425797205791732a0d2b"
            },
            {
              "timezone_id": "region_timezone_c7f027f86ddf48099ebbaf7a1c767af6",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_16b4981e2adc493392d6beb49a4370a0"
            },
            {
              "timezone_id": "region_timezone_ffdb1d6d629a497fa3097351917d8e62",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_064ffde1b500452fa8cecc84bce39de4"
            },
            {
              "timezone_id": "region_timezone_f4272cafe1d6451ea560458c9f11b640",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_21ec28da03e14004aa8a9478009d747e"
            },
            {
              "timezone_id": "region_timezone_f4272cafe1d6451ea560458c9f11b640",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_892aa9be63a143e1b8191b791dc1c419"
            },
            {
              "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_6f2697cbf37b49fb824743f734ab8588"
            },
            {
              "timezone_id": "region_timezone_c7f027f86ddf48099ebbaf7a1c767af6",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_0c56c0b9e2ed4f57bb06c6fde7006872"
            },
            {
              "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_2bb599d8cb344218b3ae350b4e01585b"
            },
            {
              "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_90ac74d5c6454baf969b9b883cc423c3"
            },
            {
              "timezone_id": "region_timezone_c7f027f86ddf48099ebbaf7a1c767af6",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_68cd242b684541a78b1c17f3ee3939f1"
            },
            {
              "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_a3bf9b1ad1de40a983d206eddc08c0ba"
            },
            {
              "timezone_id": "region_timezone_b2c194cbfbff45ec9aa418e41d94d6b6",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_e1ca76006995487a9b8dddf74fa722da"
            },
            {
              "timezone_id": "region_timezone_f4272cafe1d6451ea560458c9f11b640",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_d20e6f1fa86e4e3999c245d25b886c2d"
            },
            {
              "timezone_id": "region_timezone_0458cd80a5334f60a96f62a5248d3b25",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_eb604bee3cbe4f959e88e6eaf9cdc3fe",
              "region_guid": "region_95395d3cf61f4d948debf31cfd53ae0b"
            },
            {
              "timezone_id": "region_timezone_c7f027f86ddf48099ebbaf7a1c767af6",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_937c8ddf2fe24f34b738f5c692f86362"
            },
            {
              "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_f6b1619fd3924e51a54ff1b43bb41b81"
            },
            {
              "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_318a5a114dda453d810f22b0d0bdbc0c"
            },
            {
              "timezone_id": "region_timezone_f4272cafe1d6451ea560458c9f11b640",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_a9446cb72c8c42b889daa646005ed5a5"
            },
            {
              "timezone_id": "region_timezone_c7f027f86ddf48099ebbaf7a1c767af6",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_d8a05add55e2465bb2c6ee068a7872e8"
            },
            {
              "timezone_id": "region_timezone_c7f027f86ddf48099ebbaf7a1c767af6",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_fc81f495075e44d49691676d9852d896"
            },
            {
              "timezone_id": "region_timezone_b2c194cbfbff45ec9aa418e41d94d6b6",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_2905b594fead471d913ac4cba3372b47"
            },
            {
              "timezone_id": "region_timezone_f4272cafe1d6451ea560458c9f11b640",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_3c8ac3fd16f04cf9bca297e295cb0ce6"
            },
            {
              "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_11d8a2e2da0940628410971ebadcf82d"
            },
            {
              "timezone_id": "region_timezone_f4272cafe1d6451ea560458c9f11b640",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_b3c758abeb154ef98df872631a071dbd"
            },
            {
              "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_f4bcf4534dbd4f16a0b50cb76790187f"
            },
            {
              "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_950f35e90bdb4c73bc539b109341cd45"
            },
            {
              "timezone_id": "region_timezone_f4272cafe1d6451ea560458c9f11b640",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_35329717c1e34328be5a962ff1747a8e"
            },
            {
              "timezone_id": "region_timezone_f4272cafe1d6451ea560458c9f11b640",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_bc250219ad254bc5be46977eec0f9448"
            },
            {
              "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_6f432f28841d4bfc9c0b25f0cbcf4baf"
            },
            {
              "timezone_id": "region_timezone_b2c194cbfbff45ec9aa418e41d94d6b6",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_71773b98395c462c9d8d074cc6f4aae7"
            },
            {
              "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_f238ee5654194efab6a6b6af09c8ec35"
            },
            {
              "timezone_id": "region_timezone_f4272cafe1d6451ea560458c9f11b640",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_e6ed80a8aff149e0950003b61d696e20"
            },
            {
              "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_9cfda642998b429386cf511a71f99ca1"
            },
            {
              "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_c297967881a74662ad7b675a60994a03"
            },
            {
              "timezone_id": "region_timezone_b2c194cbfbff45ec9aa418e41d94d6b6",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_68b29f82d4844c8eb72d0a070ef2c3ac"
            },
            {
              "timezone_id": "region_timezone_c7f027f86ddf48099ebbaf7a1c767af6",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_f7be9cc954fe4b75bec4667314f0e7e0"
            },
            {
              "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_5e636b022d9e43d6918a7df1be3be989"
            },
            {
              "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_a128487474a64e05b494dda664d662d1"
            },
            {
              "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_1d10199b2ca745f6980a36011fc3c83e"
            },
            {
              "timezone_id": "region_timezone_c7f027f86ddf48099ebbaf7a1c767af6",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_a18a658e418f4d38bd56651cd5ec4318"
            },
            {
              "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_058a74777ba14c6d90872222c5e6525e"
            },
            {
              "timezone_id": "region_timezone_f4272cafe1d6451ea560458c9f11b640",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_ffe87d177f4b4008a1321c87d9b7e34c"
            },
            {
              "timezone_id": "region_timezone_c7f027f86ddf48099ebbaf7a1c767af6",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_5ce1250c8c9843c2b6021dccd6646745"
            },
            {
              "timezone_id": "region_timezone_f4272cafe1d6451ea560458c9f11b640",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_3e6eea97e4b74de1825fe004951760f6"
            },
            {
              "timezone_id": "region_timezone_c7f027f86ddf48099ebbaf7a1c767af6",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_e94115d507924f04b0410efc61e0b8ee"
            },
            {
              "timezone_id": "region_timezone_f4272cafe1d6451ea560458c9f11b640",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_fd156bcb085f45d68578c627e9adde04"
            },
            {
              "timezone_id": "region_timezone_b2c194cbfbff45ec9aa418e41d94d6b6",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_0cbd3896e49947dfbe03551b6e1a3e18"
            },
            {
              "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_ccad0ec7f12d4dc99f13e7bb69091e4b"
            },
            {
              "timezone_id": "region_timezone_f4272cafe1d6451ea560458c9f11b640",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_dc6abafa370046bea88764022b33f75f"
            },
            {
              "timezone_id": "region_timezone_c7f027f86ddf48099ebbaf7a1c767af6",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_3b4587d9a6e042ac8e43c781b23e6f2e"
            },
            {
              "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_4a07f8e785b6477e96c3c744244a6f65"
            },
            {
              "timezone_id": "region_timezone_f4272cafe1d6451ea560458c9f11b640",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_44d6627413e7402192f11c5763662edc"
            },
            {
              "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_2a6e7f27c4d24d7fa91d561a5ee8836d"
            },
            {
              "timezone_id": "region_timezone_f4272cafe1d6451ea560458c9f11b640",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_e7b88a17d1dd4459bff6b05419b28912"
            },
            {
              "timezone_id": "region_timezone_620ad67f38ac4a13a6b6def2f1cbbdd5",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_e9f38a3a920640408b788db31b3f5c22"
            },
            {
              "timezone_id": "region_timezone_b2c194cbfbff45ec9aa418e41d94d6b6",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_5032b37e7d434100aca6748564482d3d"
            },
            {
              "timezone_id": "region_timezone_c7f027f86ddf48099ebbaf7a1c767af6",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_f856aaef51294dedbec4cd7273d1c33a"
            },
            {
              "timezone_id": "region_timezone_f4272cafe1d6451ea560458c9f11b640",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_72ef5758505c4a95b698bac80f703c82"
            },
            {
              "timezone_id": "region_timezone_c7f027f86ddf48099ebbaf7a1c767af6",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_444bb9ec861249e78c55447f203ae6c8"
            },
            {
              "timezone_id": "region_timezone_c7f027f86ddf48099ebbaf7a1c767af6",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_ccf1fcd2a77a4972af40fe926797c38c"
            },
            {
              "timezone_id": "region_timezone_f4272cafe1d6451ea560458c9f11b640",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963",
              "region_guid": "region_6daf04b4a0ee4d57bcaadb5da8531109"
            }
          ]
        },
        {
          "operating_systems": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_bcc4e340e9664ce9b16f8b505b00ea03",
              "name": "Win10-64",
              "sort": 1
            },
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_f2fc14414b814f7d8540156927fc6a68",
              "name": "Win7-64",
              "sort": 2
            }
          ],
          "default_selection": {
            "timezone_id": "region_timezone_59127c59ef5c429cb8e9823b0d86c816",
            "model": "payment.virtualdesktop.options.create.country_default_selection",
            "language_id": "region_language_b1cddf64968947a69619f7c53f9bab81"
          },
          "name": "\u6FB3\u5927\u5229\u4E9A",
          "model": "payment.virtualdesktop.options.create.country",
          "id": "region_country_6c22ff1540e9419f94109e92ba3372c7",
          "browsers": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_browser",
              "id": "browser_685003f574cf4574a8c3a60ad7eddbb5",
              "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
              "sort": 1
            }
          ],
          "region_default_selection": [
            {
              "timezone_id": "region_timezone_59127c59ef5c429cb8e9823b0d86c816",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_b1cddf64968947a69619f7c53f9bab81",
              "region_guid": "region_7d3864346c5a4b059e0b98a478d74af4"
            },
            {
              "timezone_id": "region_timezone_59127c59ef5c429cb8e9823b0d86c816",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_b1cddf64968947a69619f7c53f9bab81",
              "region_guid": "region_bc657e11f277485598076a98535c9559"
            },
            {
              "timezone_id": "region_timezone_59127c59ef5c429cb8e9823b0d86c816",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_b1cddf64968947a69619f7c53f9bab81",
              "region_guid": "region_fdf798cd123549dd8a934d6ee0bc90d8"
            },
            {
              "timezone_id": "region_timezone_59127c59ef5c429cb8e9823b0d86c816",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_b1cddf64968947a69619f7c53f9bab81",
              "region_guid": "region_98c16c74f7a9412b98b2a3916ec0a6e6"
            },
            {
              "timezone_id": "region_timezone_59127c59ef5c429cb8e9823b0d86c816",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_b1cddf64968947a69619f7c53f9bab81",
              "region_guid": "region_b540ed4a17284b8f9f85077421aac2b1"
            },
            {
              "timezone_id": "region_timezone_59127c59ef5c429cb8e9823b0d86c816",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_b1cddf64968947a69619f7c53f9bab81",
              "region_guid": "region_8c2e2589ebed47a8a0fa25c490f37be3"
            },
            {
              "timezone_id": "region_timezone_59127c59ef5c429cb8e9823b0d86c816",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_b1cddf64968947a69619f7c53f9bab81",
              "region_guid": "region_c9129fc844ba4468ab2b7c3b05f4a059"
            }
          ]
        },
        {
          "operating_systems": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_bcc4e340e9664ce9b16f8b505b00ea03",
              "name": "Win10-64",
              "sort": 1
            }
          ],
          "default_selection": {
            "timezone_id": "region_timezone_2688b867b93044449d8768748d3ebf6b",
            "model": "payment.virtualdesktop.options.create.country_default_selection",
            "language_id": "region_language_624bfb637a04426b8cf6cf394f03090c"
          },
          "name": "\u8377\u5170",
          "model": "payment.virtualdesktop.options.create.country",
          "id": "region_country_7b2ea6852b434e0fa513dff8cbc02cdb",
          "browsers": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_browser",
              "id": "browser_685003f574cf4574a8c3a60ad7eddbb5",
              "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
              "sort": 1
            }
          ],
          "region_default_selection": [
            {
              "timezone_id": "region_timezone_2688b867b93044449d8768748d3ebf6b",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_624bfb637a04426b8cf6cf394f03090c",
              "region_guid": "region_88a0460bd4d44ed79918bacd3717d87d"
            },
            {
              "timezone_id": "region_timezone_2688b867b93044449d8768748d3ebf6b",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_624bfb637a04426b8cf6cf394f03090c",
              "region_guid": "region_6f3088c1b4024c1cb600c928218af480"
            },
            {
              "timezone_id": "region_timezone_2688b867b93044449d8768748d3ebf6b",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_624bfb637a04426b8cf6cf394f03090c",
              "region_guid": "region_f17a603f5c07470eb7492240121c8c55"
            },
            {
              "timezone_id": "region_timezone_2688b867b93044449d8768748d3ebf6b",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_624bfb637a04426b8cf6cf394f03090c",
              "region_guid": "region_0150a39011f04ab2830692849e745fd9"
            },
            {
              "timezone_id": "region_timezone_2688b867b93044449d8768748d3ebf6b",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_624bfb637a04426b8cf6cf394f03090c",
              "region_guid": "region_f29de4aba88f4e6d81ab9d7a99206d2d"
            },
            {
              "timezone_id": "region_timezone_2688b867b93044449d8768748d3ebf6b",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_624bfb637a04426b8cf6cf394f03090c",
              "region_guid": "region_229a2d69caaa444b82c3a0eaf47488e6"
            },
            {
              "timezone_id": "region_timezone_2688b867b93044449d8768748d3ebf6b",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_624bfb637a04426b8cf6cf394f03090c",
              "region_guid": "region_2af219ebd3964c3e808089b49f80d020"
            },
            {
              "timezone_id": "region_timezone_2688b867b93044449d8768748d3ebf6b",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_624bfb637a04426b8cf6cf394f03090c",
              "region_guid": "region_961fd038962d4c2092641031b5d75d16"
            },
            {
              "timezone_id": "region_timezone_2688b867b93044449d8768748d3ebf6b",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_624bfb637a04426b8cf6cf394f03090c",
              "region_guid": "region_abe679028d54434384a4e8d64973ee41"
            }
          ]
        },
        {
          "operating_systems": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_bcc4e340e9664ce9b16f8b505b00ea03",
              "name": "Win10-64",
              "sort": 1
            }
          ],
          "default_selection": {
            "timezone_id": "region_timezone_ee7cb2c5d2b046d6a6fd5a46db682e16",
            "model": "payment.virtualdesktop.options.create.country_default_selection",
            "language_id": "region_language_36d08c8af6a647f0a1895f514908008b"
          },
          "name": "\u65E5\u672C",
          "model": "payment.virtualdesktop.options.create.country",
          "id": "region_country_7b2ea6852b434e0fa513dff8cbc02cdc",
          "browsers": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_browser",
              "id": "browser_685003f574cf4574a8c3a60ad7eddbb5",
              "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
              "sort": 1
            }
          ],
          "region_default_selection": [
            {
              "timezone_id": "region_timezone_ee7cb2c5d2b046d6a6fd5a46db682e16",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_36d08c8af6a647f0a1895f514908008b",
              "region_guid": "region_e6394b91dc274ec08f7640feffe5dc15"
            },
            {
              "timezone_id": "region_timezone_ee7cb2c5d2b046d6a6fd5a46db682e16",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_36d08c8af6a647f0a1895f514908008b",
              "region_guid": "region_7eb4e3c20b1d40c5986724169ba0a063"
            },
            {
              "timezone_id": "region_timezone_ee7cb2c5d2b046d6a6fd5a46db682e16",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_36d08c8af6a647f0a1895f514908008b",
              "region_guid": "region_7803826694874bd0b1bb4dd221d1219e"
            },
            {
              "timezone_id": "region_timezone_ee7cb2c5d2b046d6a6fd5a46db682e16",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_36d08c8af6a647f0a1895f514908008b",
              "region_guid": "region_131203bd065e49cb8df626f7770ea02e"
            },
            {
              "timezone_id": "region_timezone_ee7cb2c5d2b046d6a6fd5a46db682e16",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_36d08c8af6a647f0a1895f514908008b",
              "region_guid": "region_1a526671b1ff496caa1a361819e9d7a3"
            },
            {
              "timezone_id": "region_timezone_ee7cb2c5d2b046d6a6fd5a46db682e16",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_36d08c8af6a647f0a1895f514908008b",
              "region_guid": "region_5a1105b7f45c47289a3a80ea0b1e6bac"
            },
            {
              "timezone_id": "region_timezone_ee7cb2c5d2b046d6a6fd5a46db682e16",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_36d08c8af6a647f0a1895f514908008b",
              "region_guid": "region_3e18e457a2474364850e70c31132ddfa"
            },
            {
              "timezone_id": "region_timezone_ee7cb2c5d2b046d6a6fd5a46db682e16",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_36d08c8af6a647f0a1895f514908008b",
              "region_guid": "region_1b734f71a32e4d42ac652c7a4dfb1a27"
            },
            {
              "timezone_id": "region_timezone_ee7cb2c5d2b046d6a6fd5a46db682e16",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_36d08c8af6a647f0a1895f514908008b",
              "region_guid": "region_62565844b95e4ee2aac333383d05f444"
            },
            {
              "timezone_id": "region_timezone_ee7cb2c5d2b046d6a6fd5a46db682e16",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_36d08c8af6a647f0a1895f514908008b",
              "region_guid": "region_fe5563c532384c9d829ab090b699da19"
            },
            {
              "timezone_id": "region_timezone_ee7cb2c5d2b046d6a6fd5a46db682e16",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_36d08c8af6a647f0a1895f514908008b",
              "region_guid": "region_8a64285f18994eaf8679c1a78c4be9c7"
            },
            {
              "timezone_id": "region_timezone_ee7cb2c5d2b046d6a6fd5a46db682e16",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_36d08c8af6a647f0a1895f514908008b",
              "region_guid": "region_eb7c42269dac42ae9f2bf3e7eda40822"
            },
            {
              "timezone_id": "region_timezone_ee7cb2c5d2b046d6a6fd5a46db682e16",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_36d08c8af6a647f0a1895f514908008b",
              "region_guid": "region_ace58e6fe2ba4a669448f90e2b040bbc"
            },
            {
              "timezone_id": "region_timezone_ee7cb2c5d2b046d6a6fd5a46db682e16",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_36d08c8af6a647f0a1895f514908008b",
              "region_guid": "region_92243456a4364aa3896921a879cc719a"
            }
          ]
        },
        {
          "operating_systems": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_bcc4e340e9664ce9b16f8b505b00ea03",
              "name": "Win10-64",
              "sort": 1
            }
          ],
          "default_selection": {
            "timezone_id": "region_timezone_d83bd507733a4ae88b7a2d51f7032e74",
            "model": "payment.virtualdesktop.options.create.country_default_selection",
            "language_id": "region_language_1447d2b0a5f7445b95dfd9ef696198ff"
          },
          "name": "\u5FB7\u56FD",
          "model": "payment.virtualdesktop.options.create.country",
          "id": "region_country_7b2ea6852b434e0fa513dff8cbc02cde",
          "browsers": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_browser",
              "id": "browser_685003f574cf4574a8c3a60ad7eddbb5",
              "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
              "sort": 1
            }
          ],
          "region_default_selection": [
            {
              "timezone_id": "region_timezone_d83bd507733a4ae88b7a2d51f7032e74",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_4ea8b8cd97e54d4fa0e8b0f01d7ec87c",
              "region_guid": "region_22ca133c0f6143f1b90007dbff7f0a7b"
            },
            {
              "timezone_id": "region_timezone_d83bd507733a4ae88b7a2d51f7032e74",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_4ea8b8cd97e54d4fa0e8b0f01d7ec87c",
              "region_guid": "region_e51e1fac03f844849f8e2a5e21255a3e"
            },
            {
              "timezone_id": "region_timezone_d83bd507733a4ae88b7a2d51f7032e74",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_4ea8b8cd97e54d4fa0e8b0f01d7ec87c",
              "region_guid": "region_ed8b42f2bc084e9498c9731caae826e0"
            },
            {
              "timezone_id": "region_timezone_d83bd507733a4ae88b7a2d51f7032e74",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_4ea8b8cd97e54d4fa0e8b0f01d7ec87c",
              "region_guid": "region_798707d941b74b81a2e63240d0810de6"
            },
            {
              "timezone_id": "region_timezone_d83bd507733a4ae88b7a2d51f7032e74",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_4ea8b8cd97e54d4fa0e8b0f01d7ec87c",
              "region_guid": "region_e3298ec8d08642c184b993cf58d59b26"
            },
            {
              "timezone_id": "region_timezone_d83bd507733a4ae88b7a2d51f7032e74",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_4ea8b8cd97e54d4fa0e8b0f01d7ec87c",
              "region_guid": "region_a1dd2c2525f84fb7b7b2e65c29010c35"
            },
            {
              "timezone_id": "region_timezone_d83bd507733a4ae88b7a2d51f7032e74",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_4ea8b8cd97e54d4fa0e8b0f01d7ec87c",
              "region_guid": "region_43ba96edfd194a7bb41682e492d65730"
            },
            {
              "timezone_id": "region_timezone_d83bd507733a4ae88b7a2d51f7032e74",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_4ea8b8cd97e54d4fa0e8b0f01d7ec87c",
              "region_guid": "region_3e7d10851a91418ea70fe9be3c52f69c"
            },
            {
              "timezone_id": "region_timezone_d83bd507733a4ae88b7a2d51f7032e74",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_4ea8b8cd97e54d4fa0e8b0f01d7ec87c",
              "region_guid": "region_6b79aa11cdd34cbd9916921a251b85a8"
            },
            {
              "timezone_id": "region_timezone_d83bd507733a4ae88b7a2d51f7032e74",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_4ea8b8cd97e54d4fa0e8b0f01d7ec87c",
              "region_guid": "region_b1e9fc70a80c41ffb8783d8b98fd041b"
            }
          ]
        },
        {
          "operating_systems": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_bcc4e340e9664ce9b16f8b505b00ea03",
              "name": "Win10-64",
              "sort": 1
            }
          ],
          "default_selection": {
            "timezone_id": "region_timezone_e5e654f51e14404e8e4e7862c9c3516e",
            "model": "payment.virtualdesktop.options.create.country_default_selection",
            "language_id": "region_language_ba49909c6e234b9f9759babd39e9738c"
          },
          "name": "\u82F1\u56FD",
          "model": "payment.virtualdesktop.options.create.country",
          "id": "region_country_7b2ea6852b434e0fa513dff8cbc02cdf",
          "browsers": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_browser",
              "id": "browser_685003f574cf4574a8c3a60ad7eddbb5",
              "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
              "sort": 1
            }
          ],
          "region_default_selection": [
            {
              "timezone_id": "region_timezone_e5e654f51e14404e8e4e7862c9c3516e",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_9dfe5d486d8046368588bdfdb3f3d4c2",
              "region_guid": "region_318937ab04334ea29ce07473118d4b2e"
            },
            {
              "timezone_id": "region_timezone_e5e654f51e14404e8e4e7862c9c3516e",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_9dfe5d486d8046368588bdfdb3f3d4c2",
              "region_guid": "region_83ff22a390da4f85bbcde555ca626ee8"
            },
            {
              "timezone_id": "region_timezone_e5e654f51e14404e8e4e7862c9c3516e",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_9dfe5d486d8046368588bdfdb3f3d4c2",
              "region_guid": "region_d1983cc9c1974cda9b685da91d17f9e1"
            },
            {
              "timezone_id": "region_timezone_e5e654f51e14404e8e4e7862c9c3516e",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_9dfe5d486d8046368588bdfdb3f3d4c2",
              "region_guid": "region_72def74b480a41e2825c56fd8e409313"
            },
            {
              "timezone_id": "region_timezone_e5e654f51e14404e8e4e7862c9c3516e",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_ba49909c6e234b9f9759babd39e9738c",
              "region_guid": "region_227ca8a3ec74442f855d88f6d751e27a"
            },
            {
              "timezone_id": "region_timezone_49a0d6d6b4b74365a21efed45e3a5b99",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_ba49909c6e234b9f9759babd39e9738c",
              "region_guid": "region_99c021e0dc67445488e64cf860266190"
            },
            {
              "timezone_id": "region_timezone_e5e654f51e14404e8e4e7862c9c3516e",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_9dfe5d486d8046368588bdfdb3f3d4c2",
              "region_guid": "region_e97a9d280d64400baa5d3eed3eb5c8ae"
            },
            {
              "timezone_id": "region_timezone_e5e654f51e14404e8e4e7862c9c3516e",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_9dfe5d486d8046368588bdfdb3f3d4c2",
              "region_guid": "region_38fd8b37ffea42a490a6b66d9c7fb14c"
            },
            {
              "timezone_id": "region_timezone_e5e654f51e14404e8e4e7862c9c3516e",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_9dfe5d486d8046368588bdfdb3f3d4c2",
              "region_guid": "region_ae4db2fde73b49fea49549f33e9d9e7a"
            },
            {
              "timezone_id": "region_timezone_e5e654f51e14404e8e4e7862c9c3516e",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_ba49909c6e234b9f9759babd39e9738c",
              "region_guid": "region_12e9b80302924c1c857f47e4b0f75ff1"
            },
            {
              "timezone_id": "region_timezone_e5e654f51e14404e8e4e7862c9c3516e",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_ba49909c6e234b9f9759babd39e9738c",
              "region_guid": "region_7d957fddbda64094a46197f77a92c2bc"
            },
            {
              "timezone_id": "region_timezone_e5e654f51e14404e8e4e7862c9c3516e",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_ba49909c6e234b9f9759babd39e9738c",
              "region_guid": "region_4bfe77bd90f6482f9b9997d89be08b82"
            }
          ]
        },
        {
          "operating_systems": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_bcc4e340e9664ce9b16f8b505b00ea03",
              "name": "Win10-64",
              "sort": 1
            },
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_f2fc14414b814f7d8540156927fc6a68",
              "name": "Win7-64",
              "sort": 2
            }
          ],
          "default_selection": {
            "timezone_id": "region_timezone_90ceb47c16b142f6b5651ac495e483c8",
            "model": "payment.virtualdesktop.options.create.country_default_selection",
            "language_id": "region_language_41bc97c6b0b44310be76b47d8d96d86d"
          },
          "name": "\u5370\u5EA6",
          "model": "payment.virtualdesktop.options.create.country",
          "id": "region_country_624d817563df41e6af84abce39f9dcdc",
          "browsers": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_browser",
              "id": "browser_685003f574cf4574a8c3a60ad7eddbb5",
              "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
              "sort": 1
            }
          ],
          "region_default_selection": [
            {
              "timezone_id": "region_timezone_47b8bba76ecf48bcb0e12ae773078a1d",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_1261f4363c0a4fabb4ca1ce221049962",
              "region_guid": "region_9c7aab7a2693441c87d77431bdbc4120"
            },
            {
              "timezone_id": "region_timezone_90ceb47c16b142f6b5651ac495e483c8",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_1261f4363c0a4fabb4ca1ce221049962",
              "region_guid": "region_64c6b999d8624a109ff044895df9cae5"
            },
            {
              "timezone_id": "region_timezone_90ceb47c16b142f6b5651ac495e483c8",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_1261f4363c0a4fabb4ca1ce221049962",
              "region_guid": "region_8101316dc1fa416189a61265df33dc5f"
            }
          ]
        },
        {
          "operating_systems": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_bcc4e340e9664ce9b16f8b505b00ea03",
              "name": "Win10-64",
              "sort": 1
            },
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_f2fc14414b814f7d8540156927fc6a68",
              "name": "Win7-64",
              "sort": 2
            }
          ],
          "default_selection": {
            "timezone_id": "region_timezone_e703e6c1137f460cac012d870d657203",
            "model": "payment.virtualdesktop.options.create.country_default_selection",
            "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963"
          },
          "name": "\u65B0\u52A0\u5761",
          "model": "payment.virtualdesktop.options.create.country",
          "id": "region_country_3d7fe27e0cb3481b9119d46d4e06f453",
          "browsers": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_browser",
              "id": "browser_685003f574cf4574a8c3a60ad7eddbb5",
              "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
              "sort": 1
            }
          ],
          "region_default_selection": [
            {
              "timezone_id": "region_timezone_e703e6c1137f460cac012d870d657203",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_9dfe5d486d8046368588bdfdb3f3d4c2",
              "region_guid": "region_af9b164e13ba4356826c40a1b0ceff93"
            },
            {
              "timezone_id": "region_timezone_e703e6c1137f460cac012d870d657203",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_9dfe5d486d8046368588bdfdb3f3d4c2",
              "region_guid": "region_6980dbad83f44c78aedb0198b459d395"
            },
            {
              "timezone_id": "region_timezone_e703e6c1137f460cac012d870d657203",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_9dfe5d486d8046368588bdfdb3f3d4c2",
              "region_guid": "region_2b1be15539c2481face8a22bc63eeb62"
            },
            {
              "timezone_id": "region_timezone_e703e6c1137f460cac012d870d657203",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_9dfe5d486d8046368588bdfdb3f3d4c2",
              "region_guid": "region_b3244a190a0d49eca6bc7155df344f36"
            },
            {
              "timezone_id": "region_timezone_e703e6c1137f460cac012d870d657203",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_9dfe5d486d8046368588bdfdb3f3d4c2",
              "region_guid": "region_8d353d803f324444a78ab30d83d7f453"
            },
            {
              "timezone_id": "region_timezone_e703e6c1137f460cac012d870d657203",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_ba49909c6e234b9f9759babd39e9738c",
              "region_guid": "region_cf705bf2fc764152a304613227d384ea"
            },
            {
              "timezone_id": "region_timezone_e703e6c1137f460cac012d870d657203",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_9dfe5d486d8046368588bdfdb3f3d4c2",
              "region_guid": "region_eb6edfdad4af405f9cc443d64742078f"
            },
            {
              "timezone_id": "region_timezone_e703e6c1137f460cac012d870d657203",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_9dfe5d486d8046368588bdfdb3f3d4c2",
              "region_guid": "region_ffbad688c0594cb8bb30742ca322c7b2"
            }
          ]
        },
        {
          "operating_systems": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_bcc4e340e9664ce9b16f8b505b00ea03",
              "name": "Win10-64",
              "sort": 1
            },
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_f2fc14414b814f7d8540156927fc6a68",
              "name": "Win7-64",
              "sort": 2
            }
          ],
          "default_selection": {
            "timezone_id": "region_timezone_7a473af2a04f499da8edf0cb73412c2f",
            "model": "payment.virtualdesktop.options.create.country_default_selection",
            "language_id": "region_language_895422ac57d645b3b44998b23ad88b63"
          },
          "name": "\u9A6C\u6765\u897F\u4E9A",
          "model": "payment.virtualdesktop.options.create.country",
          "id": "region_country_4a1fc7a1b3e04fd3bf6884289f43805e",
          "browsers": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_browser",
              "id": "browser_685003f574cf4574a8c3a60ad7eddbb5",
              "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
              "sort": 1
            }
          ],
          "region_default_selection": [
            {
              "timezone_id": "region_timezone_7a473af2a04f499da8edf0cb73412c2f",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_895422ac57d645b3b44998b23ad88b63",
              "region_guid": "region_b24dbe9d742447f7b725c26e8025c9a7"
            }
          ]
        },
        {
          "operating_systems": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_bcc4e340e9664ce9b16f8b505b00ea03",
              "name": "Win10-64",
              "sort": 1
            },
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_f2fc14414b814f7d8540156927fc6a68",
              "name": "Win7-64",
              "sort": 2
            }
          ],
          "default_selection": {
            "timezone_id": "region_timezone_a7ac8957b9a84e77a12bd29143749601",
            "model": "payment.virtualdesktop.options.create.country_default_selection",
            "language_id": "region_language_39e7914263a84f529540a38fd51a8108"
          },
          "name": "\u963F\u8054\u914B",
          "model": "payment.virtualdesktop.options.create.country",
          "id": "region_country_22a5ea67928a4b4ab3481847888bfa85",
          "browsers": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_browser",
              "id": "browser_685003f574cf4574a8c3a60ad7eddbb5",
              "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
              "sort": 1
            }
          ],
          "region_default_selection": [
            {
              "timezone_id": "region_timezone_a7ac8957b9a84e77a12bd29143749601",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_39e7914263a84f529540a38fd51a8108",
              "region_guid": "region_4d35a04dbcda4cee89f704ec77daa515"
            },
            {
              "timezone_id": "region_timezone_a7ac8957b9a84e77a12bd29143749601",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_39e7914263a84f529540a38fd51a8108",
              "region_guid": "region_c83d03c4ba41454ba72d8bf8dc05d4b5"
            },
            {
              "timezone_id": "region_timezone_0c5ee26acc9e4935b02eec74616a1e7e",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_39e7914263a84f529540a38fd51a8108",
              "region_guid": "region_e00b75e5b79c4202ac55261eb77b18b7"
            }
          ]
        },
        {
          "operating_systems": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_bcc4e340e9664ce9b16f8b505b00ea03",
              "name": "Win10-64",
              "sort": 1
            },
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_f2fc14414b814f7d8540156927fc6a68",
              "name": "Win7-64",
              "sort": 2
            }
          ],
          "default_selection": {
            "timezone_id": "region_timezone_c7f631ac50c547d18aa94318270cd029",
            "model": "payment.virtualdesktop.options.create.country_default_selection",
            "language_id": "region_language_365c41357e124ead87ae3dbfb90c6a62"
          },
          "name": "\u5370\u5EA6\u5C3C\u897F\u4E9A",
          "model": "payment.virtualdesktop.options.create.country",
          "id": "region_country_e1cfb1f82f4d43a0a58492cfc75e2f52",
          "browsers": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_browser",
              "id": "browser_685003f574cf4574a8c3a60ad7eddbb5",
              "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
              "sort": 1
            }
          ],
          "region_default_selection": [
            {
              "timezone_id": "region_timezone_c7f631ac50c547d18aa94318270cd029",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_365c41357e124ead87ae3dbfb90c6a62",
              "region_guid": "region_28511e4a7d9a4513aed9da3fd6d9c128"
            },
            {
              "timezone_id": "region_timezone_c7f631ac50c547d18aa94318270cd029",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_365c41357e124ead87ae3dbfb90c6a62",
              "region_guid": "region_f6feaba4fd3e4e8fbc70daf89465aa2a"
            }
          ]
        },
        {
          "operating_systems": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_bcc4e340e9664ce9b16f8b505b00ea03",
              "name": "Win10-64",
              "sort": 1
            },
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_f2fc14414b814f7d8540156927fc6a68",
              "name": "Win7-64",
              "sort": 2
            }
          ],
          "default_selection": {
            "timezone_id": "region_timezone_47b8bba76ecf48bcb0e12ae773078a1d",
            "model": "payment.virtualdesktop.options.create.country_default_selection",
            "language_id": "region_language_32176a474bde4f5b8ffc6824e63b4963"
          },
          "name": "\u52A0\u62FF\u5927",
          "model": "payment.virtualdesktop.options.create.country",
          "id": "region_country_d17d5e5f30034b6ab6f918a12e81a989",
          "browsers": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_browser",
              "id": "browser_685003f574cf4574a8c3a60ad7eddbb5",
              "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
              "sort": 1
            }
          ],
          "region_default_selection": [
            {
              "timezone_id": "region_timezone_47b8bba76ecf48bcb0e12ae773078a1d",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_602d7bedd10b416ebef1515d955de14d",
              "region_guid": "region_9b6fad9977374bb9a07510209f536f07"
            },
            {
              "timezone_id": "region_timezone_47b8bba76ecf48bcb0e12ae773078a1d",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_602d7bedd10b416ebef1515d955de14d",
              "region_guid": "region_7b6e8efa3c6e4a87acca965609a0fde3"
            },
            {
              "timezone_id": "region_timezone_47b8bba76ecf48bcb0e12ae773078a1d",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_602d7bedd10b416ebef1515d955de14d",
              "region_guid": "region_6c6184d9a06146258204267ecaa5b693"
            },
            {
              "timezone_id": "region_timezone_47b8bba76ecf48bcb0e12ae773078a1d",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_602d7bedd10b416ebef1515d955de14d",
              "region_guid": "region_e403535cceb6468b81ebfff30e20eb40"
            },
            {
              "timezone_id": "region_timezone_47b8bba76ecf48bcb0e12ae773078a1d",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_602d7bedd10b416ebef1515d955de14d",
              "region_guid": "region_5ac51868a90e4a80b78d12663222bd09"
            }
          ]
        },
        {
          "operating_systems": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_bcc4e340e9664ce9b16f8b505b00ea03",
              "name": "Win10-64",
              "sort": 1
            }
          ],
          "default_selection": {
            "timezone_id": "region_timezone_c083f23050f744f1a98bbc68f9817674",
            "model": "payment.virtualdesktop.options.create.country_default_selection",
            "language_id": "region_language_837daeb3ab7d4934990349e57dfd24c8"
          },
          "name": "\u6CD5\u56FD",
          "model": "payment.virtualdesktop.options.create.country",
          "id": "region_country_e1cfb1f82f4d43a0a58492cfc75e2f52_1",
          "browsers": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_browser",
              "id": "browser_685003f574cf4574a8c3a60ad7eddbb5",
              "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
              "sort": 1
            }
          ],
          "region_default_selection": [
            {
              "timezone_id": "region_timezone_c083f23050f744f1a98bbc68f9817674",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_837daeb3ab7d4934990349e57dfd24c8",
              "region_guid": "region_69899d76829d40ff9467fc899d69b3ab"
            },
            {
              "timezone_id": "region_timezone_c083f23050f744f1a98bbc68f9817674",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_837daeb3ab7d4934990349e57dfd24c8",
              "region_guid": "region_4147c4c435e343fda5c684bd1ce4aeca"
            },
            {
              "timezone_id": "region_timezone_c083f23050f744f1a98bbc68f9817674",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_837daeb3ab7d4934990349e57dfd24c8",
              "region_guid": "region_f9d25a54bb094cb18b86881223f8e480"
            },
            {
              "timezone_id": "region_timezone_c083f23050f744f1a98bbc68f9817674",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_837daeb3ab7d4934990349e57dfd24c8",
              "region_guid": "region_e1abf835fb7d4ee5b3b0bcd95159aec1"
            },
            {
              "timezone_id": "region_timezone_c083f23050f744f1a98bbc68f9817674",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_837daeb3ab7d4934990349e57dfd24c8",
              "region_guid": "region_6387aa6a642c4b7e80f10365145eb76a"
            }
          ]
        },
        {
          "operating_systems": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_bcc4e340e9664ce9b16f8b505b00ea03",
              "name": "Win10-64",
              "sort": 1
            },
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_f2fc14414b814f7d8540156927fc6a68",
              "name": "Win7-64",
              "sort": 2
            }
          ],
          "default_selection": {
            "timezone_id": "region_timezone_e912e52e79224f55aac6a1e7bca25c8a",
            "model": "payment.virtualdesktop.options.create.country_default_selection",
            "language_id": "region_language_cc25f66bca624f6497604194f574e58f"
          },
          "name": "\u5DF4\u897F",
          "model": "payment.virtualdesktop.options.create.country",
          "id": "region_country_2b856df71f96456389c84a48280b7e54",
          "browsers": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_browser",
              "id": "browser_685003f574cf4574a8c3a60ad7eddbb5",
              "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
              "sort": 1
            }
          ],
          "region_default_selection": [
            {
              "timezone_id": "region_timezone_e912e52e79224f55aac6a1e7bca25c8a",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_cc25f66bca624f6497604194f574e58f",
              "region_guid": "region_29e8441c4d4f423397a869db6070df3c"
            },
            {
              "timezone_id": "region_timezone_e912e52e79224f55aac6a1e7bca25c8a",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_cc25f66bca624f6497604194f574e58f",
              "region_guid": "region_34e772435307442ea824789872e067f1"
            },
            {
              "timezone_id": "region_timezone_e912e52e79224f55aac6a1e7bca25c8a",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_cc25f66bca624f6497604194f574e58f",
              "region_guid": "region_bc6fb2d78ec740bbbbed796c2823a90b"
            },
            {
              "timezone_id": "region_timezone_e912e52e79224f55aac6a1e7bca25c8a",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_cc25f66bca624f6497604194f574e58f",
              "region_guid": "region_03fd38af471747b7be8d3cad7a394fc5"
            }
          ]
        },
        {
          "operating_systems": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_bcc4e340e9664ce9b16f8b505b00ea03",
              "name": "Win10-64",
              "sort": 1
            },
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_f2fc14414b814f7d8540156927fc6a68",
              "name": "Win7-64",
              "sort": 2
            }
          ],
          "default_selection": {
            "timezone_id": "region_timezone_02c865e45e3f4760be918bdb2b757669",
            "model": "payment.virtualdesktop.options.create.country_default_selection",
            "language_id": "region_language_bfa74bdf98c34104ba30c9ccf9f8d373"
          },
          "name": "\u97E9\u56FD",
          "model": "payment.virtualdesktop.options.create.country",
          "id": "region_country_4dfaca65565b48a09d3f3deac5b888ba",
          "browsers": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_browser",
              "id": "browser_685003f574cf4574a8c3a60ad7eddbb5",
              "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
              "sort": 1
            }
          ],
          "region_default_selection": [
            {
              "timezone_id": "region_timezone_02c865e45e3f4760be918bdb2b757669",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_bfa74bdf98c34104ba30c9ccf9f8d373",
              "region_guid": "region_1e95685da2d04bebbb1fb1855a13d4c3"
            },
            {
              "timezone_id": "region_timezone_02c865e45e3f4760be918bdb2b757669",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_bfa74bdf98c34104ba30c9ccf9f8d373",
              "region_guid": "region_930d93c42a404ba19c2fdbf3f74d4913"
            },
            {
              "timezone_id": "region_timezone_02c865e45e3f4760be918bdb2b757669",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_bfa74bdf98c34104ba30c9ccf9f8d373",
              "region_guid": "region_a275e918d14f4c39a4333864fa1c517d"
            },
            {
              "timezone_id": "region_timezone_02c865e45e3f4760be918bdb2b757669",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_bfa74bdf98c34104ba30c9ccf9f8d373",
              "region_guid": "region_4c5b02c760b04517aa22087228342838"
            }
          ]
        },
        {
          "operating_systems": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_bcc4e340e9664ce9b16f8b505b00ea03",
              "name": "Win10-64",
              "sort": 1
            },
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_f2fc14414b814f7d8540156927fc6a68",
              "name": "Win7-64",
              "sort": 2
            }
          ],
          "default_selection": {
            "timezone_id": "region_timezone_08a79ae713144d1cbe0b7c482d9b147b",
            "model": "payment.virtualdesktop.options.create.country_default_selection",
            "language_id": "region_language_b04cfa8a351a4d0f99c1d79049ec652c"
          },
          "name": "\u745E\u5178",
          "model": "payment.virtualdesktop.options.create.country",
          "id": "region_country_fb87dfe48d6f49f1a30301cace7cd69f",
          "browsers": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_browser",
              "id": "browser_685003f574cf4574a8c3a60ad7eddbb5",
              "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
              "sort": 1
            }
          ],
          "region_default_selection": [
            {
              "timezone_id": "region_timezone_08a79ae713144d1cbe0b7c482d9b147b",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_b04cfa8a351a4d0f99c1d79049ec652c",
              "region_guid": "region_1fee577062fb48f09a7b9da40e987ee3"
            }
          ]
        },
        {
          "operating_systems": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_bcc4e340e9664ce9b16f8b505b00ea03",
              "name": "Win10-64",
              "sort": 1
            },
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_f2fc14414b814f7d8540156927fc6a68",
              "name": "Win7-64",
              "sort": 2
            }
          ],
          "default_selection": {
            "timezone_id": "region_timezone_49a0d6d6b4b74365a21efed45e3a5b99",
            "model": "payment.virtualdesktop.options.create.country_default_selection",
            "language_id": "region_language_7e1d803ee8254eb79fd89ad6c51217fb"
          },
          "name": "\u7231\u5C14\u5170",
          "model": "payment.virtualdesktop.options.create.country",
          "id": "region_country_be08d4f7ac0740b988d383909086b699",
          "browsers": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_browser",
              "id": "browser_685003f574cf4574a8c3a60ad7eddbb5",
              "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
              "sort": 1
            }
          ],
          "region_default_selection": [
            {
              "timezone_id": "region_timezone_49a0d6d6b4b74365a21efed45e3a5b99",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_7e1d803ee8254eb79fd89ad6c51217fb",
              "region_guid": "region_df50adabcb49416990503ad1a5acc595"
            }
          ]
        },
        {
          "operating_systems": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_bcc4e340e9664ce9b16f8b505b00ea03",
              "name": "Win10-64",
              "sort": 1
            },
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_f2fc14414b814f7d8540156927fc6a68",
              "name": "Win7-64",
              "sort": 2
            }
          ],
          "default_selection": {
            "timezone_id": "region_timezone_5e62ec18a2504606b8c2faf2e88e422a",
            "model": "payment.virtualdesktop.options.create.country_default_selection",
            "language_id": "region_language_36b54e83cdde4e36a0d97230f516b92d"
          },
          "name": "\u745E\u58EB",
          "model": "payment.virtualdesktop.options.create.country",
          "id": "region_country_60002b491114429c91f68c1585090df3",
          "browsers": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_browser",
              "id": "browser_685003f574cf4574a8c3a60ad7eddbb5",
              "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
              "sort": 1
            }
          ],
          "region_default_selection": [
            {
              "timezone_id": "region_timezone_5e62ec18a2504606b8c2faf2e88e422a",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_36b54e83cdde4e36a0d97230f516b92d",
              "region_guid": "region_08857f50d34e4203934c003622e62a8e"
            }
          ]
        },
        {
          "operating_systems": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_bcc4e340e9664ce9b16f8b505b00ea03",
              "name": "Win10-64",
              "sort": 1
            },
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_f2fc14414b814f7d8540156927fc6a68",
              "name": "Win7-64",
              "sort": 2
            }
          ],
          "default_selection": {
            "timezone_id": "region_timezone_70b2d2d77e9e4968b56ff576c64a4f32",
            "model": "payment.virtualdesktop.options.create.country_default_selection",
            "language_id": "region_language_ae4c8683e2a8476f9b4d95f3f62d613a"
          },
          "name": "\u632A\u5A01",
          "model": "payment.virtualdesktop.options.create.country",
          "id": "region_country_6cad9249be9b477da32433e4c102719b",
          "browsers": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_browser",
              "id": "browser_685003f574cf4574a8c3a60ad7eddbb5",
              "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
              "sort": 1
            }
          ],
          "region_default_selection": [
            {
              "timezone_id": "region_timezone_70b2d2d77e9e4968b56ff576c64a4f32",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_ae4c8683e2a8476f9b4d95f3f62d613a",
              "region_guid": "region_a26bc8937506453aacd7c0ab3677fabe"
            }
          ]
        },
        {
          "operating_systems": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_bcc4e340e9664ce9b16f8b505b00ea03",
              "name": "Win10-64",
              "sort": 1
            },
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_f2fc14414b814f7d8540156927fc6a68",
              "name": "Win7-64",
              "sort": 2
            }
          ],
          "default_selection": {
            "timezone_id": "region_timezone_d136a079d03543069b8e64f8d32d5606",
            "model": "payment.virtualdesktop.options.create.country_default_selection",
            "language_id": "region_language_bfe5ef59a4c64a5a8882fdf016596886"
          },
          "name": "\u4FC4\u7F57\u65AF",
          "model": "payment.virtualdesktop.options.create.country",
          "id": "region_country_0a4a4432854843a298fedda4e5500116",
          "browsers": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_browser",
              "id": "browser_685003f574cf4574a8c3a60ad7eddbb5",
              "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
              "sort": 1
            }
          ],
          "region_default_selection": [
            {
              "timezone_id": "region_timezone_d136a079d03543069b8e64f8d32d5606",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_bfe5ef59a4c64a5a8882fdf016596886",
              "region_guid": "region_19a53ca4742842a1ab573c60b52a64bf"
            }
          ]
        },
        {
          "operating_systems": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_bcc4e340e9664ce9b16f8b505b00ea03",
              "name": "Win10-64",
              "sort": 1
            },
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_f2fc14414b814f7d8540156927fc6a68",
              "name": "Win7-64",
              "sort": 2
            }
          ],
          "default_selection": {
            "timezone_id": "region_timezone_0f3421fb2ccd4b4c8e000b2efc8061e5",
            "model": "payment.virtualdesktop.options.create.country_default_selection",
            "language_id": "region_language_d72752efdfd74bccb701de695f032de7"
          },
          "name": "\u6CF0\u56FD",
          "model": "payment.virtualdesktop.options.create.country",
          "id": "region_country_3bf6d4cc9d814d3e88b7ebe50ade6eb7",
          "browsers": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_browser",
              "id": "browser_685003f574cf4574a8c3a60ad7eddbb5",
              "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
              "sort": 1
            }
          ],
          "region_default_selection": [
            {
              "timezone_id": "region_timezone_0f3421fb2ccd4b4c8e000b2efc8061e5",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_d72752efdfd74bccb701de695f032de7",
              "region_guid": "region_6eec921d70be41d583d46b579fc27997"
            }
          ]
        },
        {
          "operating_systems": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_bcc4e340e9664ce9b16f8b505b00ea03",
              "name": "Win10-64",
              "sort": 1
            },
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_f2fc14414b814f7d8540156927fc6a68",
              "name": "Win7-64",
              "sort": 2
            }
          ],
          "default_selection": {
            "timezone_id": "region_timezone_40a9c9528ba340148c700570c4de1570",
            "model": "payment.virtualdesktop.options.create.country_default_selection",
            "language_id": "region_language_2db5c29606724bce9cf4db852f4b298b"
          },
          "name": "\u82AC\u5170",
          "model": "payment.virtualdesktop.options.create.country",
          "id": "region_country_d9ebb3edfab9452f817974396160daf2",
          "browsers": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_browser",
              "id": "browser_685003f574cf4574a8c3a60ad7eddbb5",
              "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
              "sort": 1
            }
          ],
          "region_default_selection": [
            {
              "timezone_id": "region_timezone_40a9c9528ba340148c700570c4de1570",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_2db5c29606724bce9cf4db852f4b298b",
              "region_guid": "region_f7468fed8c3a4c37af7daf38a1b09a1b"
            },
            {
              "timezone_id": "region_timezone_40a9c9528ba340148c700570c4de1570",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_2db5c29606724bce9cf4db852f4b298b",
              "region_guid": "region_f3d1d71da3cd4853b7c6962c16386a26"
            },
            {
              "timezone_id": "region_timezone_40a9c9528ba340148c700570c4de1570",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_2db5c29606724bce9cf4db852f4b298b",
              "region_guid": "region_1df5b83dda0546faaebece14add617ba"
            }
          ]
        },
        {
          "operating_systems": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_bcc4e340e9664ce9b16f8b505b00ea03",
              "name": "Win10-64",
              "sort": 1
            },
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_f2fc14414b814f7d8540156927fc6a68",
              "name": "Win7-64",
              "sort": 2
            }
          ],
          "default_selection": {
            "timezone_id": "region_timezone_11fd6ce44fc74516910a1254d9d78963",
            "model": "payment.virtualdesktop.options.create.country_default_selection",
            "language_id": "region_language_7d899bcff2824d86a559626f08c3774e"
          },
          "name": "\u897F\u73ED\u7259",
          "model": "payment.virtualdesktop.options.create.country",
          "id": "region_country_1693842519a24d709f06754fdb65365c",
          "browsers": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_browser",
              "id": "browser_685003f574cf4574a8c3a60ad7eddbb5",
              "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
              "sort": 1
            }
          ],
          "region_default_selection": [
            {
              "timezone_id": "region_timezone_11fd6ce44fc74516910a1254d9d78963",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_f76c05efe97444f4833ae0d1f2481f45",
              "region_guid": "region_4784a6f2990d483bb97dfbd0d073a27a"
            }
          ]
        },
        {
          "operating_systems": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_bcc4e340e9664ce9b16f8b505b00ea03",
              "name": "Win10-64",
              "sort": 1
            },
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_f2fc14414b814f7d8540156927fc6a68",
              "name": "Win7-64",
              "sort": 2
            }
          ],
          "default_selection": {
            "timezone_id": "region_timezone_b5b46f98b0464135b4787eb90362d0be",
            "model": "payment.virtualdesktop.options.create.country_default_selection",
            "language_id": "region_language_2cd49cc5c502412aa0c0721f92a7e9b9"
          },
          "name": "\u58A8\u897F\u54E5",
          "model": "payment.virtualdesktop.options.create.country",
          "id": "region_country_459927a388154ed3966bad3cfd643ede",
          "browsers": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_browser",
              "id": "browser_685003f574cf4574a8c3a60ad7eddbb5",
              "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
              "sort": 1
            }
          ],
          "region_default_selection": [
            {
              "timezone_id": "region_timezone_b5b46f98b0464135b4787eb90362d0be",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_2cd49cc5c502412aa0c0721f92a7e9b9",
              "region_guid": "region_55cf603fb5334b2482757b45e48e7338"
            }
          ]
        },
        {
          "operating_systems": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_bcc4e340e9664ce9b16f8b505b00ea03",
              "name": "Win10-64",
              "sort": 1
            },
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_f2fc14414b814f7d8540156927fc6a68",
              "name": "Win7-64",
              "sort": 2
            }
          ],
          "default_selection": {
            "timezone_id": "region_timezone_ae7a33ab1517499089938533ef57cfbc",
            "model": "payment.virtualdesktop.options.create.country_default_selection",
            "language_id": "region_language_0273490b067845d3a1191432a65ce579"
          },
          "name": "\u6CE2\u5170",
          "model": "payment.virtualdesktop.options.create.country",
          "id": "region_country_9a5708cb4acb47c8b10b888da58d2274",
          "browsers": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_browser",
              "id": "browser_685003f574cf4574a8c3a60ad7eddbb5",
              "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
              "sort": 1
            }
          ],
          "region_default_selection": [
            {
              "timezone_id": "region_timezone_ae7a33ab1517499089938533ef57cfbc",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_0273490b067845d3a1191432a65ce579",
              "region_guid": "region_6896e3798b29432ea046183ac2d72317"
            }
          ]
        },
        {
          "operating_systems": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_bcc4e340e9664ce9b16f8b505b00ea03",
              "name": "Win10-64",
              "sort": 1
            },
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_f2fc14414b814f7d8540156927fc6a68",
              "name": "Win7-64",
              "sort": 2
            }
          ],
          "default_selection": {
            "timezone_id": "region_timezone_42077787f5a140fbae08114b039898b8",
            "model": "payment.virtualdesktop.options.create.country_default_selection",
            "language_id": "region_language_5a7c571e99894fb9ac5795fcb44d2ee1"
          },
          "name": "\u65B0\u897F\u5170",
          "model": "payment.virtualdesktop.options.create.country",
          "id": "region_country_2d2cef33b8af4317bc6f7e4013106720",
          "browsers": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_browser",
              "id": "browser_685003f574cf4574a8c3a60ad7eddbb5",
              "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
              "sort": 1
            }
          ],
          "region_default_selection": []
        },
        {
          "operating_systems": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_bcc4e340e9664ce9b16f8b505b00ea03",
              "name": "Win10-64",
              "sort": 1
            },
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_f2fc14414b814f7d8540156927fc6a68",
              "name": "Win7-64",
              "sort": 2
            }
          ],
          "default_selection": {
            "timezone_id": "region_timezone_faf55c945b2f4c0e97aa13d9408e72c3",
            "model": "payment.virtualdesktop.options.create.country_default_selection",
            "language_id": "region_language_c3bcd968344649ac8dc09a5938f279c5"
          },
          "name": "\u54E5\u4F26\u6BD4\u4E9A",
          "model": "payment.virtualdesktop.options.create.country",
          "id": "region_country_ef952ba9d5744759be0514689024aa40",
          "browsers": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_browser",
              "id": "browser_685003f574cf4574a8c3a60ad7eddbb5",
              "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
              "sort": 1
            }
          ],
          "region_default_selection": []
        },
        {
          "operating_systems": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_bcc4e340e9664ce9b16f8b505b00ea03",
              "name": "Win10-64",
              "sort": 1
            },
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_f2fc14414b814f7d8540156927fc6a68",
              "name": "Win7-64",
              "sort": 2
            }
          ],
          "default_selection": {
            "timezone_id": "region_timezone_c2e0233c241a477bb2d50e1add0e204e",
            "model": "payment.virtualdesktop.options.create.country_default_selection",
            "language_id": "region_language_3604226b397c47a38f0973b7e3bf42d0"
          },
          "name": "\u8D8A\u5357",
          "model": "payment.virtualdesktop.options.create.country",
          "id": "region_country_80a92523b0f44780832833f3b631e14a",
          "browsers": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_browser",
              "id": "browser_685003f574cf4574a8c3a60ad7eddbb5",
              "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
              "sort": 1
            }
          ],
          "region_default_selection": [
            {
              "timezone_id": "region_timezone_c2e0233c241a477bb2d50e1add0e204e",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_3604226b397c47a38f0973b7e3bf42d0",
              "region_guid": "region_150fc5ac14514f3580d2518f6fe3fbf3"
            }
          ]
        },
        {
          "operating_systems": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_bcc4e340e9664ce9b16f8b505b00ea03",
              "name": "Win10-64",
              "sort": 1
            },
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_f2fc14414b814f7d8540156927fc6a68",
              "name": "Win7-64",
              "sort": 2
            }
          ],
          "default_selection": {
            "timezone_id": "region_timezone_cc0a386307f04adaa6151ced926504c5",
            "model": "payment.virtualdesktop.options.create.country_default_selection",
            "language_id": "region_language_0af3f2c6898c48f7b303b50a73c9a4b9"
          },
          "name": "\u610F\u5927\u5229",
          "model": "payment.virtualdesktop.options.create.country",
          "id": "region_country_da9dcc373e2f48839f6a81020c908878",
          "browsers": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_browser",
              "id": "browser_685003f574cf4574a8c3a60ad7eddbb5",
              "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
              "sort": 1
            }
          ],
          "region_default_selection": [
            {
              "timezone_id": "region_timezone_cc0a386307f04adaa6151ced926504c5",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_4357a256541e43658c9cb73c2c8a98e9",
              "region_guid": "region_463b487916b6470f9359777ed026468d"
            },
            {
              "timezone_id": "region_timezone_2688b867b93044449d8768748d3ebf6b",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_9dfe5d486d8046368588bdfdb3f3d4c2",
              "region_guid": "region_0eeed8f5bbb34412886acd8fe3ff03fc"
            }
          ]
        },
        {
          "operating_systems": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_bcc4e340e9664ce9b16f8b505b00ea03",
              "name": "Win10-64",
              "sort": 1
            },
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_f2fc14414b814f7d8540156927fc6a68",
              "name": "Win7-64",
              "sort": 2
            }
          ],
          "default_selection": {
            "timezone_id": "region_timezone_12d6b077545543bf9b42182fd9481d39",
            "model": "payment.virtualdesktop.options.create.country_default_selection",
            "language_id": "region_language_624bfb637a04426b8cf6cf394f03090c"
          },
          "name": "\u6BD4\u5229\u65F6",
          "model": "payment.virtualdesktop.options.create.country",
          "id": "region_country_3fe29984c2e449b2b05c9350c3efa8a3",
          "browsers": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_browser",
              "id": "browser_685003f574cf4574a8c3a60ad7eddbb5",
              "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
              "sort": 1
            }
          ],
          "region_default_selection": [
            {
              "timezone_id": "region_timezone_12d6b077545543bf9b42182fd9481d39",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_1447d2b0a5f7445b95dfd9ef696198ff",
              "region_guid": "region_5cc5f2b69c5241cb86a86b85086addd7"
            }
          ]
        },
        {
          "operating_systems": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_bcc4e340e9664ce9b16f8b505b00ea03",
              "name": "Win10-64",
              "sort": 1
            },
            {
              "model": "payment.virtualdesktop.options.create.country_support_os",
              "id": "os_f2fc14414b814f7d8540156927fc6a68",
              "name": "Win7-64",
              "sort": 2
            }
          ],
          "default_selection": {
            "timezone_id": "region_timezone_eb7930b6628f45938b12cfa82d0d758f",
            "model": "payment.virtualdesktop.options.create.country_default_selection",
            "language_id": "region_language_1a4f2ebe8cb54a48aef9f1cb63d867b1"
          },
          "name": "\u571F\u8033\u5176",
          "model": "payment.virtualdesktop.options.create.country",
          "id": "region_country_e4c55796367f4d3ea072e32340ebfb7c",
          "browsers": [
            {
              "model": "payment.virtualdesktop.options.create.country_support_browser",
              "id": "browser_685003f574cf4574a8c3a60ad7eddbb5",
              "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
              "sort": 1
            }
          ],
          "region_default_selection": [
            {
              "timezone_id": "region_timezone_eb7930b6628f45938b12cfa82d0d758f",
              "model": "payment.virtualdesktop.options.create.country_region_default_selection",
              "language_id": "region_language_1a4f2ebe8cb54a48aef9f1cb63d867b1",
              "region_guid": "region_2b6c85523fa44531a7c9e04fb6123183"
            }
          ]
        }
      ],
      "resolution": [
        {
          "name": "1600x900",
          "model": "payment.virtualdesktop.options.create.resolution",
          "id": "resolution_0de6b2917cba481fa980a0f0db833462"
        },
        {
          "name": "1440x900",
          "model": "payment.virtualdesktop.options.create.resolution",
          "id": "resolution_37cf6c7676874f5886fdf07c6ac80e3e"
        },
        {
          "name": "1680x1050",
          "model": "payment.virtualdesktop.options.create.resolution",
          "id": "resolution_6159c20ecb7b4af4b496c90619a780bb"
        },
        {
          "name": "1920x1080",
          "model": "payment.virtualdesktop.options.create.resolution",
          "id": "resolution_a3ce431fb850419ea056b17730c9c35a"
        },
        {
          "name": "1366x768",
          "model": "payment.virtualdesktop.options.create.resolution",
          "id": "resolution_eb1ec0e45b034c1bb4262351c7d58098"
        }
      ],
      "version": "d2fa02afb59af75901438304e0ff86a5"
    };
    return [200, response];
  });
  mock.onOptions("/api/v7/checkVersion").reply((config) => {
    let response = {
      model: "payment.virtualdesktop.version",
      result: false
    };
    return [304, response];
  });
};
